/* eslint-disable max-len */
export const AccountCircle: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <path d="M11.1 35.25q3.15-2 6.225-3.025Q20.4 31.2 24 31.2q3.6 0 6.7 1.025t6.25 3.025q2.2-2.7 3.125-5.45Q41 27.05 41 24q0-7.25-4.875-12.125T24 7q-7.25 0-12.125 4.875T7 24q0 3.05.95 5.8t3.15 5.45ZM24 25.5q-2.9 0-4.875-1.975T17.15 18.65q0-2.9 1.975-4.875T24 11.8q2.9 0 4.875 1.975t1.975 4.875q0 2.9-1.975 4.875T24 25.5ZM24 44q-4.2 0-7.85-1.575-3.65-1.575-6.35-4.3Q7.1 35.4 5.55 31.75 4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Z" />
    </svg>
  );
};

export const Logout = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
      <path d="M9 42q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h14.55v3H9v30h14.55v3Zm24.3-9.25-2.15-2.15 5.1-5.1h-17.5v-3h17.4l-5.1-5.1 2.15-2.15 8.8 8.8Z" />
    </svg>
  );
};

export const SortIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3333 2.66666V10.6667H15.3333L12.6667 14L10 10.6667H12V2.66666H13.3333ZM8 12V13.3333H2V12H8ZM9.33333 7.33332V8.66666H2V7.33332H9.33333ZM9.33333 2.66666V3.99999H2V2.66666H9.33333Z"
      fill="black"
    />
  </svg>
);

export const SearchBig = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.1895 67.9999L91.9994 91.9999" stroke="#AF2C89" strokeWidth="8" strokeLinecap="round" />
      <path
        d="M77.588 40.8C77.588 61.1246 61.1142 77.6 40.794 77.6C20.4738 77.6 4 61.1246 4 40.8C4 20.4754 20.4738 4 40.794 4C61.1142 4 77.588 20.4754 77.588 40.8Z"
        stroke="#AF2C89"
        strokeWidth="8"
      />
    </svg>
  );
};

// export const WaterDrop = () => {
//   return <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path fillRule="evenodd" clipRule="evenodd" d="M7.50003 0C7.5235 0 7.78173 0.321081 8.07907 0.716558C8.37642 1.10812 8.90069 1.81685 9.24107 2.29064C9.58145 2.76443 10.1292 3.54755 10.4578 4.03309C10.7826 4.51862 11.1973 5.14121 11.3734 5.42313C11.5533 5.70506 11.8468 6.17885 12.0307 6.48035C12.2145 6.78185 12.5236 7.31829 12.7232 7.67461C12.9227 8.03093 13.1887 8.53213 13.3178 8.79056C13.447 9.04899 13.67 9.52278 13.8108 9.84778C13.9517 10.1689 14.1316 10.6192 14.2099 10.8463C14.292 11.0734 14.4094 11.461 14.472 11.7077C14.5698 12.0836 14.5933 12.2598 14.609 12.7845C14.6246 13.2622 14.6129 13.5128 14.562 13.8417C14.5268 14.0806 14.4564 14.4408 14.4055 14.6444C14.3507 14.848 14.2568 15.1613 14.1903 15.3375C14.1277 15.5176 13.9947 15.823 13.8969 16.0149C13.7991 16.2067 13.6465 16.4848 13.5604 16.6296C13.4704 16.7784 13.3178 17.0016 13.22 17.1308C13.1222 17.26 12.9344 17.4872 12.8014 17.6359C12.6723 17.7847 12.4062 18.0471 12.2145 18.2155C12.0228 18.3877 11.6785 18.6501 11.4516 18.8028C11.2247 18.9516 10.8491 19.1709 10.6104 19.2844C10.3718 19.398 9.99617 19.5546 9.76925 19.629C9.54233 19.7073 9.18238 19.8052 8.9672 19.8483C8.75201 19.8953 8.33729 19.9501 8.04777 19.9736C7.64479 20.0088 7.39048 20.0088 6.97185 19.9736C6.67059 19.9501 6.24804 19.8953 6.03286 19.8483C5.81767 19.8052 5.45773 19.7073 5.2308 19.629C5.00388 19.5546 4.62829 19.398 4.38963 19.2844C4.15097 19.1709 3.77537 18.9516 3.54845 18.8028C3.32153 18.6501 2.97723 18.3877 2.78552 18.2155C2.5899 18.0471 2.32776 17.7847 2.19865 17.6359C2.06563 17.4872 1.87783 17.26 1.78002 17.1308C1.68221 17.0016 1.52962 16.7784 1.43964 16.6296C1.35356 16.4848 1.20098 16.2067 1.10317 16.0149C1.00535 15.823 0.872331 15.5176 0.809732 15.3375C0.74322 15.1613 0.649321 14.848 0.594547 14.6444C0.543685 14.4408 0.473261 14.0806 0.438049 13.8417C0.387187 13.5167 0.375449 13.2583 0.391099 12.7845C0.406749 12.2324 0.426311 12.0953 0.547597 11.6294C0.621934 11.3396 0.762782 10.8893 0.860594 10.6309C0.958405 10.3725 1.1149 9.98483 1.21271 9.76947C1.30661 9.55411 1.53354 9.08815 1.7096 8.73183C1.88566 8.37551 2.15562 7.86648 2.3082 7.5963C2.45688 7.32612 2.75422 6.82492 2.96158 6.48035C3.16894 6.13577 3.48585 5.62674 3.66582 5.34482C3.84188 5.06289 4.2253 4.48338 4.51874 4.05267C4.80826 3.62195 5.34818 2.85449 5.71595 2.34546C6.08372 1.83643 6.62755 1.10029 6.9249 0.708727C7.21833 0.321081 7.48047 0 7.50003 0ZM2.94234 12.3101C3.06157 12.3178 3.1808 12.3525 3.26157 12.4065C3.32695 12.4528 3.41157 12.5492 3.44619 12.6148C3.4808 12.6881 3.52311 12.9118 3.53849 13.1471C3.55772 13.3708 3.60772 13.6986 3.65388 13.8799C3.69619 14.0612 3.82695 14.3968 3.94234 14.632C4.07311 14.902 4.24234 15.1759 4.41157 15.3841C4.55772 15.5654 4.82311 15.8316 5.00388 15.9743C5.18849 16.1247 5.49234 16.3175 5.71157 16.4255C5.9308 16.5374 6.26157 16.6608 6.4808 16.7148C6.69234 16.7688 7.0308 16.8228 7.2308 16.8344C7.50388 16.8498 7.63465 16.8768 7.75003 16.9385C7.83849 16.9887 7.93849 17.0889 7.98849 17.1777C8.03465 17.2625 8.07695 17.3937 8.07695 17.4669C8.07695 17.5402 8.03465 17.6714 7.98849 17.7562C7.93849 17.8411 7.8308 17.9491 7.75003 17.9992C7.60772 18.0841 7.56542 18.0879 7.19234 18.0648C6.96926 18.0532 6.62311 18.0108 6.42311 17.9683C6.22311 17.9298 5.92696 17.8488 5.76926 17.7909C5.61157 17.7369 5.30772 17.6019 5.09619 17.4939C4.88465 17.3821 4.5808 17.1969 4.42311 17.0812C4.26542 16.9617 4.0308 16.7688 3.90388 16.6492C3.77695 16.5335 3.56157 16.2944 3.42311 16.1208C3.28465 15.9473 3.0808 15.6426 2.96926 15.4497C2.85772 15.253 2.71542 14.956 2.65003 14.7863C2.58849 14.6166 2.50772 14.3736 2.47695 14.2463C2.44234 14.119 2.39234 13.8761 2.36157 13.7063C2.3308 13.5366 2.30772 13.2551 2.30772 13.0777C2.30772 12.9041 2.32311 12.7228 2.34234 12.6727C2.36157 12.6264 2.41926 12.5377 2.47695 12.476C2.5308 12.4142 2.61542 12.3525 2.66157 12.3333C2.71157 12.314 2.83849 12.3024 2.94234 12.3101Z" fill="#1DA1F2" />
//   </svg>;
// }

// export const Lightning = () => {
//   return <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M9.65987 0.0169002C9.65987 0.00499902 9.64785 -0.00293511 9.63182 0.00103195H9.62781C9.61178 0.00103195 7.60795 2.71054 5.17129 6.01907C2.73463 9.3276 0.738814 12.0569 0.730798 12.0847C0.722783 12.1284 1.27584 12.1363 3.66842 12.1363C6.45775 12.1363 6.61405 12.1403 6.59 12.2077C6.57798 12.2434 5.92874 14.0048 5.14724 16.1232C4.36575 18.2416 3.73655 19.9792 3.74857 19.9911C3.76059 20.003 3.77262 20.003 3.78063 19.9911C3.78865 19.9792 5.78446 17.2657 8.22112 13.9611C10.6538 10.6605 12.6496 7.9312 12.6536 7.90343C12.6656 7.85979 12.1126 7.85185 9.71999 7.85185C6.93066 7.85185 6.77436 7.84789 6.7984 7.78441C6.81042 7.74474 7.45967 5.98733 8.24116 3.87685C9.02266 1.76241 9.65987 0.0288014 9.65987 0.0169002Z" fill="#F5B800" />
//   </svg>;
// }

// export const GarbageBag = () => {
//   return <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M8.11719 5.22766H0.949219L0.792969 5.29531C0.707031 5.33049 0.605469 5.40084 0.570313 5.44955C0.511719 5.52802 0.503906 5.64437 0.5 6.43992C0.5 7.26793 0.503906 7.3464 0.574219 7.44111C0.617188 7.49793 0.710938 7.56558 0.796875 7.60076L0.949219 7.66029L8.11719 7.66299V5.22766Z" fill="#F74E31" />
//     <path d="M8.09766 5.22766H15.2656L15.4219 5.29531C15.5078 5.33049 15.6094 5.40084 15.6445 5.44955C15.7031 5.52802 15.7109 5.64437 15.7148 6.43992C15.7148 7.26793 15.7109 7.3464 15.6406 7.44111C15.5977 7.49793 15.5039 7.56558 15.418 7.60076L15.2656 7.66029L8.09766 7.66299V5.22766Z" fill="#F74E31" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M8.09769 0V2.34375H9.33987L9.34468 2.34377H9.34469C10.547 2.34766 10.5823 2.34777 10.7305 2.43359C10.8164 2.48438 10.9102 2.58203 10.9532 2.66797C11.0196 2.79688 11.0274 2.91016 11.0274 4.6875H14.4258L13.8867 2.54688C13.5899 1.37109 13.3164 0.351562 13.2813 0.28125C13.2461 0.214844 13.1485 0.121094 13.0664 0.078125C12.9258 0.0078125 12.8242 0.00390625 8.09769 0ZM14.4922 8.20312H8.09769V9.31641L8.20315 9.34375C8.26565 9.35938 8.36722 9.40625 8.42972 9.44531C8.51175 9.5 8.70315 9.78906 9.08206 10.4531C9.55081 11.2695 9.62112 11.4102 9.62112 11.5625C9.62112 11.6719 9.58987 11.7852 9.543 11.8633C9.50003 11.9336 9.40628 12.0273 9.33987 12.0703C9.26956 12.1133 9.14456 12.1484 9.06644 12.1484C8.9844 12.1484 8.87112 12.125 8.81253 12.0938C8.75003 12.0625 8.66409 11.9961 8.62112 11.9453C8.57425 11.8984 8.46097 11.7227 8.37112 11.5625C8.27737 11.4023 8.13474 11.1663 8.10349 11.1234C8.07974 11.0867 8.08047 11.3011 8.08588 12.8831C8.09025 14.1631 8.09769 16.3383 8.09769 20H10.5C12.8242 20 12.9063 19.9961 13.0586 19.9219C13.168 19.8672 13.2383 19.7969 13.293 19.6758C13.3594 19.5352 13.4532 18.668 13.918 13.9453C14.2188 10.8828 14.4688 8.33984 14.4766 8.28906L14.4922 8.20312ZM10.1992 12.9687C10.2774 12.9687 10.3907 12.9922 10.4492 13.0234C10.5117 13.0547 10.5977 13.1211 10.6407 13.1718C10.6875 13.2187 10.9453 13.6484 11.2188 14.1211C11.4883 14.5937 11.7227 15.0429 11.7383 15.1172C11.7539 15.2148 11.7383 15.3047 11.6797 15.4297C11.6211 15.5508 11.5508 15.6328 11.4414 15.6953C11.2852 15.7812 11.2578 15.7812 10.1719 15.7695C9.10941 15.7617 9.05472 15.7578 8.94925 15.6797C8.89066 15.6328 8.80472 15.5468 8.76175 15.4922C8.70706 15.4179 8.68362 15.3242 8.68362 15.1953C8.68362 15.0664 8.70706 14.9726 8.76175 14.8984C8.80472 14.8437 8.89066 14.7578 8.94925 14.7109C9.04691 14.6406 9.12894 14.625 10.1367 14.5898L9.89066 14.1601C9.68362 13.8047 9.64066 13.6992 9.64066 13.5547C9.64066 13.4492 9.67191 13.3281 9.71878 13.25C9.76175 13.1836 9.8555 13.0898 9.92191 13.0468C9.99222 13.0039 10.1172 12.9687 10.1953 12.9687H10.1992Z" fill="#F74E31" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M8.11719 0V2.34375H6.875L6.87019 2.34377H6.87019C5.66787 2.34766 5.63261 2.34777 5.48438 2.43359C5.39844 2.48438 5.30469 2.58203 5.26172 2.66797C5.19531 2.79688 5.1875 2.91016 5.1875 4.6875H1.78906L2.32812 2.54688C2.625 1.37109 2.89844 0.351562 2.93359 0.28125C2.96875 0.214844 3.06641 0.121094 3.14844 0.078125C3.28906 0.0078125 3.39062 0.00390625 8.11719 0ZM1.72266 8.20312H8.11719V9.31641L8.01172 9.34375C7.94922 9.35938 7.84766 9.40625 7.78516 9.44531C7.70312 9.5 7.51172 9.78906 7.13281 10.4531C6.66406 11.2695 6.59375 11.4102 6.59375 11.5625C6.59375 11.6719 6.625 11.7852 6.67188 11.8633C6.71484 11.9336 6.80859 12.0273 6.875 12.0703C6.94531 12.1133 7.07031 12.1484 7.14844 12.1484C7.23047 12.1484 7.34375 12.125 7.40234 12.0938C7.46484 12.0625 7.55078 11.9961 7.59375 11.9453C7.64062 11.8984 7.75391 11.7227 7.84375 11.5625C7.88543 11.4913 7.9334 11.405 7.97659 11.3273C8.03054 11.2303 8.07702 11.1467 8.09437 11.1228C8.12399 11.077 8.12362 11.4219 8.12053 14.3205C8.11913 15.6279 8.11719 17.4549 8.11719 20H5.71484C3.39062 20 3.30859 19.9961 3.15625 19.9219C3.04688 19.8672 2.97656 19.7969 2.92188 19.6758C2.85547 19.5352 2.76172 18.668 2.29688 13.9453C1.99609 10.8828 1.74609 8.33984 1.73828 8.28906L1.72266 8.20312ZM6.02729 12.9687C6.11323 12.9687 6.23823 13.0039 6.31245 13.0468C6.37886 13.0898 6.47261 13.1836 6.51558 13.2539C6.56245 13.3281 6.5937 13.4492 6.5937 13.5547C6.5937 13.6992 6.55073 13.8047 6.0937 14.5898L6.63276 14.6093C7.10542 14.625 7.18745 14.6406 7.28511 14.7109C7.3437 14.7578 7.42964 14.8437 7.47261 14.8984C7.52729 14.9726 7.55073 15.0664 7.55073 15.1953C7.55073 15.3281 7.52729 15.4179 7.4687 15.4961C7.42183 15.5547 7.33589 15.6406 7.2812 15.6836C7.17964 15.7578 7.10542 15.7617 6.06245 15.7734C4.97651 15.7812 4.94917 15.7812 4.79292 15.6953C4.68354 15.6328 4.61323 15.5508 4.55464 15.4297C4.49604 15.3047 4.48042 15.2148 4.49604 15.1172C4.51167 15.0429 4.74604 14.5937 5.01558 14.1211C5.28901 13.6484 5.5312 13.2265 5.55464 13.1836C5.57808 13.1406 5.66011 13.0742 5.73433 13.039C5.80854 13 5.94136 12.9687 6.02729 12.9687Z" fill="#F74E31" />
//   </svg>;
// }

// export const CO2 = () => {
//   return <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M18.7858 1.75162C18.6029 1.71492 18.42 1.6828 18.3777 1.6828H18.373C18.3308 1.6828 18.4059 1.75621 18.5513 1.85256C18.692 1.94433 18.9312 2.12327 19.086 2.25174C19.2361 2.38021 19.48 2.64174 19.6255 2.82985C19.7709 3.01797 19.9585 3.31161 20.0429 3.48138C20.1274 3.65573 20.2352 3.92185 20.2868 4.07785C20.3807 4.36231 20.3853 4.3669 20.6715 4.49996C20.8357 4.57337 21.0936 4.71561 21.2484 4.81655C21.4032 4.91749 21.68 5.1469 21.8582 5.32584C22.0412 5.50478 22.2898 5.8076 22.407 5.99572C22.529 6.18383 22.6838 6.47289 22.7541 6.63807C22.8198 6.80324 22.9183 7.12442 22.9652 7.34924C23.0121 7.57406 23.0543 7.92735 23.0543 8.12923C23.0543 8.33111 23.0215 8.67064 22.9793 8.88629C22.9371 9.10193 22.8433 9.43228 22.7729 9.6204C22.6979 9.80852 22.529 10.1297 22.393 10.3316C22.2616 10.5335 21.9989 10.8455 21.816 11.0198C21.6331 11.1987 21.3235 11.4419 21.1312 11.5612C20.9389 11.6759 20.5777 11.8457 20.3338 11.9329C20.0898 12.02 19.7803 12.1026 19.6536 12.121C19.5223 12.1393 19.3909 12.1806 19.3534 12.2081C19.3206 12.2357 19.2221 12.4009 19.1376 12.5798C19.0532 12.7587 18.8937 13.0386 18.7811 13.2084C18.6686 13.3781 18.4481 13.658 18.2933 13.8278C18.1432 13.9976 17.8899 14.2499 17.7304 14.383C17.5756 14.516 17.3223 14.7087 17.1675 14.8097C17.0127 14.906 16.7501 15.062 16.5812 15.1446C16.4123 15.2318 16.084 15.3648 15.8542 15.4428C15.6243 15.5162 15.2631 15.6126 15.0567 15.6585C14.8128 15.709 14.4423 15.7365 13.992 15.7411C13.612 15.7411 13.3306 15.7594 13.3587 15.7778C13.3915 15.7915 13.5088 15.8374 13.6261 15.8787C13.7433 15.9154 13.9404 15.9705 14.0717 15.998C14.1983 16.0301 14.3484 16.0622 14.4 16.0714C14.4516 16.0806 14.5689 16.099 14.658 16.1127C14.7472 16.1219 15.1177 16.1357 15.4789 16.1357C15.8729 16.1357 16.2857 16.1081 16.5108 16.0668C16.7172 16.0255 17.0456 15.943 17.2379 15.8741C17.4302 15.8099 17.7492 15.6814 17.9415 15.5897C18.1338 15.4979 18.4622 15.3144 18.6686 15.1813C18.8749 15.0437 19.2455 14.7317 19.4941 14.4885C19.738 14.2453 20.057 13.8737 20.1977 13.658C20.3384 13.4424 20.5261 13.1258 20.6152 12.9469C20.6996 12.7679 20.7934 12.6119 20.8216 12.5936C20.8497 12.5752 20.967 12.5477 21.0843 12.5339C21.2015 12.5156 21.3892 12.4789 21.5064 12.4421C21.6237 12.41 21.8019 12.3458 21.9051 12.3045C22.0083 12.2632 22.1444 12.2081 22.21 12.176C22.2757 12.1485 22.4821 12.0246 22.665 11.9053C22.8526 11.7814 23.1059 11.5887 23.2279 11.4649C23.3546 11.3456 23.5281 11.1575 23.6266 11.0427C23.7204 10.928 23.8799 10.6803 23.9878 10.4922C24.091 10.304 24.2083 10.0563 24.2505 9.94158C24.2927 9.82687 24.3584 9.6204 24.3959 9.48275C24.4334 9.34511 24.4756 9.05605 24.4944 8.84041C24.5085 8.62476 24.4944 8.26229 24.4662 8.03747C24.4334 7.81265 24.3677 7.50065 24.3161 7.34924C24.2645 7.19783 24.1567 6.94089 24.0722 6.77571C23.9925 6.61054 23.8846 6.41783 23.833 6.34442C23.7767 6.26642 23.6923 6.1563 23.6407 6.09207C23.5891 6.02783 23.4061 5.83513 23.2326 5.66537C23.059 5.49101 22.7823 5.27078 22.6181 5.16984C22.4586 5.0689 22.2194 4.94502 22.0928 4.89455C21.9286 4.83031 21.8442 4.77066 21.8019 4.6789C21.7738 4.61008 21.7363 4.49078 21.7175 4.41278C21.7034 4.33478 21.6002 4.10996 21.497 3.90808C21.3938 3.7062 21.1968 3.3942 21.0608 3.21985C20.9248 3.0455 20.7325 2.82526 20.6293 2.73809C20.5308 2.64632 20.3338 2.49032 20.193 2.38938C20.0523 2.28386 19.7521 2.11409 19.5223 2.01315C19.2971 1.90762 18.9688 1.78833 18.7858 1.75162Z" fill="#56AB2F" />
//     <path d="M5.44084 14.4243C5.22507 14.204 5.03744 14.0251 5.02337 14.0251C5.0093 14.0251 4.89672 14.1214 4.77945 14.2407C4.65749 14.3646 4.48863 14.6124 4.39482 14.8051C4.23064 15.1354 4.22595 15.1675 4.22595 15.6539C4.23064 16.1357 4.24002 16.1724 4.39013 16.4798C4.48394 16.6587 4.65749 16.8973 4.78883 17.0304C4.92017 17.1542 5.15002 17.324 5.30481 17.4066C5.46898 17.4892 5.7129 17.5672 5.89114 17.5947C6.06001 17.6176 6.28985 17.6314 6.40712 17.6176C6.52439 17.6085 6.72139 17.5718 6.85273 17.5351C6.97938 17.5029 7.21392 17.3882 7.36871 17.2919C7.5235 17.1909 7.71582 17.0304 7.79556 16.9294C7.8753 16.8331 7.98319 16.6725 8.03948 16.5715C8.09107 16.4706 8.16143 16.3008 8.19896 16.1953L8.25994 16.0072C8.00664 15.9567 7.76273 15.8787 7.55634 15.8053C7.34995 15.7273 7.04505 15.5897 6.87619 15.5025C6.70732 15.4153 6.40712 15.2272 6.20073 15.085C5.99903 14.9427 5.65661 14.6491 5.44084 14.4243Z" fill="#56AB2F" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M13.1806 0.168735C12.9742 0.141206 12.6458 0.127441 12.4535 0.127441C12.2612 0.13203 11.9563 0.150382 11.7734 0.173323C11.5904 0.196265 11.2855 0.255911 11.0932 0.301793C10.9009 0.347675 10.5725 0.453204 10.3661 0.531204C10.1598 0.609203 9.81264 0.774379 9.59218 0.902849C9.37172 1.03132 9.04806 1.24696 8.86513 1.3892C8.6259 1.57273 8.51333 1.63696 8.44297 1.61402C8.39137 1.60026 8.19436 1.55896 8.01142 1.52226C7.8238 1.48555 7.4673 1.45343 7.22339 1.45343C6.97947 1.45343 6.62298 1.48096 6.44004 1.51767C6.25242 1.55437 5.97098 1.62779 5.81618 1.68284C5.66139 1.73331 5.39871 1.85261 5.22985 1.94437C5.06098 2.03155 4.80769 2.19672 4.66697 2.30225C4.52625 2.40778 4.30578 2.60507 4.17914 2.74272C4.05249 2.88037 3.85079 3.13731 3.73821 3.31166C3.62095 3.48601 3.46615 3.76589 3.40048 3.93107C3.33012 4.09624 3.24569 4.35318 3.21286 4.50459C3.18002 4.656 3.11904 4.81659 3.07683 4.86247C3.03461 4.90835 2.98301 4.94047 2.95487 4.94047C2.92672 4.94047 2.74379 5.03224 2.54678 5.14694C2.34508 5.26165 2.02142 5.50482 1.82441 5.68376C1.62741 5.86729 1.37411 6.14258 1.26622 6.29399C1.15834 6.4454 1.00824 6.68399 0.937875 6.82164C0.867515 6.95928 0.754939 7.22081 0.69396 7.39516C0.632981 7.56952 0.562621 7.89069 0.534477 8.10634C0.501642 8.32198 0.49226 8.67068 0.506332 8.88633C0.525095 9.10198 0.581383 9.4415 0.632981 9.64338C0.684578 9.84527 0.792464 10.1435 0.872206 10.3087C0.951947 10.4739 1.09267 10.7216 1.18648 10.8593C1.28499 10.9969 1.4773 11.2309 1.61802 11.3777C1.75874 11.5291 2.00266 11.7448 2.15745 11.8595C2.31224 11.9742 2.63121 12.1531 2.86105 12.2587C3.0909 12.3688 3.41925 12.4881 3.58811 12.5248C3.75697 12.5661 3.97275 12.612 4.07125 12.6257C4.23542 12.6487 4.25419 12.667 4.46058 13.0708C4.57784 13.3048 4.77485 13.6305 4.89212 13.7957C5.01408 13.9609 5.27207 14.2591 5.46907 14.461C5.66608 14.6629 5.99443 14.9428 6.19613 15.085C6.40252 15.2272 6.70272 15.4154 6.87159 15.5025C7.04045 15.5897 7.34535 15.7274 7.55174 15.8054C7.75813 15.8833 8.14745 15.9889 8.41951 16.0439C8.776 16.1173 9.0809 16.1449 9.52182 16.1449C9.8877 16.1449 10.3005 16.1173 10.5538 16.0715C10.7836 16.0302 11.112 15.9522 11.2808 15.9017C11.4497 15.8466 11.7921 15.709 12.0454 15.5943L12.5051 15.3786L13.2744 15.7549C14.4236 15.7365 14.8176 15.7044 15.0568 15.6539C15.2632 15.6126 15.6244 15.5163 15.8542 15.4429C16.0841 15.3649 16.4124 15.2318 16.5813 15.1446C16.7502 15.0621 17.0128 14.9061 17.1676 14.8097C17.3224 14.7088 17.5757 14.5161 17.7305 14.383C17.89 14.2499 18.1433 13.9976 18.2934 13.8278C18.4482 13.6581 18.6687 13.3782 18.7812 13.2084C18.8938 13.0387 19.0533 12.7588 19.1377 12.5798C19.2222 12.4009 19.3207 12.2357 19.3535 12.2082C19.391 12.1807 19.527 12.1394 19.6537 12.121C19.785 12.1027 20.0899 12.0201 20.3338 11.9329C20.5778 11.8457 20.9389 11.676 21.1313 11.5613C21.3236 11.442 21.6332 11.1988 21.8161 11.0198C21.999 10.8455 22.2617 10.5335 22.3931 10.3316C22.5291 10.1297 22.6979 9.80856 22.773 9.62044C22.8434 9.43233 22.9372 9.10198 22.9794 8.88633C23.0216 8.67068 23.0544 8.33116 23.0544 8.12928C23.0544 7.9274 23.0122 7.5741 22.9653 7.34928C22.9184 7.12446 22.8199 6.80328 22.7542 6.63811C22.6839 6.47293 22.5291 6.18388 22.4071 5.99576C22.2899 5.80764 22.0413 5.50482 21.8583 5.32588C21.6801 5.14694 21.4033 4.91753 21.2485 4.81659C21.0937 4.71565 20.8357 4.57342 20.6716 4.5C20.3854 4.36695 20.3808 4.36236 20.2869 4.07789C20.2353 3.92189 20.1275 3.65577 20.043 3.48142C19.9586 3.31166 19.771 3.01801 19.6256 2.8299C19.4801 2.64178 19.2362 2.38025 19.0861 2.25178C18.9313 2.12331 18.6968 1.94896 18.5655 1.86178C18.4294 1.77461 18.3309 1.69202 18.3497 1.66908C18.3638 1.65073 18.1433 1.63696 17.8572 1.63696C17.5663 1.63696 17.1676 1.66908 16.9706 1.70579C16.647 1.76543 16.5954 1.76543 16.5109 1.70579L16.4912 1.69L16.4911 1.6899C16.4227 1.6352 16.2637 1.50806 16.1122 1.38461C15.9434 1.24696 15.6479 1.04508 15.4555 0.930378C15.2632 0.815673 14.9255 0.650497 14.705 0.558733C14.4846 0.471557 14.1375 0.356852 13.9311 0.306382C13.7247 0.255911 13.3869 0.191676 13.1806 0.168735ZM15.6666 16.1678C15.7698 16.1586 15.6948 16.1495 15.5024 16.1495C15.3101 16.1495 15.2257 16.1586 15.3148 16.1678C15.4039 16.177 15.5634 16.177 15.6666 16.1678ZM3.82264 18.1545C4.00558 18.1545 4.14161 18.1866 4.29171 18.26C4.42774 18.3289 4.55908 18.4482 4.65759 18.595C4.74202 18.7189 4.82176 18.9024 4.83583 19.0033C4.8499 19.1043 4.83583 19.2786 4.80769 19.3933C4.77016 19.5356 4.68104 19.6686 4.53094 19.8109C4.3996 19.9439 4.24481 20.0449 4.12754 20.077C4.02434 20.1045 3.88831 20.1274 3.82264 20.1274C3.75697 20.1274 3.62564 20.1045 3.53182 20.0816C3.43332 20.054 3.27853 19.9669 3.18471 19.8843C3.0909 19.8063 2.97363 19.6594 2.92672 19.5631C2.87513 19.4713 2.8376 19.2878 2.83291 19.1502C2.82822 19.0217 2.86105 18.8382 2.89858 18.751C2.9408 18.6638 3.01116 18.5445 3.05806 18.4895C3.10497 18.4344 3.23631 18.338 3.35358 18.2738C3.50837 18.1866 3.63502 18.1545 3.82264 18.1545ZM18.5513 4.95422C18.4575 4.90834 18.2464 4.87163 18.0588 4.86246C17.8759 4.85787 17.6648 4.87622 17.5897 4.90375C17.5147 4.93128 17.374 5.00469 17.2849 5.06892C17.1957 5.13316 17.0832 5.22951 17.0362 5.27998C16.9893 5.33504 16.9096 5.45892 16.8627 5.55986C16.8111 5.6608 16.7689 5.81221 16.7689 5.89021C16.7689 5.98198 16.8064 6.07833 16.8627 6.13339C16.919 6.18845 17.0222 6.22515 17.1066 6.22515C17.1957 6.22974 17.2942 6.19304 17.3411 6.14715C17.3834 6.10127 17.4443 5.99115 17.4819 5.90398C17.5194 5.8168 17.6132 5.69751 17.6883 5.63786C17.7774 5.56904 17.89 5.53233 18.0119 5.53233C18.1339 5.53233 18.2464 5.56904 18.3356 5.63786C18.4106 5.69751 18.4997 5.81221 18.5373 5.89021C18.5889 6.01868 18.5889 6.07374 18.5232 6.25727C18.481 6.38115 18.3403 6.6335 18.2089 6.82162C18.0776 7.00974 17.7305 7.48691 17.4396 7.87691C17.1441 8.26691 16.8955 8.62479 16.8815 8.66608C16.8721 8.71196 16.8955 8.80831 16.9331 8.88631C16.9706 8.95973 17.0597 9.0469 17.1301 9.07443C17.2145 9.10196 17.632 9.11572 18.2605 9.10655L19.2643 9.09278C19.405 8.91384 19.4473 8.82208 19.4473 8.77161C19.4473 8.72114 19.405 8.62479 19.3488 8.55137L19.2549 8.42749H17.8946C18.3919 7.77138 18.6592 7.40432 18.8046 7.18868C18.95 6.97303 19.1142 6.68397 19.1705 6.54633C19.2221 6.40409 19.269 6.18386 19.269 6.04163C19.269 5.88563 19.2362 5.71127 19.1752 5.5828C19.1236 5.4681 18.997 5.29834 18.8984 5.20198C18.7953 5.10563 18.6405 4.99551 18.5513 4.95422ZM8.72436 6.11045C8.56957 6.07374 8.26467 6.03245 8.04421 6.01868C7.80499 6.00492 7.52355 6.02327 7.34061 6.05998C7.17175 6.09668 6.90907 6.17468 6.75428 6.23433C6.59948 6.29398 6.34619 6.43162 6.19139 6.53256C6.0366 6.6335 5.80207 6.8308 5.67542 6.96385C5.54408 7.1015 5.37052 7.31256 5.29078 7.44103C5.20635 7.56491 5.08908 7.8035 5.0281 7.96867C4.96244 8.13385 4.88738 8.43208 4.85455 8.63396C4.82171 8.84043 4.81233 9.12031 4.8311 9.27631C4.84517 9.42772 4.89207 9.67549 4.9296 9.8269C4.97182 9.97831 5.08908 10.2674 5.19697 10.4692C5.333 10.7308 5.49248 10.9372 5.74578 11.1804C5.99438 11.4282 6.20547 11.5842 6.47283 11.7172C6.67922 11.8228 6.98412 11.9421 7.15298 11.9879C7.34061 12.0338 7.62674 12.0659 7.90349 12.0659C8.14741 12.0659 8.45699 12.0384 8.58364 12.0109C8.71029 11.9788 8.9542 11.8916 9.12307 11.8136C9.30601 11.7264 9.54523 11.5567 9.71879 11.3915C9.93925 11.185 10.0143 11.0795 10.0143 10.9831C10.0143 10.9097 9.96739 10.8134 9.89703 10.7445C9.83136 10.6803 9.72817 10.6298 9.6625 10.6298C9.58745 10.6298 9.44673 10.717 9.27786 10.8684C9.12776 10.9969 8.90261 11.1529 8.77127 11.2125C8.64462 11.2676 8.4007 11.341 8.23184 11.3639C8.01607 11.4007 7.83313 11.4007 7.61267 11.3685C7.43442 11.341 7.1952 11.2814 7.07324 11.2355C6.94659 11.1896 6.72144 11.0703 6.57134 10.9739C6.41655 10.873 6.21016 10.6987 6.11165 10.584C6.01315 10.4692 5.86774 10.2536 5.79269 10.1022C5.71294 9.95078 5.61913 9.6709 5.57691 9.48278C5.53001 9.25796 5.51594 9.04231 5.5347 8.86337C5.54877 8.71196 5.60975 8.45502 5.66135 8.28985C5.71763 8.12467 5.84897 7.86773 5.95217 7.72091C6.06005 7.5695 6.2383 7.36762 6.35557 7.27126C6.47283 7.17491 6.71675 7.0235 6.895 6.93633C7.11077 6.8308 7.35468 6.75739 7.5986 6.72527C7.89411 6.67939 8.0489 6.68397 8.32565 6.72986C8.55081 6.76656 8.8041 6.85374 9.02926 6.96844C9.25441 7.08315 9.42796 7.14279 9.51709 7.13362C9.59683 7.12444 9.69064 7.06938 9.74693 7.00515C9.80791 6.92715 9.82667 6.85374 9.80791 6.76197C9.79384 6.69315 9.73286 6.5968 9.67657 6.54174C9.61559 6.49127 9.44204 6.39033 9.28724 6.31692C9.13245 6.24351 8.87915 6.15174 8.72436 6.11045ZM13.3118 6.02327C13.5698 6.03245 13.856 6.08292 14.0858 6.15633C14.2828 6.21598 14.583 6.34445 14.7472 6.4408C14.9114 6.53715 15.1975 6.77115 15.3804 6.95927C15.6244 7.20703 15.7745 7.4135 15.9152 7.69338C16.0231 7.90903 16.145 8.23938 16.1872 8.42749C16.2388 8.66608 16.2529 8.90467 16.2388 9.20749C16.2201 9.46902 16.1732 9.76266 16.1122 9.9416C16.0559 10.1068 15.9433 10.3637 15.8636 10.5151C15.7698 10.6849 15.5634 10.9418 15.3148 11.1804C15.0146 11.4787 14.8316 11.6163 14.5643 11.7402C14.3719 11.8365 14.0764 11.9466 13.9076 11.9879C13.7293 12.0338 13.4197 12.0659 13.1571 12.0659C12.8803 12.0705 12.5942 12.0384 12.4065 11.9925C12.2377 11.9466 11.975 11.8549 11.8202 11.7815C11.6654 11.7127 11.4027 11.5521 11.2386 11.4282C11.0744 11.3043 10.8445 11.0887 10.732 10.951C10.6194 10.8134 10.4552 10.5564 10.3661 10.3775C10.277 10.1985 10.1738 9.90948 10.1316 9.73513C10.0753 9.50113 10.0565 9.27631 10.0753 8.90926C10.0893 8.56514 10.1269 8.3082 10.1925 8.10632C10.2488 7.94114 10.3708 7.67503 10.4693 7.50985C10.5678 7.34468 10.7976 7.06938 10.9759 6.89044C11.201 6.67021 11.4262 6.50962 11.6795 6.37656C11.8859 6.27104 12.1814 6.15633 12.3362 6.11962C12.491 6.07833 12.6833 6.03704 12.7583 6.02327C12.8334 6.0141 13.082 6.0141 13.3118 6.02327Z" fill="#56AB2F" />
//     <path d="M13.5324 6.73449C13.4151 6.70696 13.2369 6.68861 13.129 6.68402C13.0258 6.68402 12.9273 6.6932 12.9179 6.70237C12.9086 6.71155 12.8054 6.73449 12.6881 6.75284C12.5708 6.7712 12.402 6.81249 12.3128 6.84002C12.2237 6.87214 12.0548 6.95473 11.9376 7.01896C11.8203 7.08778 11.6421 7.21625 11.5389 7.31261C11.4357 7.40896 11.3043 7.5466 11.2481 7.6246C11.1918 7.7026 11.0886 7.86319 11.0229 7.99166C10.9572 8.11554 10.8775 8.31283 10.84 8.42754C10.8024 8.54225 10.7743 8.82213 10.7743 9.04695C10.7743 9.28554 10.8071 9.55624 10.8447 9.6893C10.8869 9.81318 10.976 10.0334 11.051 10.1711C11.1261 10.3087 11.309 10.5427 11.4544 10.6895C11.6374 10.8639 11.8531 11.0153 12.1018 11.1346C12.3597 11.2585 12.5849 11.3319 12.8288 11.364C13.0211 11.3915 13.2322 11.4007 13.2979 11.3869C13.3635 11.3732 13.4902 11.3548 13.5793 11.3456C13.6684 11.3319 13.8373 11.2906 13.9546 11.2493C14.0718 11.208 14.2595 11.1208 14.3767 11.0566C14.494 10.9878 14.6957 10.8272 14.8224 10.6941C14.9537 10.5611 15.085 10.4234 15.1179 10.3821C15.146 10.3408 15.2351 10.1802 15.3149 10.0242C15.3899 9.86365 15.4744 9.63424 15.4978 9.50577C15.5213 9.38189 15.5353 9.11118 15.526 8.9093C15.5166 8.68448 15.4697 8.43672 15.404 8.26695C15.3477 8.11554 15.2727 7.95954 15.2398 7.92284C15.207 7.88613 15.1742 7.82648 15.1742 7.79896C15.1742 7.76684 15.0428 7.61084 14.8786 7.45484C14.7192 7.29425 14.5456 7.13825 14.494 7.11072C14.4424 7.07861 14.3017 7.00061 14.1797 6.93637C14.0531 6.87214 13.9077 6.81249 13.8514 6.79873C13.7904 6.78496 13.6497 6.75743 13.5324 6.73449Z" fill="#56AB2F" />
//   </svg>;
// }

export const Close = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.59 0L14 1.41L8.41 7L14 12.59L12.59 14L7 8.41L1.41 14L0 12.59L5.59 7L0 1.41L1.41 0L7 5.59L12.59 0Z"
        fill="#1A1532"
      />
    </svg>
  );
};

export const DropdownArrowDown = () => {
  return (
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.71145 6.34206L10.3052 1.44219C10.4351 1.30363 10.5 1.13975 10.5 0.950047C10.5 0.760344 10.4351 0.596346 10.3052 0.457784C10.1753 0.319223 10.0215 0.25 9.8438 0.25L0.656342 0.25C0.478636 0.25 0.324778 0.319223 0.194946 0.457784C0.0650425 0.596499 0 0.760497 0 0.950047C0 1.13963 0.0650425 1.30363 0.194946 1.44219L4.78869 6.34206C4.91845 6.48051 5.07231 6.55 5.25009 6.55C5.4278 6.55 5.58155 6.48055 5.71145 6.34206Z"
        fill="#979797"
      />
    </svg>
  );
};

export const DropdownArrowUp = () => {
  return (
    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.28855 0.657938L0.694802 5.55781C0.564898 5.69637 0.5 5.86025 0.5 6.04995C0.5 6.23966 0.564898 6.40365 0.694802 6.54222C0.824705 6.68078 0.978456 6.75 1.1562 6.75L10.3437 6.75C10.5214 6.75 10.6752 6.68078 10.8051 6.54222C10.935 6.4035 11 6.2395 11 6.04995C11 5.86037 10.935 5.69637 10.8051 5.55781L6.21131 0.657938C6.08155 0.519492 5.92769 0.45 5.74991 0.45C5.5722 0.45 5.41845 0.519454 5.28855 0.657938Z"
        fill="#979797"
      />
    </svg>
  );
};

export const Filters = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 16C7.71667 16 7.47933 15.904 7.288 15.712C7.096 15.5207 7 15.2833 7 15V9L1.2 1.6C0.949999 1.26667 0.912666 0.916667 1.088 0.55C1.26267 0.183334 1.56667 0 2 0H16C16.4333 0 16.7377 0.183334 16.913 0.55C17.0877 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9043 15.5207 10.713 15.712C10.521 15.904 10.2833 16 10 16H8Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export const ClarityHelp = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_123_1821)">
        <path
          d="M9.99998 1.11133C8.24192 1.11133 6.52334 1.63265 5.06157 2.60938C3.5998 3.5861 2.46049 4.97435 1.78771 6.59859C1.11494 8.22282 0.938906 10.0101 1.28189 11.7344C1.62487 13.4586 2.47145 15.0425 3.71458 16.2856C4.95772 17.5287 6.54157 18.3753 8.26584 18.7183C9.99012 19.0613 11.7774 18.8853 13.4016 18.2125C15.0258 17.5397 16.4141 16.4004 17.3908 14.9386C18.3675 13.4768 18.8889 11.7583 18.8889 10.0002C18.8889 7.64274 17.9524 5.38181 16.2854 3.71482C14.6184 2.04783 12.3575 1.11133 9.99998 1.11133ZM9.99998 17.778C8.46168 17.778 6.95792 17.3218 5.67888 16.4672C4.39983 15.6126 3.40293 14.3978 2.81425 12.9766C2.22557 11.5554 2.07154 9.99159 2.37165 8.48285C2.67175 6.97411 3.41252 5.58824 4.50026 4.5005C5.588 3.41276 6.97387 2.67199 8.48261 2.37189C9.99135 2.07178 11.5552 2.22581 12.9764 2.81449C14.3976 3.40317 15.6123 4.40007 16.467 5.67911C17.3216 6.95816 17.7778 8.46192 17.7778 10.0002C17.7778 12.063 16.9583 14.0413 15.4997 15.4999C14.0411 16.9586 12.0628 17.778 9.99998 17.778Z"
          fill="#BDBDBD"
        />
        <path
          d="M10.1611 4.95564C9.55907 4.94569 8.96224 5.06846 8.41302 5.31522C7.8638 5.56199 7.37567 5.92669 6.98332 6.38342C6.92881 6.43393 6.88499 6.49487 6.85445 6.56262C6.82392 6.63037 6.80729 6.70356 6.80554 6.77786C6.80551 6.84641 6.81926 6.91426 6.84598 6.97738C6.8727 7.0405 6.91185 7.09761 6.96109 7.14529C7.01033 7.19298 7.06866 7.23027 7.1326 7.25496C7.19655 7.27964 7.26481 7.29121 7.33332 7.28897C7.48008 7.28533 7.62042 7.22801 7.72776 7.12786C8.02469 6.77991 8.39347 6.50041 8.80874 6.3086C9.224 6.11679 9.6759 6.01722 10.1333 6.01675C11.4444 6.01675 12.2611 6.86119 12.2611 7.91119V7.93897C12.2611 9.16675 11.2833 9.85008 9.73888 9.96675C9.67634 9.96916 9.61502 9.98476 9.55892 10.0125C9.50283 10.0403 9.45323 10.0796 9.41337 10.1278C9.37351 10.1761 9.34429 10.2322 9.32763 10.2925C9.31096 10.3528 9.30722 10.416 9.31665 10.4779C9.31665 10.4779 9.31665 11.7667 9.31665 12.0056C9.33047 12.1432 9.39505 12.2706 9.49778 12.363C9.6005 12.4555 9.73401 12.5063 9.87221 12.5056H9.93332C10.0708 12.4918 10.1983 12.4272 10.2907 12.3245C10.3832 12.2218 10.434 12.0883 10.4333 11.9501V10.8056C12.1 10.5723 13.45 9.69453 13.45 7.8723V7.84453C13.4333 6.17786 12.1333 4.95564 10.1611 4.95564Z"
          fill="#BDBDBD"
        />
        <path
          d="M9.87779 15.2502C10.2613 15.2502 10.5722 14.9393 10.5722 14.5558C10.5722 14.1722 10.2613 13.8613 9.87779 13.8613C9.49426 13.8613 9.18335 14.1722 9.18335 14.5558C9.18335 14.9393 9.49426 15.2502 9.87779 15.2502Z"
          fill="#BDBDBD"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_1821">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LoginLogoutRed = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6113 12.9516L18.5875 10.0002L15.6113 7.04883M12.0001 10.0002H17.9922"
        stroke="#EB5757"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.06157 2.49805C6.52335 1.52132 8.24192 1 9.99998 1C12.3575 1 14.6184 1.93651 16.2854 3.6035C16.4537 3.77185 16.6146 3.94626 16.7679 4.12621C17.0719 4.48327 16.7995 5 16.3305 5C16.1526 5 15.9852 4.91868 15.8684 4.78444C15.0814 3.87961 14.0926 3.16549 12.9764 2.70316C11.5552 2.11448 9.99135 1.96045 8.48261 2.26056C6.97387 2.56067 5.588 3.30143 4.50026 4.38917C3.41252 5.47691 2.67175 6.86278 2.37165 8.37152C2.07154 9.88026 2.22557 11.4441 2.81425 12.8653C3.40293 14.2865 4.39983 15.5012 5.67888 16.3559C6.95792 17.2105 8.46168 17.6667 9.99998 17.6667C12.0628 17.6667 14.0411 16.8472 15.4997 15.3886C15.5616 15.3267 15.6224 15.2638 15.6821 15.2C15.799 15.0749 15.9609 15 16.1321 15C16.6118 15 16.8826 15.5345 16.5587 15.8885C15.6846 16.8441 14.6082 17.6014 13.4016 18.1012C11.7774 18.7739 9.99012 18.95 8.26584 18.607C6.54157 18.264 4.95772 17.4174 3.71458 16.1743C2.47145 14.9311 1.62487 13.3473 1.28189 11.623C0.938906 9.89875 1.11494 8.11149 1.78771 6.48726C2.46049 4.86303 3.5998 3.47477 5.06157 2.49805Z"
        fill="#EB5757"
      />
    </svg>
  );
};

export const FAQ = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_138_6077)">
        <path
          d="M9.88889 1.11133C8.13084 1.11133 6.41226 1.63265 4.95049 2.60938C3.48872 3.5861 2.34941 4.97435 1.67663 6.59859C1.00385 8.22282 0.827822 10.0101 1.1708 11.7344C1.51378 13.4586 2.36037 15.0425 3.6035 16.2856C4.84663 17.5287 6.43048 18.3753 8.15476 18.7183C9.87903 19.0613 11.6663 18.8853 13.2905 18.2125C14.9148 17.5397 16.303 16.4004 17.2797 14.9386C18.2565 13.4768 18.7778 11.7583 18.7778 10.0002C18.7778 7.64274 17.8413 5.38181 16.1743 3.71482C14.5073 2.04783 12.2464 1.11133 9.88889 1.11133ZM9.88889 17.778C8.35059 17.778 6.84684 17.3218 5.56779 16.4672C4.28874 15.6126 3.29184 14.3978 2.70316 12.9766C2.11448 11.5554 1.96046 9.99159 2.26056 8.48285C2.56067 6.97411 3.30143 5.58824 4.38917 4.5005C5.47692 3.41276 6.86278 2.67199 8.37152 2.37189C9.88027 2.07178 11.4441 2.22581 12.8653 2.81449C14.2865 3.40317 15.5012 4.40007 16.3559 5.67911C17.2105 6.95816 17.6667 8.46192 17.6667 10.0002C17.6667 12.063 16.8472 14.0413 15.3886 15.4999C13.93 16.9586 11.9517 17.778 9.88889 17.778Z"
          fill="#BDBDBD"
        />
        <path
          d="M9.88892 5.93774C8.38519 5.93774 7.34346 6.99399 7.34346 8.28149C7.34346 8.89649 7.61328 9.29712 7.96964 9.72149L8.10583 9.87962C8.24773 10.0446 8.40492 10.2271 8.5341 10.4096C8.71482 10.6665 8.87583 10.9696 8.92928 11.3409C8.94202 11.4615 8.90668 11.5822 8.83069 11.6778C8.7547 11.7733 8.64396 11.8363 8.52174 11.8533C8.39952 11.8704 8.27531 11.8403 8.17521 11.7693C8.07511 11.6984 8.00691 11.5921 7.98492 11.4727C7.95946 11.2965 7.88119 11.1309 7.74946 10.9434C7.64199 10.796 7.52687 10.6541 7.40455 10.5184C7.3511 10.4559 7.29446 10.3902 7.23401 10.3184C6.83501 9.84399 6.38892 9.22899 6.38892 8.28149C6.38892 6.44399 7.89264 5.00024 9.88892 5.00024C11.8852 5.00024 13.3889 6.44399 13.3889 8.28149C13.3889 9.22899 12.9428 9.84399 12.5438 10.3184C12.4834 10.3902 12.4267 10.4559 12.3733 10.5177C12.2416 10.6709 12.1296 10.8009 12.029 10.9434C11.8966 11.1309 11.819 11.2965 11.7936 11.4727C11.7701 11.5909 11.7013 11.6956 11.6015 11.7654C11.5016 11.8351 11.3783 11.8645 11.2569 11.8475C11.1356 11.8305 11.0256 11.7684 10.9496 11.674C10.8736 11.5796 10.8374 11.4601 10.8486 11.3402C10.902 10.9696 11.063 10.6665 11.2437 10.4096C11.3729 10.2271 11.5301 10.0446 11.672 9.87962C11.7197 9.82462 11.7656 9.77149 11.8076 9.72149C12.1646 9.29712 12.4344 8.89649 12.4344 8.28149C12.4344 6.99399 11.3926 5.93774 9.88892 5.93774ZM8.4571 12.5002H11.3207C11.4473 12.5002 11.5687 12.5496 11.6582 12.6375C11.7477 12.7254 11.798 12.8447 11.798 12.969C11.798 13.0933 11.7477 13.2125 11.6582 13.3005C11.5687 13.3884 11.4473 13.4377 11.3207 13.4377H8.4571C8.33052 13.4377 8.20912 13.3884 8.11961 13.3005C8.03011 13.2125 7.97983 13.0933 7.97983 12.969C7.97983 12.8447 8.03011 12.7254 8.11961 12.6375C8.20912 12.5496 8.33052 12.5002 8.4571 12.5002ZM8.61619 14.5315C8.61619 14.4072 8.66647 14.2879 8.75598 14.2C8.84548 14.1121 8.96688 14.0627 9.09346 14.0627H10.6844C10.811 14.0627 10.9323 14.1121 11.0219 14.2C11.1114 14.2879 11.1616 14.4072 11.1616 14.5315C11.1616 14.6558 11.1114 14.775 11.0219 14.863C10.9323 14.9509 10.811 15.0002 10.6844 15.0002H9.09346C8.96688 15.0002 8.84548 14.9509 8.75598 14.863C8.66647 14.775 8.61619 14.6558 8.61619 14.5315Z"
          fill="#BDBDBD"
        />
      </g>
      <defs>
        <clipPath id="clip0_138_6077">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Suggestions = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_138_6077)">
        <path
          d="M9.88889 1.11133C8.13084 1.11133 6.41226 1.63265 4.95049 2.60938C3.48872 3.5861 2.34941 4.97435 1.67663 6.59859C1.00385 8.22282 0.827822 10.0101 1.1708 11.7344C1.51378 13.4586 2.36037 15.0425 3.6035 16.2856C4.84663 17.5287 6.43048 18.3753 8.15476 18.7183C9.87903 19.0613 11.6663 18.8853 13.2905 18.2125C14.9148 17.5397 16.303 16.4004 17.2797 14.9386C18.2565 13.4768 18.7778 11.7583 18.7778 10.0002C18.7778 7.64274 17.8413 5.38181 16.1743 3.71482C14.5073 2.04783 12.2464 1.11133 9.88889 1.11133ZM9.88889 17.778C8.35059 17.778 6.84684 17.3218 5.56779 16.4672C4.28874 15.6126 3.29184 14.3978 2.70316 12.9766C2.11448 11.5554 1.96046 9.99159 2.26056 8.48285C2.56067 6.97411 3.30143 5.58824 4.38917 4.5005C5.47692 3.41276 6.86278 2.67199 8.37152 2.37189C9.88027 2.07178 11.4441 2.22581 12.8653 2.81449C14.2865 3.40317 15.5012 4.40007 16.3559 5.67911C17.2105 6.95816 17.6667 8.46192 17.6667 10.0002C17.6667 12.063 16.8472 14.0413 15.3886 15.4999C13.93 16.9586 11.9517 17.778 9.88889 17.778Z"
          fill="#BDBDBD"
        />
        <path
          d="M9.88892 5.93774C8.38519 5.93774 7.34346 6.99399 7.34346 8.28149C7.34346 8.89649 7.61328 9.29712 7.96964 9.72149L8.10583 9.87962C8.24773 10.0446 8.40492 10.2271 8.5341 10.4096C8.71482 10.6665 8.87583 10.9696 8.92928 11.3409C8.94202 11.4615 8.90668 11.5822 8.83069 11.6778C8.7547 11.7733 8.64396 11.8363 8.52174 11.8533C8.39952 11.8704 8.27531 11.8403 8.17521 11.7693C8.07511 11.6984 8.00691 11.5921 7.98492 11.4727C7.95946 11.2965 7.88119 11.1309 7.74946 10.9434C7.64199 10.796 7.52687 10.6541 7.40455 10.5184C7.3511 10.4559 7.29446 10.3902 7.23401 10.3184C6.83501 9.84399 6.38892 9.22899 6.38892 8.28149C6.38892 6.44399 7.89264 5.00024 9.88892 5.00024C11.8852 5.00024 13.3889 6.44399 13.3889 8.28149C13.3889 9.22899 12.9428 9.84399 12.5438 10.3184C12.4834 10.3902 12.4267 10.4559 12.3733 10.5177C12.2416 10.6709 12.1296 10.8009 12.029 10.9434C11.8966 11.1309 11.819 11.2965 11.7936 11.4727C11.7701 11.5909 11.7013 11.6956 11.6015 11.7654C11.5016 11.8351 11.3783 11.8645 11.2569 11.8475C11.1356 11.8305 11.0256 11.7684 10.9496 11.674C10.8736 11.5796 10.8374 11.4601 10.8486 11.3402C10.902 10.9696 11.063 10.6665 11.2437 10.4096C11.3729 10.2271 11.5301 10.0446 11.672 9.87962C11.7197 9.82462 11.7656 9.77149 11.8076 9.72149C12.1646 9.29712 12.4344 8.89649 12.4344 8.28149C12.4344 6.99399 11.3926 5.93774 9.88892 5.93774ZM8.4571 12.5002H11.3207C11.4473 12.5002 11.5687 12.5496 11.6582 12.6375C11.7477 12.7254 11.798 12.8447 11.798 12.969C11.798 13.0933 11.7477 13.2125 11.6582 13.3005C11.5687 13.3884 11.4473 13.4377 11.3207 13.4377H8.4571C8.33052 13.4377 8.20912 13.3884 8.11961 13.3005C8.03011 13.2125 7.97983 13.0933 7.97983 12.969C7.97983 12.8447 8.03011 12.7254 8.11961 12.6375C8.20912 12.5496 8.33052 12.5002 8.4571 12.5002ZM8.61619 14.5315C8.61619 14.4072 8.66647 14.2879 8.75598 14.2C8.84548 14.1121 8.96688 14.0627 9.09346 14.0627H10.6844C10.811 14.0627 10.9323 14.1121 11.0219 14.2C11.1114 14.2879 11.1616 14.4072 11.1616 14.5315C11.1616 14.6558 11.1114 14.775 11.0219 14.863C10.9323 14.9509 10.811 15.0002 10.6844 15.0002H9.09346C8.96688 15.0002 8.84548 14.9509 8.75598 14.863C8.66647 14.775 8.61619 14.6558 8.61619 14.5315Z"
          fill="#BDBDBD"
        />
      </g>
      <defs>
        <clipPath id="clip0_138_6077">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ContactUs = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_138_6095)">
        <path
          d="M9.99998 1.11133C8.24192 1.11133 6.52334 1.63265 5.06157 2.60938C3.5998 3.5861 2.46049 4.97435 1.78771 6.59859C1.11494 8.22282 0.938906 10.0101 1.28189 11.7344C1.62487 13.4586 2.47145 15.0425 3.71458 16.2856C4.95772 17.5287 6.54157 18.3753 8.26584 18.7183C9.99012 19.0613 11.7774 18.8853 13.4016 18.2125C15.0258 17.5397 16.4141 16.4004 17.3908 14.9386C18.3675 13.4768 18.8889 11.7583 18.8889 10.0002C18.8889 7.64274 17.9524 5.38181 16.2854 3.71482C14.6184 2.04783 12.3575 1.11133 9.99998 1.11133ZM9.99998 17.778C8.46168 17.778 6.95792 17.3218 5.67888 16.4672C4.39983 15.6126 3.40293 14.3978 2.81425 12.9766C2.22557 11.5554 2.07154 9.99159 2.37165 8.48285C2.67175 6.97411 3.41252 5.58824 4.50026 4.5005C5.588 3.41276 6.97387 2.67199 8.48261 2.37189C9.99135 2.07178 11.5552 2.22581 12.9764 2.81449C14.3976 3.40317 15.6123 4.40007 16.467 5.67911C17.3216 6.95816 17.7778 8.46192 17.7778 10.0002C17.7778 12.063 16.9583 14.0413 15.4997 15.4999C14.0411 16.9586 12.0628 17.778 9.99998 17.778Z"
          fill="#BDBDBD"
        />
        <path
          d="M13.5333 14C13.6667 14 13.7778 13.9556 13.8667 13.8667C13.9556 13.7778 14 13.6667 14 13.5333V11.7333C14 11.6296 13.9667 11.5388 13.9 11.4609C13.8333 11.3833 13.7481 11.3333 13.6444 11.3111L12.1111 11C12.0074 10.9852 11.9018 10.9944 11.7942 11.0276C11.687 11.061 11.6 11.1111 11.5333 11.1778L10.4889 12.2222C9.92593 11.8815 9.41111 11.4778 8.94444 11.0111C8.47778 10.5444 8.08889 10.0444 7.77778 9.51111L8.84444 8.42222C8.91111 8.35556 8.95378 8.27956 8.97244 8.19422C8.99081 8.10919 8.99259 8.01481 8.97778 7.91111L8.68889 6.35556C8.67407 6.25185 8.62593 6.16667 8.54444 6.1C8.46296 6.03333 8.37037 6 8.26667 6H6.46667C6.33333 6 6.22222 6.04444 6.13333 6.13333C6.04444 6.22222 6 6.33333 6 6.46667C6 7.42222 6.21304 8.35363 6.63911 9.26089C7.06489 10.1684 7.62785 10.9721 8.328 11.672C9.02785 12.3721 9.83141 12.9351 10.7387 13.3609C11.6462 13.787 12.5778 14 13.5333 14Z"
          fill="#BDBDBD"
        />
      </g>
      <defs>
        <clipPath id="clip0_138_6095">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WaterTypeBronzeLevel = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="18" transform="matrix(1 0 0 -1 2 36)" fill="white" stroke="white" strokeWidth="2" />
      <path
        d="M3 18.9704L3 18.2142C3 12.3526 6.20522 6.96023 11.3542 4.15921C16.1215 1.56585 21.8785 1.56585 26.6458 4.15921C31.7948 6.96023 35 12.3526 35 18.2142V18.9705C35 24.832 31.7948 30.2244 26.6458 33.0254C21.8785 35.6188 16.1215 35.6188 11.3542 33.0254C6.20521 30.2244 3 24.832 3 18.9704Z"
        fill="url(#paint0_linear_139_6154)"
      />
      <path
        d="M5.43201 18.8801L5.43201 18.2397C5.43201 13.2761 8.14619 8.70985 12.5064 6.33794C16.5434 4.14188 21.4183 4.14188 25.4553 6.33794C29.8155 8.70985 32.5296 13.2761 32.5296 18.2397V18.8801C32.5296 23.8437 29.8155 28.41 25.4553 30.7819C21.4183 32.978 16.5433 32.978 12.5064 30.7819C8.14618 28.41 5.43201 23.8437 5.43201 18.8801Z"
        fill="url(#paint1_linear_139_6154)"
      />
      <g filter="url(#filter0_f_139_6154)">
        <path
          d="M5.43201 18.8801L5.43201 18.2397C5.43201 13.2761 8.14619 8.70985 12.5064 6.33794C16.5434 4.14188 21.4183 4.14188 25.4553 6.33794C29.8155 8.70985 32.5296 13.2761 32.5296 18.2397V18.8801C32.5296 23.8437 29.8155 28.41 25.4553 30.7819C21.4183 32.978 16.5433 32.978 12.5064 30.7819C8.14618 28.41 5.43201 23.8437 5.43201 18.8801Z"
          stroke="url(#paint2_linear_139_6154)"
          strokeWidth="0.128"
        />
      </g>
      <g opacity="0.5">
        <mask id="mask0_139_6154" maskUnits="userSpaceOnUse" x="6" y="5" width="26" height="27">
          <path
            d="M6.58389 18.8697V18.3001C6.5839 13.7264 9.08579 9.51905 13.1043 7.33497C16.8207 5.31514 21.3071 5.31514 25.0234 7.33497C29.042 9.51905 31.5439 13.7264 31.5439 18.3001V18.8697C31.5439 23.4435 29.042 27.6508 25.0234 29.8349C21.3071 31.8547 16.8207 31.8547 13.1043 29.8349C9.08578 27.6508 6.58389 23.4435 6.58389 18.8697Z"
            fill="#A6D3DE"
          />
        </mask>
        <g mask="url(#mask0_139_6154)">
          <path
            d="M6.58389 18.8697V18.3001C6.5839 13.7264 9.08579 9.51905 13.1043 7.33497C16.8207 5.31514 21.3071 5.31514 25.0234 7.33497C29.042 9.51905 31.5439 13.7264 31.5439 18.3001V18.8697C31.5439 23.4435 29.042 27.6508 25.0234 29.8349C21.3071 31.8547 16.8207 31.8547 13.1043 29.8349C9.08578 27.6508 6.58389 23.4435 6.58389 18.8697Z"
            fill="url(#paint3_radial_139_6154)"
          />
          <path
            opacity="0.5"
            d="M16.9433 31.5603L16.5243 6.10394C16.501 4.68502 17.6448 3.52222 19.0639 3.52222C20.483 3.52222 21.6268 4.68502 21.6035 6.10394L21.1846 31.5603C21.1655 32.7179 20.2217 33.6464 19.0639 33.6464C17.9062 33.6464 16.9623 32.7179 16.9433 31.5603Z"
            fill="url(#paint4_linear_139_6154)"
          />
          <path
            opacity="0.5"
            d="M15.8386 31.5898L2.74755 9.75341C2.01786 8.53626 2.42704 6.95734 3.65603 6.24778C4.88502 5.53823 6.45699 5.97333 7.14623 7.21383L19.5116 29.4692C20.0739 30.4812 19.7207 31.7572 18.7181 32.3361C17.7155 32.9149 16.4338 32.5828 15.8386 31.5898Z"
            fill="url(#paint5_linear_139_6154)"
          />
          <path
            opacity="0.5"
            d="M17.4943 29.469L29.8596 7.21362C30.5489 5.97312 32.1209 5.53802 33.3498 6.24758C34.5788 6.95713 34.988 8.53606 34.2583 9.7532L21.1673 31.5896C20.572 32.5826 19.2904 32.9147 18.2878 32.3358C17.2851 31.757 16.932 30.481 17.4943 29.469Z"
            fill="url(#paint6_linear_139_6154)"
          />
          <rect
            x="6.58383"
            y="16.8628"
            width="24.96"
            height="16.2097"
            rx="8.10483"
            fill="url(#paint7_linear_139_6154)"
          />
          <g filter="url(#filter1_i_139_6154)">
            <path
              d="M6.58389 18.8697V18.3001C6.5839 13.7264 9.08579 9.51905 13.1043 7.33497C16.8207 5.31514 21.3071 5.31514 25.0234 7.33497C29.042 9.51905 31.5439 13.7264 31.5439 18.3001V18.8697C31.5439 23.4435 29.042 27.6508 25.0234 29.8349C21.3071 31.8547 16.8207 31.8547 13.1043 29.8349C9.08578 27.6508 6.58389 23.4435 6.58389 18.8697Z"
              fill="#F5C4AF"
              fillOpacity="0.03"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_139_6154)">
        <path
          d="M19.5192 11.1582C19.2851 10.8418 19.0819 10.585 19.0634 10.585C19.048 10.585 18.8417 10.8418 18.6108 11.1519C18.3768 11.4652 17.9488 12.0541 17.6593 12.4613C17.3699 12.8685 16.9449 13.4825 16.7171 13.8271C16.4861 14.1717 16.1844 14.6353 16.0458 14.8608C15.9042 15.0864 15.6548 15.4936 15.4916 15.7692C15.3284 16.0449 15.0943 16.4459 14.9773 16.662C14.8572 16.8781 14.6448 17.2854 14.5062 17.5704C14.3676 17.8555 14.1891 18.2282 14.1152 18.4005C14.0382 18.5728 13.915 18.8829 13.838 19.0897C13.761 19.2964 13.6502 19.6567 13.5917 19.8885C13.4962 20.2612 13.4808 20.3709 13.4685 20.8126C13.4562 21.1916 13.4654 21.3983 13.5055 21.6583C13.5332 21.8494 13.5886 22.1376 13.6286 22.3005C13.6717 22.4634 13.7456 22.714 13.798 22.8549C13.8473 22.999 13.952 23.2434 14.0289 23.3969C14.1059 23.5504 14.226 23.7728 14.2937 23.8887C14.3646 24.0077 14.4847 24.1863 14.5616 24.2896C14.6386 24.393 14.7864 24.5747 14.8911 24.6937C14.9927 24.8128 15.199 25.0226 15.353 25.1573C15.5039 25.2952 15.7748 25.505 15.9534 25.6272C16.132 25.7462 16.4276 25.9217 16.6155 26.0125C16.8033 26.1033 17.0989 26.2286 17.2775 26.2882C17.4561 26.3508 17.7394 26.4291 17.9087 26.4636C18.0781 26.5012 18.4106 26.545 18.6477 26.5638C18.9772 26.592 19.1774 26.592 19.4945 26.5638C19.7224 26.545 20.0488 26.5012 20.2181 26.4636C20.3875 26.4291 20.6708 26.3508 20.8494 26.2882C21.028 26.2286 21.3236 26.1033 21.5114 26.0125C21.6992 25.9217 21.9948 25.7462 22.1734 25.6272C22.352 25.505 22.623 25.2952 22.7739 25.1573C22.9248 25.0226 23.1342 24.8128 23.2358 24.6937C23.3405 24.5747 23.4883 24.393 23.5652 24.2896C23.6422 24.1863 23.7623 24.0077 23.8331 23.8887C23.9009 23.7728 24.021 23.5504 24.0979 23.3969C24.1749 23.2434 24.2796 22.999 24.3289 22.8549C24.3812 22.714 24.4551 22.4634 24.4982 22.3005C24.5383 22.1376 24.5937 21.8494 24.6214 21.6583C24.6614 21.3952 24.6707 21.1947 24.6584 20.8126C24.646 20.3928 24.6276 20.2518 24.5506 19.9511C24.5013 19.7538 24.4089 19.4437 24.3443 19.262C24.2827 19.0803 24.1411 18.72 24.0302 18.4632C23.9194 18.2032 23.7438 17.8242 23.6422 17.6174C23.5406 17.4107 23.3312 17.0097 23.1742 16.7247C23.0171 16.4396 22.7739 16.0104 22.6292 15.7692C22.4844 15.528 22.2535 15.149 22.1119 14.9235C21.9733 14.6979 21.6469 14.1999 21.3913 13.8114C21.1327 13.423 20.7016 12.7965 20.4337 12.4175C20.1658 12.0384 19.7532 11.4715 19.5192 11.1582Z"
          fill="url(#paint8_linear_139_6154)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_139_6154"
          x="5.29121"
          y="4.55015"
          width="27.3792"
          height="28.0196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0384" result="effect1_foregroundBlur_139_6154" />
        </filter>
        <filter
          id="filter1_i_139_6154"
          x="6.58389"
          y="5.82007"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.283333 0 0 0 0 0.158667 0 0 0 0 0.0566667 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6154" />
        </filter>
        <filter
          id="filter2_d_139_6154"
          x="13.3521"
          y="10.4736"
          width="11.6455"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6154" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6154" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6154"
          x1="12.28"
          y1="4.48"
          x2="26.68"
          y2="33.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1DCC1" />
          <stop offset="1" stopColor="#BD8A65" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6154"
          x1="12.152"
          y1="6.84792"
          x2="24.568"
          y2="29.7599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BF8E69" />
          <stop offset="1" stopColor="#E4C196" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6154"
          x1="13.496"
          y1="6.01592"
          x2="26.872"
          y2="30.0799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD4B7" />
          <stop offset="1" stopColor="#FFE3CE" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6154"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0639 18.5849) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#E3C29C" />
          <stop offset="1" stopColor="#D1A479" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6154"
          x1="19.0639"
          y1="3.52222"
          x2="19.0639"
          y2="33.6464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6154"
          x1="3.65603"
          y1="6.24778"
          x2="18.7181"
          y2="32.3361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6154"
          x1="33.3498"
          y1="6.24758"
          x2="18.2878"
          y2="32.3358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6154"
          x1="19.0638"
          y1="23.8918"
          x2="18.9885"
          y2="32.0681"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291667" stopColor="#FFFAF7" stopOpacity="0" />
          <stop offset="1" stopColor="#E4CBAD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6154"
          x1="15.6348"
          y1="15.1564"
          x2="20.2062"
          y2="22.0135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WaterTypeSilverLevel = () => {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18.4167"
        transform="matrix(1 0 0 -1 3 37.345)"
        fill="white"
        stroke="white"
        strokeWidth="2.83333"
      />
      <g opacity="0.7">
        <path
          d="M4 20.9704L4 20.2142C4 14.3526 7.20522 8.96023 12.3542 6.15921C17.1215 3.56585 22.8785 3.56585 27.6458 6.15921C32.7948 8.96023 36 14.3526 36 20.2142V20.9705C36 26.832 32.7948 32.2244 27.6458 35.0254C22.8785 37.6188 17.1215 37.6188 12.3542 35.0254C7.20521 32.2244 4 26.832 4 20.9704Z"
          fill="url(#paint0_linear_139_6175)"
        />
        <path
          d="M6.43207 20.8801L6.43207 20.2397C6.43207 15.2761 9.14625 10.7098 13.5065 8.33794C17.5434 6.14188 22.4184 6.14188 26.4553 8.33794C30.8155 10.7098 33.5297 15.2761 33.5297 20.2397V20.8801C33.5297 25.8437 30.8155 30.41 26.4553 32.7819C22.4184 34.978 17.5434 34.978 13.5064 32.7819C9.14624 30.41 6.43207 25.8437 6.43207 20.8801Z"
          fill="url(#paint1_linear_139_6175)"
        />
        <g filter="url(#filter0_f_139_6175)">
          <path
            d="M6.43207 20.8801L6.43207 20.2397C6.43207 15.2761 9.14625 10.7098 13.5065 8.33794C17.5434 6.14188 22.4184 6.14188 26.4553 8.33794C30.8155 10.7098 33.5297 15.2761 33.5297 20.2397V20.8801C33.5297 25.8437 30.8155 30.41 26.4553 32.7819C22.4184 34.978 17.5434 34.978 13.5064 32.7819C9.14624 30.41 6.43207 25.8437 6.43207 20.8801Z"
            stroke="url(#paint2_linear_139_6175)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6175" maskUnits="userSpaceOnUse" x="7" y="7" width="26" height="27">
            <path
              d="M7.58392 20.8697V20.3001C7.58393 15.7264 10.0858 11.5191 14.1044 9.33497C17.8207 7.31514 22.3072 7.31514 26.0235 9.33497C30.042 11.5191 32.5439 15.7264 32.5439 20.3001V20.8697C32.5439 25.4435 30.042 29.6508 26.0235 31.8349C22.3072 33.8547 17.8207 33.8547 14.1044 31.8349C10.0858 29.6508 7.58392 25.4435 7.58392 20.8697Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6175)">
            <path
              d="M7.58392 20.8697V20.3001C7.58393 15.7264 10.0858 11.5191 14.1044 9.33497C17.8207 7.31514 22.3072 7.31514 26.0235 9.33497C30.042 11.5191 32.5439 15.7264 32.5439 20.3001V20.8697C32.5439 25.4435 30.042 29.6508 26.0235 31.8349C22.3072 33.8547 17.8207 33.8547 14.1044 31.8349C10.0858 29.6508 7.58392 25.4435 7.58392 20.8697Z"
              fill="url(#paint3_radial_139_6175)"
            />
            <path
              opacity="0.5"
              d="M17.9433 33.5603L17.5244 8.10394C17.501 6.68502 18.6448 5.52222 20.0639 5.52222C21.4831 5.52222 22.6269 6.68501 22.6035 8.10394L22.1846 33.5603C22.1655 34.7179 21.2217 35.6464 20.0639 35.6464C18.9062 35.6464 17.9624 34.7179 17.9433 33.5603Z"
              fill="url(#paint4_linear_139_6175)"
            />
            <path
              opacity="0.5"
              d="M16.8384 33.5896L3.74739 11.7532C3.01771 10.536 3.42689 8.9571 4.65588 8.24754C5.88486 7.53798 7.45684 7.97309 8.14608 9.21358L20.5115 31.4689C21.0738 32.481 20.7206 33.7569 19.7179 34.3358C18.7153 34.9147 17.4337 34.5826 16.8384 33.5896Z"
              fill="url(#paint5_linear_139_6175)"
            />
            <path
              opacity="0.5"
              d="M18.4942 31.469L30.8596 9.21362C31.5488 7.97313 33.1208 7.53802 34.3498 8.24758C35.5788 8.95713 35.988 10.5361 35.2583 11.7532L22.1673 33.5896C21.572 34.5826 20.2904 34.9147 19.2877 34.3358C18.2851 33.757 17.9319 32.481 18.4942 31.469Z"
              fill="url(#paint6_linear_139_6175)"
            />
            <rect
              x="7.5838"
              y="18.8628"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6175)"
            />
            <g filter="url(#filter1_i_139_6175)">
              <path
                d="M7.58392 20.8697V20.3001C7.58393 15.7264 10.0858 11.5191 14.1044 9.33497C17.8207 7.31514 22.3072 7.31514 26.0235 9.33497C30.042 11.5191 32.5439 15.7264 32.5439 20.3001V20.8697C32.5439 25.4435 30.042 29.6508 26.0235 31.8349C22.3072 33.8547 17.8207 33.8547 14.1044 31.8349C10.0858 29.6508 7.58392 25.4435 7.58392 20.8697Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6175)">
          <path
            d="M20.4552 13.1655C20.2212 12.8491 20.018 12.5923 19.9995 12.5923C19.9841 12.5923 19.7778 12.8491 19.5468 13.1593C19.3128 13.4725 18.8848 14.0614 18.5954 14.4686C18.3059 14.8759 17.881 15.4898 17.6531 15.8344C17.4222 16.179 17.1204 16.6426 16.9819 16.8681C16.8402 17.0937 16.5908 17.5009 16.4276 17.7766C16.2644 18.0522 16.0304 18.4532 15.9134 18.6693C15.7933 18.8855 15.5808 19.2927 15.4422 19.5777C15.3037 19.8628 15.1251 20.2356 15.0512 20.4079C14.9742 20.5801 14.851 20.8903 14.7741 21.097C14.6971 21.3038 14.5862 21.664 14.5277 21.8958C14.4323 22.2686 14.4169 22.3782 14.4046 22.8199C14.3922 23.1989 14.4015 23.4057 14.4415 23.6657C14.4692 23.8567 14.5246 24.1449 14.5647 24.3078C14.6078 24.4707 14.6817 24.7213 14.734 24.8623C14.7833 25.0064 14.888 25.2507 14.965 25.4042C15.042 25.5577 15.162 25.7801 15.2298 25.896C15.3006 26.015 15.4207 26.1936 15.4977 26.297C15.5747 26.4003 15.7225 26.582 15.8271 26.701C15.9288 26.8201 16.1351 27.03 16.289 27.1647C16.4399 27.3025 16.7109 27.5124 16.8895 27.6345C17.0681 27.7536 17.3637 27.929 17.5515 28.0198C17.7393 28.1107 18.0349 28.236 18.2135 28.2955C18.3921 28.3581 18.6754 28.4364 18.8448 28.4709C19.0141 28.5085 19.3467 28.5523 19.5838 28.5711C19.9133 28.5993 20.1134 28.5993 20.4306 28.5711C20.6584 28.5523 20.9848 28.5085 21.1542 28.4709C21.3235 28.4364 21.6068 28.3581 21.7854 28.2955C21.964 28.236 22.2596 28.1107 22.4474 28.0198C22.6353 27.929 22.9309 27.7536 23.1095 27.6345C23.2881 27.5124 23.559 27.3025 23.7099 27.1647C23.8608 27.03 24.0702 26.8201 24.1718 26.701C24.2765 26.582 24.4243 26.4003 24.5013 26.297C24.5783 26.1936 24.6983 26.015 24.7692 25.896C24.8369 25.7801 24.957 25.5577 25.034 25.4042C25.111 25.2507 25.2157 25.0064 25.2649 24.8623C25.3173 24.7213 25.3912 24.4707 25.4343 24.3078C25.4743 24.1449 25.5297 23.8567 25.5574 23.6657C25.5975 23.4025 25.6067 23.202 25.5944 22.8199C25.5821 22.4001 25.5636 22.2592 25.4866 21.9584C25.4374 21.7611 25.345 21.451 25.2803 21.2693C25.2187 21.0876 25.0771 20.7274 24.9662 20.4705C24.8554 20.2105 24.6799 19.8315 24.5783 19.6247C24.4766 19.418 24.2673 19.017 24.1102 18.732C23.9532 18.4469 23.7099 18.0178 23.5652 17.7766C23.4205 17.5354 23.1895 17.1563 23.0479 16.9308C22.9093 16.7053 22.5829 16.2072 22.3274 15.8188C22.0687 15.4303 21.6376 14.8038 21.3697 14.4248C21.1018 14.0458 20.6892 13.4788 20.4552 13.1655Z"
            fill="url(#paint8_linear_139_6175)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6175"
          x="6.32964"
          y="6.58855"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6175" />
        </filter>
        <filter
          id="filter1_i_139_6175"
          x="7.58392"
          y="7.82007"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.297222 0 0 0 0 0.329917 0 0 0 0 0.445833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6175" />
        </filter>
        <filter
          id="filter2_d_139_6175"
          x="14.2881"
          y="12.4809"
          width="11.6455"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6175" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6175" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6175"
          x1="13.28"
          y1="6.48"
          x2="27.68"
          y2="35.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="1" stopColor="#B8BAC2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6175"
          x1="13.1521"
          y1="8.84792"
          x2="25.5681"
          y2="31.7599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDCFD6" />
          <stop offset="1" stopColor="#EFEFF1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6175"
          x1="14.4961"
          y1="8.01592"
          x2="27.8721"
          y2="32.0799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDDFE2" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6175"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.0639 20.5849) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#F5F7FF" />
          <stop offset="1" stopColor="#B3B5C5" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6175"
          x1="20.0639"
          y1="5.52222"
          x2="20.0639"
          y2="35.6464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6175"
          x1="4.65588"
          y1="8.24754"
          x2="19.7179"
          y2="34.3358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6175"
          x1="34.3498"
          y1="8.24758"
          x2="19.2877"
          y2="34.3358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6175"
          x1="20.0638"
          y1="25.8918"
          x2="19.9885"
          y2="34.0681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#D0DBFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6175"
          x1="16.5708"
          y1="17.1637"
          x2="21.1422"
          y2="24.0209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WaterTypeGoldLevel = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="18" transform="matrix(1 0 0 -1 2 36)" fill="white" stroke="white" strokeWidth="2" />
      <g opacity="0.7">
        <path
          d="M3 18.9704L3 18.2142C3 12.3526 6.20522 6.96023 11.3542 4.15921C16.1215 1.56585 21.8785 1.56585 26.6458 4.15921C31.7948 6.96023 35 12.3526 35 18.2142V18.9705C35 24.832 31.7948 30.2244 26.6458 33.0254C21.8785 35.6188 16.1215 35.6188 11.3542 33.0254C6.20521 30.2244 3 24.832 3 18.9704Z"
          fill="url(#paint0_linear_139_6196)"
        />
        <path
          d="M5.43201 18.8804L5.43201 18.24C5.43201 13.2764 8.14619 8.71009 12.5064 6.33819C16.5434 4.14212 21.4183 4.14212 25.4553 6.33819C29.8155 8.71009 32.5296 13.2764 32.5296 18.24V18.8804C32.5296 23.844 29.8155 28.4102 25.4553 30.7821C21.4183 32.9782 16.5433 32.9782 12.5064 30.7821C8.14618 28.4102 5.43201 23.844 5.43201 18.8804Z"
          fill="url(#paint1_linear_139_6196)"
        />
        <g filter="url(#filter0_f_139_6196)">
          <path
            d="M5.43201 18.8804L5.43201 18.24C5.43201 13.2764 8.14619 8.71009 12.5064 6.33819C16.5434 4.14212 21.4183 4.14212 25.4553 6.33819C29.8155 8.71009 32.5296 13.2764 32.5296 18.24V18.8804C32.5296 23.844 29.8155 28.4102 25.4553 30.7821C21.4183 32.9782 16.5433 32.9782 12.5064 30.7821C8.14618 28.4102 5.43201 23.844 5.43201 18.8804Z"
            stroke="url(#paint2_linear_139_6196)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6196" maskUnits="userSpaceOnUse" x="6" y="5" width="26" height="27">
            <path
              d="M6.58405 18.87V18.3003C6.58405 13.7266 9.08594 9.51929 13.1045 7.33521C16.8208 5.31539 21.3073 5.31539 25.0236 7.33521C29.0421 9.5193 31.544 13.7266 31.544 18.3003V18.87C31.544 23.4437 29.0421 27.651 25.0236 29.8351C21.3073 31.8549 16.8208 31.8549 13.1045 29.8351C9.08594 27.651 6.58405 23.4437 6.58405 18.87Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6196)">
            <path
              d="M6.58405 18.87V18.3003C6.58405 13.7266 9.08594 9.51929 13.1045 7.33521C16.8208 5.31539 21.3073 5.31539 25.0236 7.33521C29.0421 9.5193 31.544 13.7266 31.544 18.3003V18.87C31.544 23.4437 29.0421 27.651 25.0236 29.8351C21.3073 31.8549 16.8208 31.8549 13.1045 29.8351C9.08594 27.651 6.58405 23.4437 6.58405 18.87Z"
              fill="url(#paint3_radial_139_6196)"
            />
            <path
              opacity="0.5"
              d="M16.9426 31.5603L16.5236 6.10394C16.5003 4.68502 17.6441 3.52222 19.0632 3.52222C20.4823 3.52222 21.6261 4.68502 21.6028 6.10394L21.1839 31.5603C21.1648 32.7179 20.221 33.6464 19.0632 33.6464C17.9055 33.6464 16.9616 32.7179 16.9426 31.5603Z"
              fill="url(#paint4_linear_139_6196)"
            />
            <path
              opacity="0.5"
              d="M15.838 31.5898L2.74697 9.75341C2.01728 8.53626 2.42646 6.95734 3.65545 6.24778C4.88444 5.53823 6.45641 5.97333 7.14565 7.21383L19.511 29.4692C20.0733 30.4812 19.7202 31.7572 18.7175 32.3361C17.7149 32.9149 16.4333 32.5828 15.838 31.5898Z"
              fill="url(#paint5_linear_139_6196)"
            />
            <path
              opacity="0.5"
              d="M17.4935 29.4692L29.8589 7.21387C30.5481 5.97337 32.1201 5.53827 33.3491 6.24782C34.5781 6.95738 34.9873 8.5363 34.2576 9.75345L21.1666 31.5899C20.5713 32.5828 19.2897 32.915 18.287 32.3361C17.2844 31.7572 16.9312 30.4812 17.4935 29.4692Z"
              fill="url(#paint6_linear_139_6196)"
            />
            <rect
              x="6.58325"
              y="16.863"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6196)"
            />
            <g filter="url(#filter1_i_139_6196)">
              <path
                d="M6.58405 18.87V18.3003C6.58405 13.7266 9.08594 9.51929 13.1045 7.33521C16.8208 5.31539 21.3073 5.31539 25.0236 7.33521C29.0421 9.5193 31.544 13.7266 31.544 18.3003V18.87C31.544 23.4437 29.0421 27.651 25.0236 29.8351C21.3073 31.8549 16.8208 31.8549 13.1045 29.8351C9.08594 27.651 6.58405 23.4437 6.58405 18.87Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6196)">
          <path
            d="M19.4559 11.5732C19.2219 11.2569 19.0187 11 19.0002 11C18.9848 11 18.7785 11.2569 18.5476 11.567C18.3135 11.8802 17.8855 12.4691 17.5961 12.8764C17.3066 13.2836 16.8817 13.8976 16.6539 14.2421C16.4229 14.5867 16.1211 15.0503 15.9826 15.2759C15.8409 15.5014 15.5915 15.9086 15.4283 16.1843C15.2651 16.4599 15.0311 16.8609 14.9141 17.077C14.794 17.2932 14.5815 17.7004 14.443 17.9855C14.3044 18.2705 14.1258 18.6433 14.0519 18.8156C13.9749 18.9879 13.8518 19.298 13.7748 19.5047C13.6978 19.7115 13.587 20.0717 13.5285 20.3035C13.433 20.6763 13.4176 20.7859 13.4053 21.2276C13.393 21.6066 13.4022 21.8134 13.4422 22.0734C13.47 22.2645 13.5254 22.5526 13.5654 22.7155C13.6085 22.8784 13.6824 23.129 13.7348 23.27C13.784 23.4141 13.8887 23.6584 13.9657 23.8119C14.0427 23.9654 14.1628 24.1878 14.2305 24.3037C14.3013 24.4227 14.4214 24.6013 14.4984 24.7047C14.5754 24.808 14.7232 24.9897 14.8279 25.1088C14.9295 25.2278 15.1358 25.4377 15.2898 25.5724C15.4406 25.7102 15.7116 25.9201 15.8902 26.0422C16.0688 26.1613 16.3644 26.3367 16.5522 26.4275C16.7401 26.5184 17.0357 26.6437 17.2143 26.7032C17.3929 26.7658 17.6761 26.8442 17.8455 26.8786C18.0149 26.9162 18.3474 26.9601 18.5845 26.9789C18.914 27.007 19.1141 27.007 19.4313 26.9789C19.6592 26.9601 19.9856 26.9162 20.1549 26.8786C20.3243 26.8442 20.6076 26.7658 20.7861 26.7032C20.9647 26.6437 21.2603 26.5184 21.4482 26.4275C21.636 26.3367 21.9316 26.1613 22.1102 26.0422C22.2888 25.9201 22.5598 25.7102 22.7107 25.5724C22.8615 25.4377 23.0709 25.2278 23.1725 25.1088C23.2772 24.9897 23.425 24.808 23.502 24.7047C23.579 24.6013 23.6991 24.4227 23.7699 24.3037C23.8376 24.1878 23.9577 23.9654 24.0347 23.8119C24.1117 23.6584 24.2164 23.4141 24.2657 23.27C24.318 23.129 24.3919 22.8784 24.435 22.7155C24.475 22.5526 24.5305 22.2645 24.5582 22.0734C24.5982 21.8102 24.6074 21.6098 24.5951 21.2276C24.5828 20.8078 24.5643 20.6669 24.4874 20.3662C24.4381 20.1688 24.3457 19.8587 24.281 19.677C24.2195 19.4953 24.0778 19.1351 23.967 18.8782C23.8561 18.6182 23.6806 18.2392 23.579 18.0325C23.4774 17.8257 23.268 17.4247 23.1109 17.1397C22.9539 16.8546 22.7107 16.4255 22.5659 16.1843C22.4212 15.9431 22.1903 15.564 22.0486 15.3385C21.9101 15.113 21.5837 14.6149 21.3281 14.2265C21.0694 13.838 20.6383 13.2115 20.3705 12.8325C20.1026 12.4535 19.69 11.8865 19.4559 11.5732Z"
            fill="url(#paint8_linear_139_6196)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6196"
          x="5.32958"
          y="4.5888"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6196" />
        </filter>
        <filter
          id="filter1_i_139_6196"
          x="6.58405"
          y="5.82031"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.860689" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.458333 0 0 0 0 0.256743 0 0 0 0 0.0706597 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6196" />
        </filter>
        <filter
          id="filter2_d_139_6196"
          x="13.2888"
          y="10.8886"
          width="11.6455"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6196" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6196" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6196"
          x1="12.28"
          y1="4.48"
          x2="26.68"
          y2="33.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DE" />
          <stop offset="1" stopColor="#CFA365" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6196"
          x1="12.152"
          y1="6.84816"
          x2="24.568"
          y2="29.7602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2A86C" />
          <stop offset="1" stopColor="#F8E6C0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6196"
          x1="13.496"
          y1="6.01616"
          x2="26.872"
          y2="30.0802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E7" />
          <stop offset="1" stopColor="#FFF8EC" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6196"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.064 18.5852) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#FFE4BA" />
          <stop offset="1" stopColor="#DEA44D" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6196"
          x1="19.0632"
          y1="3.52222"
          x2="19.0632"
          y2="33.6464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6196"
          x1="3.65545"
          y1="6.24778"
          x2="18.7175"
          y2="32.3361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6196"
          x1="33.3491"
          y1="6.24782"
          x2="18.287"
          y2="32.3361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6196"
          x1="19.0633"
          y1="23.892"
          x2="18.988"
          y2="32.0684"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#FFF1E3" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6196"
          x1="15.5715"
          y1="15.5714"
          x2="20.143"
          y2="22.4286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EnergyTypeBronzeLevel = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="18" transform="matrix(1 0 0 -1 2 36)" fill="white" stroke="white" strokeWidth="2" />
      <path
        d="M3 19.3782L3 18.6219C3 12.7603 6.20522 7.36794 11.3542 4.56693C16.1215 1.97356 21.8785 1.97356 26.6458 4.56693C31.7948 7.36794 35 12.7603 35 18.6219V19.3782C35 25.2398 31.7948 30.6321 26.6458 33.4331C21.8785 36.0265 16.1215 36.0265 11.3542 33.4331C6.20521 30.6321 3 25.2397 3 19.3782Z"
        fill="url(#paint0_linear_139_6220)"
      />
      <path
        d="M5.43201 19.2878L5.43201 18.6474C5.43201 13.6838 8.14619 9.11756 12.5064 6.74566C16.5434 4.54959 21.4183 4.54959 25.4553 6.74566C29.8155 9.11756 32.5296 13.6838 32.5296 18.6474V19.2878C32.5296 24.2514 29.8155 28.8177 25.4553 31.1896C21.4183 33.3857 16.5433 33.3857 12.5064 31.1896C8.14618 28.8177 5.43201 24.2514 5.43201 19.2878Z"
        fill="url(#paint1_linear_139_6220)"
      />
      <g filter="url(#filter0_f_139_6220)">
        <path
          d="M5.43201 19.2878L5.43201 18.6474C5.43201 13.6838 8.14619 9.11756 12.5064 6.74566C16.5434 4.54959 21.4183 4.54959 25.4553 6.74566C29.8155 9.11756 32.5296 13.6838 32.5296 18.6474V19.2878C32.5296 24.2514 29.8155 28.8177 25.4553 31.1896C21.4183 33.3857 16.5433 33.3857 12.5064 31.1896C8.14618 28.8177 5.43201 24.2514 5.43201 19.2878Z"
          stroke="url(#paint2_linear_139_6220)"
          strokeWidth="0.128"
        />
      </g>
      <g opacity="0.5">
        <mask id="mask0_139_6220" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="26">
          <path
            d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
            fill="#A6D3DE"
          />
        </mask>
        <g mask="url(#mask0_139_6220)">
          <path
            d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
            fill="url(#paint3_radial_139_6220)"
          />
          <path
            opacity="0.5"
            d="M16.9433 31.968L16.5244 6.51165C16.501 5.09273 17.6448 3.92993 19.0639 3.92993C20.4831 3.92993 21.6269 5.09273 21.6035 6.51165L21.1846 31.968C21.1655 33.1256 20.2217 34.0541 19.0639 34.0541C17.9062 34.0541 16.9624 33.1256 16.9433 31.968Z"
            fill="url(#paint4_linear_139_6220)"
          />
          <path
            opacity="0.5"
            d="M15.8386 31.9975L2.74758 10.1611C2.01789 8.94398 2.42707 7.36506 3.65606 6.6555C4.88505 5.94594 6.45702 6.38105 7.14626 7.62154L19.5116 29.8769C20.0739 30.8889 19.7208 32.1649 18.7181 32.7438C17.7155 33.3226 16.4339 32.9905 15.8386 31.9975Z"
            fill="url(#paint5_linear_139_6220)"
          />
          <path
            opacity="0.5"
            d="M17.4943 29.8767L29.8596 7.62134C30.5489 6.38084 32.1209 5.94574 33.3498 6.65529C34.5788 7.36485 34.988 8.94377 34.2583 10.1609L21.1673 31.9973C20.572 32.9903 19.2904 33.3224 18.2878 32.7436C17.2851 32.1647 16.932 30.8887 17.4943 29.8767Z"
            fill="url(#paint6_linear_139_6220)"
          />
          <rect
            x="6.5838"
            y="17.2705"
            width="24.96"
            height="16.2097"
            rx="8.10483"
            fill="url(#paint7_linear_139_6220)"
          />
          <g filter="url(#filter1_i_139_6220)">
            <path
              d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
              fill="#F5C4AF"
              fillOpacity="0.03"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_139_6220)">
        <path
          d="M21.489 11.0135C21.489 11.004 21.4789 10.9977 21.4654 11.0008H21.4621C21.4486 11.0008 19.768 13.1684 17.7244 15.8153C15.6807 18.4621 14.0068 20.6456 14.0001 20.6678C13.9933 20.7027 14.4572 20.709 16.4639 20.709C18.8033 20.709 18.9344 20.7122 18.9142 20.7662C18.9042 20.7947 18.3596 22.2038 17.7042 23.8985C17.0487 25.5933 16.521 26.9833 16.5311 26.9929C16.5412 27.0024 16.5513 27.0024 16.558 26.9929C16.5647 26.9833 18.2386 24.8126 20.2823 22.1689C22.3226 19.5284 23.9965 17.345 23.9998 17.3227C24.0099 17.2878 23.5461 17.2815 21.5394 17.2815C19.2 17.2815 19.0689 17.2783 19.089 17.2275C19.0991 17.1958 19.6436 15.7899 20.2991 14.1015C20.9545 12.4099 21.489 11.023 21.489 11.0135Z"
          fill="url(#paint8_linear_139_6220)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_139_6220"
          x="5.29118"
          y="4.95787"
          width="27.3792"
          height="28.0196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0384" result="effect1_foregroundBlur_139_6220" />
        </filter>
        <filter
          id="filter1_i_139_6220"
          x="6.58386"
          y="6.22778"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.283333 0 0 0 0 0.158667 0 0 0 0 0.0566667 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6220" />
        </filter>
        <filter
          id="filter2_d_139_6220"
          x="13.8886"
          y="10.8886"
          width="10.4454"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6220" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6220" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6220"
          x1="12.28"
          y1="4.88771"
          x2="26.68"
          y2="33.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1DCC1" />
          <stop offset="1" stopColor="#BD8A65" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6220"
          x1="12.152"
          y1="7.25563"
          x2="24.568"
          y2="30.1676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BF8E69" />
          <stop offset="1" stopColor="#E4C196" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6220"
          x1="13.496"
          y1="6.42363"
          x2="26.872"
          y2="30.4876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD4B7" />
          <stop offset="1" stopColor="#FFE3CE" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6220"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0639 18.9926) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#E3C29C" />
          <stop offset="1" stopColor="#D1A479" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6220"
          x1="19.0639"
          y1="3.92993"
          x2="19.0639"
          y2="34.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6220"
          x1="3.65606"
          y1="6.6555"
          x2="18.7181"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6220"
          x1="33.3498"
          y1="6.65529"
          x2="18.2878"
          y2="32.7436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6220"
          x1="19.0638"
          y1="24.2995"
          x2="18.9885"
          y2="32.4758"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291667" stopColor="#FFFAF7" stopOpacity="0" />
          <stop offset="1" stopColor="#E4CBAD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6220"
          x1="15.9387"
          y1="15.5714"
          x2="20.687"
          y2="21.9308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EnergyTypeSilverLevel = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18.4167"
        transform="matrix(1 0 0 -1 3 37)"
        fill="white"
        stroke="white"
        strokeWidth="2.83333"
      />
      <g opacity="0.7">
        <path
          d="M4 20.3782L4 19.6219C4 13.7603 7.20522 8.36794 12.3542 5.56693C17.1215 2.97356 22.8785 2.97356 27.6458 5.56693C32.7948 8.36794 36 13.7603 36 19.6219V20.3782C36 26.2398 32.7948 31.6321 27.6458 34.4331C22.8785 37.0265 17.1215 37.0265 12.3542 34.4331C7.20521 31.6321 4 26.2397 4 20.3782Z"
          fill="url(#paint0_linear_139_6241)"
        />
        <path
          d="M6.43207 20.2878L6.43207 19.6474C6.43207 14.6838 9.14625 10.1176 13.5065 7.74566C17.5434 5.54959 22.4184 5.54959 26.4553 7.74566C30.8155 10.1176 33.5297 14.6838 33.5297 19.6474V20.2878C33.5297 25.2514 30.8155 29.8177 26.4553 32.1896C22.4184 34.3857 17.5434 34.3857 13.5064 32.1896C9.14624 29.8177 6.43207 25.2514 6.43207 20.2878Z"
          fill="url(#paint1_linear_139_6241)"
        />
        <g filter="url(#filter0_f_139_6241)">
          <path
            d="M6.43207 20.2878L6.43207 19.6474C6.43207 14.6838 9.14625 10.1176 13.5065 7.74566C17.5434 5.54959 22.4184 5.54959 26.4553 7.74566C30.8155 10.1176 33.5297 14.6838 33.5297 19.6474V20.2878C33.5297 25.2514 30.8155 29.8177 26.4553 32.1896C22.4184 34.3857 17.5434 34.3857 13.5064 32.1896C9.14624 29.8177 6.43207 25.2514 6.43207 20.2878Z"
            stroke="url(#paint2_linear_139_6241)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6241" maskUnits="userSpaceOnUse" x="7" y="7" width="26" height="26">
            <path
              d="M7.58392 20.2775V19.7078C7.58393 15.1341 10.0858 10.9268 14.1044 8.74268C17.8207 6.72286 22.3072 6.72286 26.0235 8.74268C30.042 10.9268 32.5439 15.1341 32.5439 19.7078V20.2775C32.5439 24.8512 30.042 29.0585 26.0235 31.2426C22.3072 33.2624 17.8207 33.2624 14.1044 31.2426C10.0858 29.0585 7.58392 24.8512 7.58392 20.2775Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6241)">
            <path
              d="M7.58392 20.2775V19.7078C7.58393 15.1341 10.0858 10.9268 14.1044 8.74268C17.8207 6.72286 22.3072 6.72286 26.0235 8.74268C30.042 10.9268 32.5439 15.1341 32.5439 19.7078V20.2775C32.5439 24.8512 30.042 29.0585 26.0235 31.2426C22.3072 33.2624 17.8207 33.2624 14.1044 31.2426C10.0858 29.0585 7.58392 24.8512 7.58392 20.2775Z"
              fill="url(#paint3_radial_139_6241)"
            />
            <path
              opacity="0.5"
              d="M17.9433 32.968L17.5244 7.51165C17.501 6.09273 18.6448 4.92993 20.0639 4.92993C21.4831 4.92993 22.6269 6.09273 22.6035 7.51165L22.1846 32.968C22.1655 34.1256 21.2217 35.0541 20.0639 35.0541C18.9062 35.0541 17.9624 34.1256 17.9433 32.968Z"
              fill="url(#paint4_linear_139_6241)"
            />
            <path
              opacity="0.5"
              d="M16.8384 32.9973L3.74739 11.1609C3.01771 9.94373 3.42689 8.36481 4.65588 7.65525C5.88486 6.9457 7.45684 7.3808 8.14608 8.6213L20.5115 30.8766C21.0738 31.8887 20.7206 33.1646 19.7179 33.7435C18.7153 34.3224 17.4337 33.9903 16.8384 32.9973Z"
              fill="url(#paint5_linear_139_6241)"
            />
            <path
              opacity="0.5"
              d="M18.4942 30.8767L30.8596 8.62134C31.5488 7.38084 33.1208 6.94574 34.3498 7.65529C35.5788 8.36485 35.988 9.94377 35.2583 11.1609L22.1673 32.9973C21.572 33.9903 20.2904 34.3224 19.2877 33.7436C18.2851 33.1647 17.9319 31.8887 18.4942 30.8767Z"
              fill="url(#paint6_linear_139_6241)"
            />
            <rect
              x="7.5838"
              y="18.2705"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6241)"
            />
            <g filter="url(#filter1_i_139_6241)">
              <path
                d="M7.58392 20.2775V19.7078C7.58393 15.1341 10.0858 10.9268 14.1044 8.74268C17.8207 6.72286 22.3072 6.72286 26.0235 8.74268C30.042 10.9268 32.5439 15.1341 32.5439 19.7078V20.2775C32.5439 24.8512 30.042 29.0585 26.0235 31.2426C22.3072 33.2624 17.8207 33.2624 14.1044 31.2426C10.0858 29.0585 7.58392 24.8512 7.58392 20.2775Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6241)">
          <path
            d="M22.425 12.0208C22.425 12.0113 22.4149 12.005 22.4015 12.0081H22.3981C22.3847 12.0081 20.704 14.1758 18.6604 16.8226C16.6167 19.4694 14.9428 21.6529 14.9361 21.6751C14.9294 21.71 15.3932 21.7164 17.3999 21.7164C19.7394 21.7164 19.8704 21.7195 19.8503 21.7735C19.8402 21.802 19.2957 23.2111 18.6402 24.9059C17.9848 26.6006 17.4571 27.9907 17.4671 28.0002C17.4772 28.0097 17.4873 28.0097 17.494 28.0002C17.5008 27.9907 19.1747 25.8199 21.2183 23.1762C23.2586 20.5358 24.9325 18.3523 24.9359 18.3301C24.946 18.2952 24.4821 18.2888 22.4754 18.2888C20.136 18.2888 20.0049 18.2856 20.0251 18.2349C20.0351 18.2031 20.5797 16.7972 21.2351 15.1088C21.8906 13.4173 22.425 12.0304 22.425 12.0208Z"
            fill="url(#paint8_linear_139_6241)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6241"
          x="6.32964"
          y="5.99627"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6241" />
        </filter>
        <filter
          id="filter1_i_139_6241"
          x="7.58392"
          y="7.22778"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.297222 0 0 0 0 0.329917 0 0 0 0 0.445833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6241" />
        </filter>
        <filter
          id="filter2_d_139_6241"
          x="14.8247"
          y="11.896"
          width="10.4454"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6241" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6241" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6241"
          x1="13.28"
          y1="5.88771"
          x2="27.68"
          y2="34.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="1" stopColor="#B8BAC2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6241"
          x1="13.1521"
          y1="8.25563"
          x2="25.5681"
          y2="31.1676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDCFD6" />
          <stop offset="1" stopColor="#EFEFF1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6241"
          x1="14.4961"
          y1="7.42363"
          x2="27.8721"
          y2="31.4876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDDFE2" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6241"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.0639 19.9926) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#F5F7FF" />
          <stop offset="1" stopColor="#B3B5C5" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6241"
          x1="20.0639"
          y1="4.92993"
          x2="20.0639"
          y2="35.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6241"
          x1="4.65588"
          y1="7.65525"
          x2="19.7179"
          y2="33.7435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6241"
          x1="34.3498"
          y1="7.65529"
          x2="19.2877"
          y2="33.7436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6241"
          x1="20.0638"
          y1="25.2995"
          x2="19.9885"
          y2="33.4758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#D0DBFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6241"
          x1="16.8747"
          y1="16.5788"
          x2="21.623"
          y2="22.9381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4F4F4" />
          <stop offset="1" stopColor="#CDCED5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EnergyTypeGoldLevel = () => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="18" transform="matrix(1 0 0 -1 2 36)" fill="white" stroke="white" strokeWidth="2" />
      <g opacity="0.7">
        <path
          d="M3 19.3782L3 18.6219C3 12.7603 6.20522 7.36794 11.3542 4.56693C16.1215 1.97356 21.8785 1.97356 26.6458 4.56693C31.7948 7.36794 35 12.7603 35 18.6219V19.3782C35 25.2398 31.7948 30.6321 26.6458 33.4331C21.8785 36.0265 16.1215 36.0265 11.3542 33.4331C6.20521 30.6321 3 25.2397 3 19.3782Z"
          fill="url(#paint0_linear_139_6262)"
        />
        <path
          d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
          fill="url(#paint1_linear_139_6262)"
        />
        <g filter="url(#filter0_f_139_6262)">
          <path
            d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
            stroke="url(#paint2_linear_139_6262)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6262" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="26">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6262)">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="url(#paint3_radial_139_6262)"
            />
            <path
              opacity="0.5"
              d="M16.9424 31.968L16.5234 6.51165C16.5001 5.09273 17.6439 3.92993 19.063 3.92993C20.4821 3.92993 21.626 5.09273 21.6026 6.51165L21.1837 31.968C21.1646 33.1256 20.2208 34.0541 19.063 34.0541C17.9053 34.0541 16.9614 33.1256 16.9424 31.968Z"
              fill="url(#paint4_linear_139_6262)"
            />
            <path
              opacity="0.5"
              d="M15.8379 31.9975L2.74684 10.1611C2.01716 8.94398 2.42634 7.36506 3.65533 6.6555C4.88431 5.94594 6.45629 6.38105 7.14553 7.62154L19.5109 29.8769C20.0732 30.8889 19.72 32.1649 18.7174 32.7438C17.7148 33.3226 16.4331 32.9905 15.8379 31.9975Z"
              fill="url(#paint5_linear_139_6262)"
            />
            <path
              opacity="0.5"
              d="M17.4933 29.8769L29.8587 7.62158C30.548 6.38108 32.1199 5.94598 33.3489 6.65554C34.5779 7.36509 34.9871 8.94402 34.2574 10.1612L21.1664 31.9976C20.5711 32.9905 19.2895 33.3227 18.2869 32.7438C17.2842 32.1649 16.931 30.889 17.4933 29.8769Z"
              fill="url(#paint6_linear_139_6262)"
            />
            <rect
              x="6.58313"
              y="17.2708"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6262)"
            />
            <g filter="url(#filter1_i_139_6262)">
              <path
                d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6262)">
          <path
            d="M21.425 11.0208C21.425 11.0113 21.4149 11.005 21.4015 11.0081H21.3981C21.3847 11.0081 19.704 13.1758 17.6604 15.8226C15.6167 18.4694 13.9428 20.6529 13.9361 20.6751C13.9294 20.71 14.3932 20.7164 16.3999 20.7164C18.7394 20.7164 18.8704 20.7195 18.8503 20.7735C18.8402 20.802 18.2957 22.2111 17.6402 23.9059C16.9848 25.6006 16.4571 26.9907 16.4671 27.0002C16.4772 27.0097 16.4873 27.0097 16.494 27.0002C16.5008 26.9907 18.1747 24.8199 20.2183 22.1762C22.2586 19.5358 23.9325 17.3523 23.9359 17.3301C23.946 17.2952 23.4821 17.2888 21.4754 17.2888C19.136 17.2888 19.0049 17.2856 19.0251 17.2349C19.0351 17.2031 19.5797 15.7972 20.2351 14.1088C20.8906 12.4173 21.425 11.0304 21.425 11.0208Z"
            fill="url(#paint8_linear_139_6262)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6262"
          x="5.32964"
          y="4.99651"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6262" />
        </filter>
        <filter
          id="filter1_i_139_6262"
          x="6.58398"
          y="6.22803"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.860689" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.458333 0 0 0 0 0.256743 0 0 0 0 0.0706597 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6262" />
        </filter>
        <filter
          id="filter2_d_139_6262"
          x="13.8247"
          y="10.896"
          width="10.4454"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6262" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6262" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6262"
          x1="12.28"
          y1="4.88771"
          x2="26.68"
          y2="33.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DE" />
          <stop offset="1" stopColor="#CFA365" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6262"
          x1="12.152"
          y1="7.25588"
          x2="24.568"
          y2="30.1679"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2A86C" />
          <stop offset="1" stopColor="#F8E6C0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6262"
          x1="13.496"
          y1="6.42388"
          x2="26.872"
          y2="30.4879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E7" />
          <stop offset="1" stopColor="#FFF8EC" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6262"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.064 18.9929) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#FFE4BA" />
          <stop offset="1" stopColor="#DEA44D" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6262"
          x1="19.063"
          y1="3.92993"
          x2="19.063"
          y2="34.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6262"
          x1="3.65533"
          y1="6.6555"
          x2="18.7174"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6262"
          x1="33.3489"
          y1="6.65554"
          x2="18.2869"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6262"
          x1="19.0631"
          y1="24.2997"
          x2="18.9878"
          y2="32.4761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#FFF1E3" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6262"
          x1="15.8747"
          y1="15.5788"
          x2="20.623"
          y2="21.9381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WasteTypeBronzeLevel = () => {
  return (
    <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18"
        transform="matrix(1 0 0 -1 2 36.5923)"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M3 19.9704L3 19.2142C3 13.3526 6.20522 7.96023 11.3542 5.15921C16.1215 2.56585 21.8785 2.56585 26.6458 5.15921C31.7948 7.96023 35 13.3526 35 19.2142V19.9705C35 25.832 31.7948 31.2244 26.6458 34.0254C21.8785 36.6188 16.1215 36.6188 11.3542 34.0254C6.20521 31.2244 3 25.832 3 19.9704Z"
        fill="url(#paint0_linear_139_6286)"
      />
      <path
        d="M5.43201 19.8801L5.43201 19.2397C5.43201 14.2761 8.14619 9.70985 12.5064 7.33794C16.5434 5.14188 21.4183 5.14188 25.4553 7.33794C29.8155 9.70985 32.5296 14.2761 32.5296 19.2397V19.8801C32.5296 24.8437 29.8155 29.41 25.4553 31.7819C21.4183 33.978 16.5433 33.978 12.5064 31.7819C8.14618 29.41 5.43201 24.8437 5.43201 19.8801Z"
        fill="url(#paint1_linear_139_6286)"
      />
      <g filter="url(#filter0_f_139_6286)">
        <path
          d="M5.43201 19.8801L5.43201 19.2397C5.43201 14.2761 8.14619 9.70985 12.5064 7.33794C16.5434 5.14188 21.4183 5.14188 25.4553 7.33794C29.8155 9.70985 32.5296 14.2761 32.5296 19.2397V19.8801C32.5296 24.8437 29.8155 29.41 25.4553 31.7819C21.4183 33.978 16.5433 33.978 12.5064 31.7819C8.14618 29.41 5.43201 24.8437 5.43201 19.8801Z"
          stroke="url(#paint2_linear_139_6286)"
          strokeWidth="0.128"
        />
      </g>
      <g opacity="0.5">
        <mask id="mask0_139_6286" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="27">
          <path
            d="M6.58386 19.8697V19.3001C6.58387 14.7264 9.08576 10.5191 13.1043 8.33497C16.8206 6.31514 21.3071 6.31514 25.0234 8.33497C29.042 10.5191 31.5439 14.7264 31.5439 19.3001V19.8697C31.5439 24.4435 29.042 28.6508 25.0234 30.8349C21.3071 32.8547 16.8206 32.8547 13.1043 30.8349C9.08575 28.6508 6.58386 24.4435 6.58386 19.8697Z"
            fill="#A6D3DE"
          />
        </mask>
        <g mask="url(#mask0_139_6286)">
          <path
            d="M6.58386 19.8697V19.3001C6.58387 14.7264 9.08576 10.5191 13.1043 8.33497C16.8206 6.31514 21.3071 6.31514 25.0234 8.33497C29.042 10.5191 31.5439 14.7264 31.5439 19.3001V19.8697C31.5439 24.4435 29.042 28.6508 25.0234 30.8349C21.3071 32.8547 16.8206 32.8547 13.1043 30.8349C9.08575 28.6508 6.58386 24.4435 6.58386 19.8697Z"
            fill="url(#paint3_radial_139_6286)"
          />
          <path
            opacity="0.5"
            d="M16.9432 32.5603L16.5243 7.10394C16.5009 5.68502 17.6448 4.52222 19.0639 4.52222C20.483 4.52222 21.6268 5.68502 21.6035 7.10394L21.1845 32.5603C21.1655 33.7179 20.2216 34.6464 19.0639 34.6464C17.9061 34.6464 16.9623 33.7179 16.9432 32.5603Z"
            fill="url(#paint4_linear_139_6286)"
          />
          <path
            opacity="0.5"
            d="M15.8385 32.5898L2.74746 10.7534C2.01777 9.53626 2.42695 7.95734 3.65594 7.24778C4.88492 6.53823 6.4569 6.97333 7.14614 8.21383L19.5115 30.4692C20.0738 31.4812 19.7206 32.7572 18.718 33.3361C17.7154 33.9149 16.4338 33.5828 15.8385 32.5898Z"
            fill="url(#paint5_linear_139_6286)"
          />
          <path
            opacity="0.5"
            d="M17.4942 30.469L29.8596 8.21362C30.5488 6.97312 32.1208 6.53802 33.3498 7.24758C34.5788 7.95713 34.9879 9.53606 34.2583 10.7532L21.1673 32.5896C20.572 33.5826 19.2904 33.9147 18.2877 33.3358C17.2851 32.757 16.9319 31.481 17.4942 30.469Z"
            fill="url(#paint6_linear_139_6286)"
          />
          <rect
            x="6.58374"
            y="17.8628"
            width="24.96"
            height="16.2097"
            rx="8.10483"
            fill="url(#paint7_linear_139_6286)"
          />
          <g filter="url(#filter1_i_139_6286)">
            <path
              d="M6.58386 19.8697V19.3001C6.58387 14.7264 9.08576 10.5191 13.1043 8.33497C16.8206 6.31514 21.3071 6.31514 25.0234 8.33497C29.042 10.5191 31.5439 14.7264 31.5439 19.3001V19.8697C31.5439 24.4435 29.042 28.6508 25.0234 30.8349C21.3071 32.8547 16.8206 32.8547 13.1043 30.8349C9.08575 28.6508 6.58386 24.4435 6.58386 19.8697Z"
              fill="#F5C4AF"
              fillOpacity="0.03"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_139_6286)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.911 11.6548C22.8002 11.5986 22.7202 11.5954 19.0078 11.5923L18.9999 11.5923L18.9921 11.5923C15.2797 11.5954 15.1996 11.5986 15.0889 11.6548C15.0242 11.6892 14.9472 11.7642 14.9194 11.8173C14.8917 11.8735 14.676 12.6892 14.4419 13.6298L14.0167 15.3423H16.5999V15.346H21.5074V15.3423H23.9831L23.558 13.6298C23.3238 12.6892 23.1082 11.8735 23.0804 11.8173C23.0527 11.7642 22.9757 11.6892 22.911 11.6548ZM24.0232 18.2236L24.0355 18.1548H13.9644L13.9767 18.2236C13.9828 18.2642 14.18 20.2986 14.4172 22.7486C14.7839 26.5267 14.8578 27.2205 14.9102 27.333C14.9533 27.4299 15.0088 27.4861 15.095 27.5299C15.2152 27.5892 15.2799 27.5924 17.113 27.5924H20.8868C22.72 27.5924 22.7847 27.5892 22.9048 27.5299C22.9911 27.4861 23.0465 27.4299 23.0897 27.333C23.142 27.2205 23.216 26.5267 23.5826 22.7486C23.8198 20.2986 24.017 18.2642 24.0232 18.2236ZM24.6458 15.7744H13.3543L13.2311 15.8285C13.1633 15.8567 13.0832 15.913 13.0555 15.9519C13.0092 16.0147 13.0031 16.1078 13 16.7442C13 17.4066 13.0031 17.4694 13.0585 17.5452C13.0924 17.5906 13.1664 17.6448 13.2341 17.6729L13.3543 17.7205L24.6458 17.7205L24.7659 17.6729C24.8337 17.6448 24.9076 17.5906 24.9415 17.5452C24.997 17.4694 25.0001 17.4066 25.0001 16.7442C24.997 16.1078 24.9908 16.0147 24.9446 15.9519C24.9169 15.913 24.8368 15.8567 24.769 15.8285L24.6458 15.7744Z"
          fill="url(#paint8_linear_139_6286)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_139_6286"
          x="5.29124"
          y="5.55015"
          width="27.3792"
          height="28.0196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0384" result="effect1_foregroundBlur_139_6286" />
        </filter>
        <filter
          id="filter1_i_139_6286"
          x="6.58386"
          y="6.82007"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.283333 0 0 0 0 0.158667 0 0 0 0 0.0566667 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6286" />
        </filter>
        <filter
          id="filter2_d_139_6286"
          x="12.8886"
          y="11.4809"
          width="12.4456"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6286" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6286" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6286"
          x1="12.28"
          y1="5.48"
          x2="26.68"
          y2="34.088"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1DCC1" />
          <stop offset="1" stopColor="#BD8A65" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6286"
          x1="12.152"
          y1="7.84792"
          x2="24.568"
          y2="30.7599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BF8E69" />
          <stop offset="1" stopColor="#E4C196" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6286"
          x1="13.496"
          y1="7.01592"
          x2="26.872"
          y2="31.0799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD4B7" />
          <stop offset="1" stopColor="#FFE3CE" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6286"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0639 19.5849) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#E3C29C" />
          <stop offset="1" stopColor="#D1A479" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6286"
          x1="19.0639"
          y1="4.52222"
          x2="19.0639"
          y2="34.6464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6286"
          x1="3.65594"
          y1="7.24778"
          x2="18.718"
          y2="33.3361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6286"
          x1="33.3498"
          y1="7.24758"
          x2="18.2877"
          y2="33.3358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6286"
          x1="19.0637"
          y1="24.8918"
          x2="18.9884"
          y2="33.0681"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291667" stopColor="#FFFAF7" stopOpacity="0" />
          <stop offset="1" stopColor="#E4CBAD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6286"
          x1="15.3264"
          y1="16.1637"
          x2="19.7693"
          y2="23.3041"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WasteTypeSilverLevel = () => {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18.4167"
        transform="matrix(1 0 0 -1 3 37.7527)"
        fill="white"
        stroke="white"
        strokeWidth="2.83333"
      />
      <g opacity="0.7">
        <path
          d="M4 21.3782L4 20.6219C4 14.7603 7.20522 9.36794 12.3542 6.56693C17.1215 3.97356 22.8785 3.97356 27.6458 6.56693C32.7948 9.36794 36 14.7603 36 20.6219V21.3782C36 27.2398 32.7948 32.6321 27.6458 35.4331C22.8785 38.0265 17.1215 38.0265 12.3542 35.4331C7.20521 32.6321 4 27.2397 4 21.3782Z"
          fill="url(#paint0_linear_139_6309)"
        />
        <path
          d="M6.43201 21.2878L6.43201 20.6474C6.43201 15.6838 9.14619 11.1176 13.5064 8.74566C17.5434 6.54959 22.4183 6.54959 26.4553 8.74566C30.8155 11.1176 33.5296 15.6838 33.5296 20.6474V21.2878C33.5296 26.2514 30.8155 30.8177 26.4553 33.1896C22.4183 35.3857 17.5433 35.3857 13.5064 33.1896C9.14618 30.8177 6.43201 26.2514 6.43201 21.2878Z"
          fill="url(#paint1_linear_139_6309)"
        />
        <g filter="url(#filter0_f_139_6309)">
          <path
            d="M6.43201 21.2878L6.43201 20.6474C6.43201 15.6838 9.14619 11.1176 13.5064 8.74566C17.5434 6.54959 22.4183 6.54959 26.4553 8.74566C30.8155 11.1176 33.5296 15.6838 33.5296 20.6474V21.2878C33.5296 26.2514 30.8155 30.8177 26.4553 33.1896C22.4183 35.3857 17.5433 35.3857 13.5064 33.1896C9.14618 30.8177 6.43201 26.2514 6.43201 21.2878Z"
            stroke="url(#paint2_linear_139_6309)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6309" maskUnits="userSpaceOnUse" x="7" y="8" width="26" height="26">
            <path
              d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6309)">
            <path
              d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
              fill="url(#paint3_radial_139_6309)"
            />
            <path
              opacity="0.5"
              d="M17.9432 33.968L17.5243 8.51165C17.5009 7.09273 18.6448 5.92993 20.0639 5.92993C21.483 5.92993 22.6268 7.09273 22.6035 8.51165L22.1845 33.968C22.1655 35.1256 21.2216 36.0541 20.0639 36.0541C18.9061 36.0541 17.9623 35.1256 17.9432 33.968Z"
              fill="url(#paint4_linear_139_6309)"
            />
            <path
              opacity="0.5"
              d="M16.8382 33.9973L3.74721 12.1609C3.01753 10.9437 3.42671 9.36481 4.65569 8.65525C5.88468 7.9457 7.45666 8.3808 8.14589 9.6213L20.5113 31.8766C21.0736 32.8887 20.7204 34.1646 19.7178 34.7435C18.7151 35.3224 17.4335 34.9903 16.8382 33.9973Z"
              fill="url(#paint5_linear_139_6309)"
            />
            <path
              opacity="0.5"
              d="M18.4941 31.8767L30.8595 9.62134C31.5487 8.38084 33.1207 7.94574 34.3497 8.65529C35.5786 9.36485 35.9878 10.9438 35.2581 12.1609L22.1671 33.9973C21.5718 34.9903 20.2902 35.3224 19.2876 34.7436C18.285 34.1647 17.9318 32.8887 18.4941 31.8767Z"
              fill="url(#paint6_linear_139_6309)"
            />
            <rect
              x="7.58362"
              y="19.2705"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6309)"
            />
            <g filter="url(#filter1_i_139_6309)">
              <path
                d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6309)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.911 13.0625C23.8002 13.0063 23.7202 13.0031 20.0078 13L19.9999 13L19.9921 13C16.2797 13.0031 16.1996 13.0063 16.0889 13.0625C16.0242 13.0969 15.9472 13.1719 15.9194 13.225C15.8917 13.2812 15.676 14.0969 15.4419 15.0375L15.0167 16.75H17.5999V16.7537H22.5074V16.75H24.9831L24.558 15.0375C24.3238 14.0969 24.1082 13.2812 24.0804 13.225C24.0527 13.1719 23.9757 13.0969 23.911 13.0625ZM25.0232 19.6313L25.0355 19.5625H14.9644L14.9767 19.6313C14.9828 19.6719 15.18 21.7063 15.4172 24.1563C15.7839 27.9345 15.8578 28.6282 15.9102 28.7407C15.9533 28.8376 16.0088 28.8938 16.095 28.9376C16.2152 28.997 16.2799 29.0001 18.113 29.0001H21.8868C23.72 29.0001 23.7847 28.997 23.9048 28.9376C23.9911 28.8938 24.0465 28.8376 24.0897 28.7407C24.142 28.6282 24.216 27.9345 24.5826 24.1563C24.8198 21.7063 25.017 19.6719 25.0232 19.6313ZM25.6458 17.1821H14.3543L14.2311 17.2362C14.1633 17.2644 14.0832 17.3207 14.0555 17.3596C14.0092 17.4224 14.0031 17.5155 14 18.1519C14 18.8144 14.0031 18.8771 14.0585 18.9529C14.0924 18.9984 14.1664 19.0525 14.2341 19.0806L14.3543 19.1282L25.6458 19.1282L25.7659 19.0806C25.8337 19.0525 25.9076 18.9984 25.9415 18.9529C25.997 18.8771 26.0001 18.8144 26.0001 18.1519C25.997 17.5155 25.9908 17.4224 25.9446 17.3596C25.9169 17.3207 25.8368 17.2644 25.769 17.2362L25.6458 17.1821Z"
            fill="url(#paint8_linear_139_6309)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6309"
          x="6.32964"
          y="6.99627"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6309" />
        </filter>
        <filter
          id="filter1_i_139_6309"
          x="7.58386"
          y="8.22778"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.297222 0 0 0 0 0.329917 0 0 0 0 0.445833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6309" />
        </filter>
        <filter
          id="filter2_d_139_6309"
          x="13.8886"
          y="12.8886"
          width="12.4456"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6309" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6309" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6309"
          x1="13.28"
          y1="6.88771"
          x2="27.68"
          y2="35.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="1" stopColor="#B8BAC2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6309"
          x1="13.152"
          y1="9.25563"
          x2="25.568"
          y2="32.1676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDCFD6" />
          <stop offset="1" stopColor="#EFEFF1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6309"
          x1="14.496"
          y1="8.42363"
          x2="27.872"
          y2="32.4876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDDFE2" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6309"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.0639 20.9926) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#F5F7FF" />
          <stop offset="1" stopColor="#B3B5C5" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6309"
          x1="20.0639"
          y1="5.92993"
          x2="20.0639"
          y2="36.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6309"
          x1="4.65569"
          y1="8.65525"
          x2="19.7178"
          y2="34.7435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6309"
          x1="34.3497"
          y1="8.65529"
          x2="19.2876"
          y2="34.7436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6309"
          x1="20.0636"
          y1="26.2995"
          x2="19.9883"
          y2="34.4758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#D0DBFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6309"
          x1="16.3264"
          y1="17.5715"
          x2="20.7693"
          y2="24.7118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const WasteTypeGoldLevel = () => {
  return (
    <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18"
        transform="matrix(1 0 0 -1 2 36.4077)"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <g opacity="0.7">
        <path
          d="M3 19.3782L3 18.6219C3 12.7603 6.20522 7.36794 11.3542 4.56693C16.1215 1.97356 21.8785 1.97356 26.6458 4.56693C31.7948 7.36794 35 12.7603 35 18.6219V19.3782C35 25.2398 31.7948 30.6321 26.6458 33.4331C21.8785 36.0265 16.1215 36.0265 11.3542 33.4331C6.20521 30.6321 3 25.2397 3 19.3782Z"
          fill="url(#paint0_linear_139_6332)"
        />
        <path
          d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
          fill="url(#paint1_linear_139_6332)"
        />
        <g filter="url(#filter0_f_139_6332)">
          <path
            d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
            stroke="url(#paint2_linear_139_6332)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6332" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="26">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6332)">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="url(#paint3_radial_139_6332)"
            />
            <path
              opacity="0.5"
              d="M16.9424 31.968L16.5234 6.51165C16.5001 5.09273 17.6439 3.92993 19.063 3.92993C20.4821 3.92993 21.626 5.09273 21.6026 6.51165L21.1837 31.968C21.1646 33.1256 20.2208 34.0541 19.063 34.0541C17.9053 34.0541 16.9614 33.1256 16.9424 31.968Z"
              fill="url(#paint4_linear_139_6332)"
            />
            <path
              opacity="0.5"
              d="M15.8379 31.9975L2.74684 10.1611C2.01716 8.94398 2.42634 7.36506 3.65533 6.6555C4.88431 5.94594 6.45629 6.38105 7.14553 7.62154L19.5109 29.8769C20.0732 30.8889 19.72 32.1649 18.7174 32.7438C17.7148 33.3226 16.4331 32.9905 15.8379 31.9975Z"
              fill="url(#paint5_linear_139_6332)"
            />
            <path
              opacity="0.5"
              d="M17.4933 29.8769L29.8587 7.62158C30.548 6.38108 32.1199 5.94598 33.3489 6.65554C34.5779 7.36509 34.9871 8.94402 34.2574 10.1612L21.1664 31.9976C20.5711 32.9905 19.2895 33.3227 18.2869 32.7438C17.2842 32.1649 16.931 30.889 17.4933 29.8769Z"
              fill="url(#paint6_linear_139_6332)"
            />
            <rect
              x="6.58313"
              y="17.2708"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6332)"
            />
            <g filter="url(#filter1_i_139_6332)">
              <path
                d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6332)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.911 11.4702C22.8002 11.414 22.7202 11.4108 19.0078 11.4077L18.9999 11.4077L18.9921 11.4077C15.2797 11.4108 15.1996 11.414 15.0889 11.4702C15.0242 11.5046 14.9472 11.5796 14.9194 11.6327C14.8917 11.689 14.676 12.5046 14.4419 13.4452L14.0167 15.1577H16.5999V15.1614H21.5074V15.1577H23.9831L23.558 13.4452C23.3238 12.5046 23.1082 11.689 23.0804 11.6327C23.0527 11.5796 22.9757 11.5046 22.911 11.4702ZM24.0232 18.039L24.0355 17.9702H13.9644L13.9767 18.039C13.9828 18.0796 14.18 20.114 14.4172 22.564C14.7839 26.3422 14.8578 27.0359 14.9102 27.1484C14.9533 27.2453 15.0088 27.3015 15.095 27.3453C15.2152 27.4047 15.2799 27.4078 17.113 27.4078H20.8868C22.72 27.4078 22.7847 27.4047 22.9048 27.3453C22.9911 27.3015 23.0465 27.2453 23.0897 27.1484C23.142 27.0359 23.216 26.3422 23.5826 22.564C23.8198 20.114 24.017 18.0796 24.0232 18.039ZM24.6458 15.5898H13.3543L13.2311 15.644C13.1633 15.6721 13.0832 15.7284 13.0555 15.7674C13.0092 15.8301 13.0031 15.9232 13 16.5597C13 17.2221 13.0031 17.2848 13.0585 17.3606C13.0924 17.4061 13.1664 17.4602 13.2341 17.4883L13.3543 17.536L24.6458 17.536L24.7659 17.4883C24.8337 17.4602 24.9076 17.4061 24.9415 17.3606C24.997 17.2848 25.0001 17.2221 25.0001 16.5597C24.997 15.9232 24.9908 15.8301 24.9446 15.7674C24.9169 15.7284 24.8368 15.6721 24.769 15.644L24.6458 15.5898Z"
            fill="url(#paint8_linear_139_6332)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6332"
          x="5.32964"
          y="4.99651"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6332" />
        </filter>
        <filter
          id="filter1_i_139_6332"
          x="6.58398"
          y="6.22803"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.860689" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.458333 0 0 0 0 0.256743 0 0 0 0 0.0706597 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6332" />
        </filter>
        <filter
          id="filter2_d_139_6332"
          x="12.8886"
          y="11.2964"
          width="12.4456"
          height="16.4454"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6332" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6332" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6332"
          x1="12.28"
          y1="4.88771"
          x2="26.68"
          y2="33.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DE" />
          <stop offset="1" stopColor="#CFA365" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6332"
          x1="12.152"
          y1="7.25588"
          x2="24.568"
          y2="30.1679"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2A86C" />
          <stop offset="1" stopColor="#F8E6C0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6332"
          x1="13.496"
          y1="6.42388"
          x2="26.872"
          y2="30.4879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E7" />
          <stop offset="1" stopColor="#FFF8EC" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6332"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.064 18.9929) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#FFE4BA" />
          <stop offset="1" stopColor="#DEA44D" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6332"
          x1="19.063"
          y1="3.92993"
          x2="19.063"
          y2="34.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6332"
          x1="3.65533"
          y1="6.6555"
          x2="18.7174"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6332"
          x1="33.3489"
          y1="6.65554"
          x2="18.2869"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6332"
          x1="19.0631"
          y1="24.2997"
          x2="18.9878"
          y2="32.4761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#FFF1E3" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6332"
          x1="15.3264"
          y1="15.9792"
          x2="19.7693"
          y2="23.1195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EmissionTypeBronzeLevel = () => {
  return (
    <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18"
        transform="matrix(1 0 0 -1 2 36.4077)"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M3 19.3782L3 18.6219C3 12.7603 6.20522 7.36794 11.3542 4.56693C16.1215 1.97356 21.8785 1.97356 26.6458 4.56693C31.7948 7.36794 35 12.7603 35 18.6219V19.3782C35 25.2398 31.7948 30.6321 26.6458 33.4331C21.8785 36.0265 16.1215 36.0265 11.3542 33.4331C6.20521 30.6321 3 25.2397 3 19.3782Z"
        fill="url(#paint0_linear_139_6358)"
      />
      <path
        d="M5.43201 19.2878L5.43201 18.6474C5.43201 13.6838 8.14619 9.11756 12.5064 6.74566C16.5434 4.54959 21.4183 4.54959 25.4553 6.74566C29.8155 9.11756 32.5296 13.6838 32.5296 18.6474V19.2878C32.5296 24.2514 29.8155 28.8177 25.4553 31.1896C21.4183 33.3857 16.5433 33.3857 12.5064 31.1896C8.14618 28.8177 5.43201 24.2514 5.43201 19.2878Z"
        fill="url(#paint1_linear_139_6358)"
      />
      <g filter="url(#filter0_f_139_6358)">
        <path
          d="M5.43201 19.2878L5.43201 18.6474C5.43201 13.6838 8.14619 9.11756 12.5064 6.74566C16.5434 4.54959 21.4183 4.54959 25.4553 6.74566C29.8155 9.11756 32.5296 13.6838 32.5296 18.6474V19.2878C32.5296 24.2514 29.8155 28.8177 25.4553 31.1896C21.4183 33.3857 16.5433 33.3857 12.5064 31.1896C8.14618 28.8177 5.43201 24.2514 5.43201 19.2878Z"
          stroke="url(#paint2_linear_139_6358)"
          strokeWidth="0.128"
        />
      </g>
      <g opacity="0.5">
        <mask id="mask0_139_6358" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="26">
          <path
            d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
            fill="#A6D3DE"
          />
        </mask>
        <g mask="url(#mask0_139_6358)">
          <path
            d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
            fill="url(#paint3_radial_139_6358)"
          />
          <path
            opacity="0.5"
            d="M16.9432 31.968L16.5243 6.51165C16.5009 5.09273 17.6448 3.92993 19.0639 3.92993C20.483 3.92993 21.6268 5.09273 21.6035 6.51165L21.1845 31.968C21.1655 33.1256 20.2216 34.0541 19.0639 34.0541C17.9061 34.0541 16.9623 33.1256 16.9432 31.968Z"
            fill="url(#paint4_linear_139_6358)"
          />
          <path
            opacity="0.5"
            d="M15.8385 31.9975L2.74746 10.1611C2.01777 8.94398 2.42695 7.36506 3.65594 6.6555C4.88492 5.94594 6.4569 6.38105 7.14614 7.62154L19.5115 29.8769C20.0738 30.8889 19.7206 32.1649 18.718 32.7438C17.7154 33.3226 16.4338 32.9905 15.8385 31.9975Z"
            fill="url(#paint5_linear_139_6358)"
          />
          <path
            opacity="0.5"
            d="M17.4942 29.8767L29.8596 7.62134C30.5488 6.38084 32.1208 5.94574 33.3498 6.65529C34.5788 7.36485 34.9879 8.94377 34.2583 10.1609L21.1673 31.9973C20.572 32.9903 19.2904 33.3224 18.2877 32.7436C17.2851 32.1647 16.9319 30.8887 17.4942 29.8767Z"
            fill="url(#paint6_linear_139_6358)"
          />
          <rect
            x="6.58374"
            y="17.2705"
            width="24.96"
            height="16.2097"
            rx="8.10483"
            fill="url(#paint7_linear_139_6358)"
          />
          <g filter="url(#filter1_i_139_6358)">
            <path
              d="M6.58386 19.2775V18.7078C6.58387 14.1341 9.08576 9.92677 13.1043 7.74268C16.8206 5.72286 21.3071 5.72286 25.0234 7.74268C29.042 9.92677 31.5439 14.1341 31.5439 18.7078V19.2775C31.5439 23.8512 29.042 28.0585 25.0234 30.2426C21.3071 32.2624 16.8206 32.2624 13.1043 30.2426C9.08575 28.0585 6.58386 23.8512 6.58386 19.2775Z"
              fill="#F5C4AF"
              fillOpacity="0.03"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_139_6358)">
        <path
          d="M23.2226 13.3009C23.1007 13.2759 22.9787 13.2541 22.9506 13.2541H22.9474C22.9193 13.2541 22.9693 13.304 23.0663 13.3695C23.1601 13.4319 23.3196 13.5536 23.4228 13.641C23.5228 13.7283 23.6854 13.9062 23.7824 14.0341C23.8793 14.162 24.0044 14.3617 24.0607 14.4771C24.117 14.5957 24.1889 14.7767 24.2233 14.8827C24.2859 15.0762 24.289 15.0793 24.4797 15.1698C24.5892 15.2197 24.7612 15.3164 24.8644 15.385C24.9676 15.4537 25.1521 15.6097 25.2709 15.7314C25.3929 15.853 25.5586 16.059 25.6368 16.1869C25.7181 16.3148 25.8213 16.5114 25.8682 16.6237C25.912 16.736 25.9776 16.9544 26.0089 17.1073C26.0402 17.2602 26.0683 17.5004 26.0683 17.6377C26.0683 17.775 26.0464 18.0058 26.0183 18.1525C25.9901 18.2991 25.9276 18.5238 25.8807 18.6517C25.8307 18.7796 25.7181 18.998 25.6274 19.1353C25.5398 19.2725 25.3647 19.4847 25.2428 19.6033C25.1208 19.7249 24.9144 19.8903 24.7862 19.9714C24.658 20.0494 24.4172 20.1649 24.2546 20.2241C24.092 20.2834 23.8856 20.3396 23.8011 20.3521C23.7136 20.3645 23.626 20.3926 23.601 20.4113C23.5791 20.4301 23.5135 20.5424 23.4572 20.6641C23.4009 20.7857 23.2946 20.9761 23.2195 21.0915C23.1445 21.2069 22.9975 21.3973 22.8943 21.5127C22.7942 21.6281 22.6253 21.7997 22.519 21.8902C22.4158 21.9807 22.247 22.1117 22.1438 22.1804C22.0406 22.2459 21.8655 22.352 21.7529 22.4081C21.6403 22.4674 21.4214 22.5579 21.2682 22.6109C21.1149 22.6608 20.8742 22.7264 20.7366 22.7576C20.574 22.7919 20.3269 22.8106 20.0267 22.8137C19.7734 22.8137 19.5858 22.8262 19.6045 22.8387C19.6264 22.848 19.7046 22.8792 19.7828 22.9073C19.861 22.9323 19.9923 22.9697 20.0799 22.9884C20.1643 23.0103 20.2644 23.0321 20.2988 23.0384C20.3332 23.0446 20.4113 23.0571 20.4708 23.0664C20.5302 23.0727 20.7772 23.082 21.018 23.082C21.2807 23.082 21.5559 23.0633 21.706 23.0352C21.8436 23.0072 22.0625 22.951 22.1907 22.9042C22.3189 22.8605 22.5315 22.7732 22.6597 22.7108C22.788 22.6484 23.0069 22.5236 23.1445 22.4331C23.282 22.3395 23.5291 22.1273 23.6948 21.962C23.8574 21.7966 24.0701 21.5439 24.1639 21.3973C24.2577 21.2506 24.3828 21.0353 24.4422 20.9137C24.4985 20.792 24.561 20.6859 24.5798 20.6734C24.5986 20.6609 24.6767 20.6422 24.7549 20.6329C24.8331 20.6204 24.9582 20.5954 25.0364 20.5705C25.1145 20.5486 25.2334 20.5049 25.3022 20.4769C25.371 20.4488 25.4617 20.4113 25.5054 20.3895C25.5492 20.3708 25.6868 20.2865 25.8088 20.2054C25.9339 20.1212 26.1027 19.9901 26.184 19.9059C26.2685 19.8248 26.3842 19.6969 26.4498 19.6189C26.5124 19.5409 26.6187 19.3724 26.6906 19.2445C26.7594 19.1165 26.8376 18.9481 26.8657 18.8701C26.8939 18.7921 26.9377 18.6517 26.9627 18.5581C26.9877 18.4645 27.0158 18.2679 27.0283 18.1213C27.0377 17.9746 27.0283 17.7282 27.0096 17.5753C26.9877 17.4224 26.9439 17.2102 26.9095 17.1073C26.8751 17.0043 26.8032 16.8296 26.7469 16.7173C26.6937 16.605 26.6218 16.4739 26.5874 16.424C26.5499 16.371 26.4936 16.2961 26.4592 16.2524C26.4248 16.2087 26.3029 16.0777 26.1872 15.9622C26.0714 15.8437 25.8869 15.6939 25.7775 15.6253C25.6712 15.5566 25.5117 15.4724 25.4273 15.4381C25.3178 15.3944 25.2615 15.3538 25.2334 15.2914C25.2146 15.2446 25.1896 15.1635 25.1771 15.1105C25.1677 15.0575 25.0989 14.9046 25.0301 14.7673C24.9613 14.63 24.83 14.4179 24.7393 14.2993C24.6486 14.1807 24.5204 14.031 24.4516 13.9717C24.3859 13.9093 24.2546 13.8032 24.1608 13.7346C24.067 13.6628 23.8668 13.5474 23.7136 13.4787C23.5635 13.407 23.3446 13.3259 23.2226 13.3009Z"
          fill="url(#paint8_linear_139_6358)"
        />
        <path
          d="M14.3259 21.9183C14.1821 21.7685 14.057 21.6469 14.0476 21.6469C14.0383 21.6469 13.9632 21.7124 13.885 21.7935C13.8037 21.8777 13.6911 22.0462 13.6286 22.1772C13.5191 22.4019 13.516 22.4237 13.516 22.7544C13.5191 23.082 13.5254 23.107 13.6255 23.316C13.688 23.4377 13.8037 23.6 13.8913 23.6904C13.9788 23.7747 14.1321 23.8901 14.2353 23.9463C14.3447 24.0024 14.5073 24.0555 14.6262 24.0742C14.7387 24.0898 14.892 24.0992 14.9701 24.0898C15.0483 24.0836 15.1797 24.0586 15.2672 24.0336C15.3516 24.0118 15.508 23.9338 15.6112 23.8683C15.7144 23.7996 15.8426 23.6904 15.8958 23.6218C15.9489 23.5563 16.0209 23.4471 16.0584 23.3784C16.0928 23.3098 16.1397 23.1944 16.1647 23.1226L16.2054 22.9947C16.0365 22.9604 15.8739 22.9073 15.7363 22.8574C15.5987 22.8044 15.3954 22.7108 15.2828 22.6515C15.1703 22.5922 14.9701 22.4643 14.8325 22.3676C14.6981 22.2708 14.4698 22.0712 14.3259 21.9183Z"
          fill="url(#paint9_linear_139_6358)"
        />
        <path
          d="M19.4857 12.2244C19.3481 12.2056 19.1292 12.1963 19.001 12.1963C18.8728 12.1994 18.6695 12.2119 18.5476 12.2275C18.4256 12.2431 18.2223 12.2836 18.0941 12.3148C17.9659 12.346 17.747 12.4178 17.6094 12.4708C17.4718 12.5239 17.2404 12.6362 17.0935 12.7236C16.9465 12.8109 16.7307 12.9576 16.6088 13.0543C16.4493 13.1791 16.3742 13.2228 16.3273 13.2072C16.2929 13.1978 16.1616 13.1697 16.0396 13.1448C15.9145 13.1198 15.6769 13.098 15.5143 13.098C15.3516 13.098 15.114 13.1167 14.992 13.1416C14.8669 13.1666 14.6793 13.2165 14.5761 13.254C14.4729 13.2883 14.2978 13.3694 14.1852 13.4318C14.0726 13.4911 13.9038 13.6034 13.81 13.6752C13.7162 13.7469 13.5692 13.8811 13.4847 13.9747C13.4003 14.0683 13.2658 14.243 13.1908 14.3616C13.1126 14.4801 13.0094 14.6704 12.9656 14.7828C12.9187 14.8951 12.8624 15.0698 12.8406 15.1728C12.8187 15.2757 12.778 15.3849 12.7499 15.4161C12.7217 15.4473 12.6873 15.4691 12.6686 15.4691C12.6498 15.4691 12.5278 15.5315 12.3965 15.6095C12.262 15.6875 12.0463 15.8529 11.9149 15.9746C11.7836 16.0994 11.6147 16.2866 11.5428 16.3895C11.4709 16.4925 11.3708 16.6547 11.3239 16.7483C11.277 16.8419 11.2019 17.0198 11.1613 17.1383C11.1206 17.2569 11.0737 17.4753 11.055 17.6219C11.0331 17.7686 11.0268 18.0057 11.0362 18.1523C11.0487 18.299 11.0862 18.5299 11.1206 18.6671C11.155 18.8044 11.227 19.0072 11.2801 19.1195C11.3333 19.2318 11.4271 19.4003 11.4896 19.4939C11.5553 19.5875 11.6835 19.7466 11.7773 19.8465C11.8711 19.9494 12.0338 20.0961 12.137 20.1741C12.2401 20.2521 12.4528 20.3738 12.606 20.4455C12.7593 20.5204 12.9782 20.6015 13.0907 20.6265C13.2033 20.6546 13.3472 20.6858 13.4128 20.6951C13.5223 20.7107 13.5348 20.7232 13.6724 20.9978C13.7506 21.1569 13.8819 21.3784 13.9601 21.4907C14.0414 21.603 14.2134 21.8058 14.3447 21.9431C14.476 22.0804 14.6949 22.2707 14.8294 22.3674C14.967 22.4641 15.1671 22.5921 15.2797 22.6513C15.3923 22.7106 15.5956 22.8042 15.7332 22.8573C15.8707 22.9103 16.1303 22.9821 16.3117 23.0195C16.5493 23.0694 16.7526 23.0881 17.0465 23.0881C17.2905 23.0881 17.5657 23.0694 17.7345 23.0382C17.8877 23.0101 18.1066 22.9571 18.2192 22.9228C18.3318 22.8853 18.5601 22.7917 18.7289 22.7137L19.0354 22.5671L19.5483 22.8229C20.3144 22.8105 20.5771 22.7886 20.7366 22.7543C20.8742 22.7262 21.1149 22.6608 21.2682 22.6109C21.4214 22.5579 21.6403 22.4674 21.7529 22.4081C21.8655 22.352 22.0406 22.2459 22.1438 22.1804C22.247 22.1117 22.4158 21.9807 22.519 21.8902C22.6253 21.7997 22.7942 21.6281 22.8943 21.5127C22.9975 21.3973 23.1445 21.2069 23.2195 21.0915C23.2946 20.9761 23.4009 20.7857 23.4572 20.6641C23.5135 20.5424 23.5791 20.4301 23.601 20.4113C23.626 20.3926 23.7167 20.3645 23.8011 20.3521C23.8887 20.3396 24.092 20.2834 24.2546 20.2241C24.4172 20.1649 24.658 20.0494 24.7862 19.9714C24.9144 19.8903 25.1208 19.7249 25.2428 19.6033C25.3647 19.4847 25.5398 19.2725 25.6274 19.1353C25.7181 18.998 25.8307 18.7796 25.8807 18.6517C25.9276 18.5238 25.9901 18.2991 26.0183 18.1525C26.0464 18.0058 26.0683 17.775 26.0683 17.6377C26.0683 17.5004 26.0402 17.2602 26.0089 17.1073C25.9776 16.9544 25.912 16.736 25.8682 16.6237C25.8213 16.5114 25.7181 16.3148 25.6368 16.1869C25.5586 16.059 25.3929 15.853 25.2709 15.7314C25.1521 15.6097 24.9676 15.4537 24.8644 15.385C24.7612 15.3164 24.5892 15.2197 24.4797 15.1698C24.289 15.0793 24.2859 15.0762 24.2233 14.8827C24.1889 14.7767 24.117 14.5957 24.0607 14.4771C24.0044 14.3617 23.8793 14.162 23.7824 14.0341C23.6854 13.9062 23.5228 13.7283 23.4228 13.641C23.3196 13.5536 23.1632 13.4349 23.0757 13.3756C22.985 13.3164 22.9193 13.2602 22.9318 13.2446C22.9412 13.2321 22.7942 13.2228 22.6035 13.2228C22.4096 13.2228 22.1438 13.2446 22.0124 13.2696C21.7967 13.3101 21.7623 13.3101 21.706 13.2696C21.6716 13.2415 21.5527 13.1448 21.4402 13.0512C21.3276 12.9576 21.1306 12.8203 21.0024 12.7423C20.8742 12.6643 20.649 12.552 20.502 12.4896C20.3551 12.4303 20.1236 12.3523 19.9861 12.318C19.8485 12.2836 19.6233 12.24 19.4857 12.2244Z"
          fill="url(#paint10_linear_139_6358)"
        />
        <path
          d="M21.1431 23.1037C21.2119 23.0975 21.1619 23.0913 21.0336 23.0913C20.9054 23.0913 20.8491 23.0975 20.9086 23.1037C20.968 23.11 21.0743 23.11 21.1431 23.1037Z"
          fill="url(#paint11_linear_139_6358)"
        />
        <path
          d="M13.5598 24.5265C13.4597 24.4765 13.369 24.4547 13.2471 24.4547C13.122 24.4547 13.0376 24.4765 12.9344 24.5358C12.8562 24.5795 12.7686 24.645 12.7374 24.6825C12.7061 24.7199 12.6592 24.801 12.631 24.8603C12.606 24.9196 12.5841 25.0444 12.5873 25.1317C12.5904 25.2253 12.6154 25.3501 12.6498 25.4125C12.6811 25.4781 12.7593 25.5779 12.8218 25.6309C12.8843 25.6871 12.9875 25.7464 13.0532 25.7651C13.1157 25.7807 13.2033 25.7963 13.2471 25.7963C13.2909 25.7963 13.3816 25.7807 13.4503 25.762C13.5285 25.7401 13.6317 25.6715 13.7193 25.581C13.8194 25.4843 13.8788 25.3938 13.9038 25.2971C13.9225 25.2191 13.9319 25.1005 13.9225 25.0319C13.9132 24.9633 13.86 24.8385 13.8037 24.7542C13.738 24.6544 13.6505 24.5733 13.5598 24.5265Z"
          fill="url(#paint12_linear_139_6358)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_139_6358"
          x="5.29124"
          y="4.95787"
          width="27.3792"
          height="28.0196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0384" result="effect1_foregroundBlur_139_6358" />
        </filter>
        <filter
          id="filter1_i_139_6358"
          x="6.58386"
          y="6.22778"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.283333 0 0 0 0 0.158667 0 0 0 0 0.0566667 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6358" />
        </filter>
        <filter
          id="filter2_d_139_6358"
          x="10.9206"
          y="12.0849"
          width="16.4454"
          height="14.0455"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6358" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6358" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6358"
          x1="12.28"
          y1="4.88771"
          x2="26.68"
          y2="33.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1DCC1" />
          <stop offset="1" stopColor="#BD8A65" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6358"
          x1="12.152"
          y1="7.25563"
          x2="24.568"
          y2="30.1676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BF8E69" />
          <stop offset="1" stopColor="#E4C196" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6358"
          x1="13.496"
          y1="6.42363"
          x2="26.872"
          y2="30.4876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD4B7" />
          <stop offset="1" stopColor="#FFE3CE" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6358"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0639 18.9926) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#E3C29C" />
          <stop offset="1" stopColor="#D1A479" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6358"
          x1="19.0639"
          y1="3.92993"
          x2="19.0639"
          y2="34.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6358"
          x1="3.65594"
          y1="6.6555"
          x2="18.718"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6358"
          x1="33.3498"
          y1="6.65529"
          x2="18.2877"
          y2="32.7436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6358"
          x1="19.0637"
          y1="24.2995"
          x2="18.9884"
          y2="32.4758"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.291667" stopColor="#FFFAF7" stopOpacity="0" />
          <stop offset="1" stopColor="#E4CBAD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6358"
          x1="14.1339"
          y1="16.082"
          x2="17.0194"
          y2="23.3565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_139_6358"
          x1="14.1339"
          y1="16.082"
          x2="17.0194"
          y2="23.3565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_139_6358"
          x1="14.1339"
          y1="16.082"
          x2="17.0194"
          y2="23.3565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_139_6358"
          x1="14.1339"
          y1="16.082"
          x2="17.0194"
          y2="23.3565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_139_6358"
          x1="14.1339"
          y1="16.082"
          x2="17.0194"
          y2="23.3565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D8BD" />
          <stop offset="1" stopColor="#E0A579" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EmissionTypeSilverLevel = () => {
  return (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18.4167"
        transform="matrix(1 0 0 -1 3 37.7527)"
        fill="white"
        stroke="white"
        strokeWidth="2.83333"
      />
      <path
        d="M4 21.3782L4 20.6219C4 14.7603 7.20522 9.36794 12.3542 6.56693C17.1215 3.97356 22.8785 3.97356 27.6458 6.56693C32.7948 9.36794 36 14.7603 36 20.6219V21.3782C36 27.2398 32.7948 32.6321 27.6458 35.4331C22.8785 38.0265 17.1215 38.0265 12.3542 35.4331C7.20521 32.6321 4 27.2397 4 21.3782Z"
        fill="url(#paint0_linear_139_6378)"
      />
      <path
        d="M6.43201 21.2878L6.43201 20.6474C6.43201 15.6838 9.14619 11.1176 13.5064 8.74566C17.5434 6.54959 22.4183 6.54959 26.4553 8.74566C30.8155 11.1176 33.5296 15.6838 33.5296 20.6474V21.2878C33.5296 26.2514 30.8155 30.8177 26.4553 33.1896C22.4183 35.3857 17.5433 35.3857 13.5064 33.1896C9.14618 30.8177 6.43201 26.2514 6.43201 21.2878Z"
        fill="url(#paint1_linear_139_6378)"
      />
      <g filter="url(#filter0_f_139_6378)">
        <path
          d="M6.43201 21.2878L6.43201 20.6474C6.43201 15.6838 9.14619 11.1176 13.5064 8.74566C17.5434 6.54959 22.4183 6.54959 26.4553 8.74566C30.8155 11.1176 33.5296 15.6838 33.5296 20.6474V21.2878C33.5296 26.2514 30.8155 30.8177 26.4553 33.1896C22.4183 35.3857 17.5433 35.3857 13.5064 33.1896C9.14618 30.8177 6.43201 26.2514 6.43201 21.2878Z"
          stroke="url(#paint2_linear_139_6378)"
          strokeWidth="0.128"
        />
      </g>
      <g opacity="0.5">
        <mask id="mask0_139_6378" maskUnits="userSpaceOnUse" x="7" y="8" width="26" height="26">
          <path
            d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
            fill="#A6D3DE"
          />
        </mask>
        <g mask="url(#mask0_139_6378)">
          <path
            d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
            fill="url(#paint3_radial_139_6378)"
          />
          <path
            opacity="0.5"
            d="M17.9432 33.968L17.5243 8.51165C17.5009 7.09273 18.6448 5.92993 20.0639 5.92993C21.483 5.92993 22.6268 7.09273 22.6035 8.51165L22.1845 33.968C22.1655 35.1256 21.2216 36.0541 20.0639 36.0541C18.9061 36.0541 17.9623 35.1256 17.9432 33.968Z"
            fill="url(#paint4_linear_139_6378)"
          />
          <path
            opacity="0.5"
            d="M16.8382 33.9973L3.74721 12.1609C3.01753 10.9437 3.42671 9.36481 4.65569 8.65525C5.88468 7.9457 7.45666 8.3808 8.14589 9.6213L20.5113 31.8766C21.0736 32.8887 20.7204 34.1646 19.7178 34.7435C18.7151 35.3224 17.4335 34.9903 16.8382 33.9973Z"
            fill="url(#paint5_linear_139_6378)"
          />
          <path
            opacity="0.5"
            d="M18.4941 31.8767L30.8595 9.62134C31.5487 8.38084 33.1207 7.94574 34.3497 8.65529C35.5786 9.36485 35.9878 10.9438 35.2581 12.1609L22.1671 33.9973C21.5718 34.9903 20.2902 35.3224 19.2876 34.7436C18.285 34.1647 17.9318 32.8887 18.4941 31.8767Z"
            fill="url(#paint6_linear_139_6378)"
          />
          <rect
            x="7.58362"
            y="19.2705"
            width="24.96"
            height="16.2097"
            rx="8.10483"
            fill="url(#paint7_linear_139_6378)"
          />
          <g filter="url(#filter1_i_139_6378)">
            <path
              d="M7.58386 21.2775V20.7078C7.58387 16.1341 10.0858 11.9268 14.1043 9.74268C17.8206 7.72286 22.3071 7.72286 26.0234 9.74268C30.042 11.9268 32.5439 16.1341 32.5439 20.7078V21.2775C32.5439 25.8512 30.042 30.0585 26.0234 32.2426C22.3071 34.2624 17.8206 34.2624 14.1043 32.2426C10.0858 30.0585 7.58386 25.8512 7.58386 21.2775Z"
              fill="#6052B4"
              fillOpacity="0.01"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_139_6378)">
        <path
          d="M24.1906 15.3046C24.0687 15.2796 23.9467 15.2578 23.9186 15.2578H23.9155C23.8873 15.2578 23.9374 15.3077 24.0343 15.3732C24.1281 15.4356 24.2876 15.5573 24.3908 15.6446C24.4909 15.732 24.6535 15.9098 24.7504 16.0378C24.8473 16.1657 24.9724 16.3654 25.0287 16.4808C25.085 16.5994 25.1569 16.7803 25.1913 16.8864C25.2539 17.0798 25.257 17.083 25.4478 17.1734C25.5572 17.2234 25.7292 17.3201 25.8324 17.3887C25.9356 17.4574 26.1201 17.6133 26.2389 17.735C26.3609 17.8567 26.5266 18.0626 26.6048 18.1905C26.6861 18.3185 26.7893 18.515 26.8362 18.6273C26.88 18.7397 26.9457 18.9581 26.9769 19.1109C27.0082 19.2638 27.0363 19.5041 27.0363 19.6413C27.0363 19.7786 27.0144 20.0095 26.9863 20.1561C26.9582 20.3028 26.8956 20.5274 26.8487 20.6553C26.7987 20.7833 26.6861 21.0016 26.5954 21.1389C26.5079 21.2762 26.3327 21.4884 26.2108 21.6069C26.0888 21.7286 25.8824 21.894 25.7542 21.9751C25.626 22.0531 25.3852 22.1685 25.2226 22.2278C25.06 22.2871 24.8536 22.3432 24.7692 22.3557C24.6816 22.3682 24.594 22.3963 24.569 22.415C24.5471 22.4337 24.4815 22.546 24.4252 22.6677C24.3689 22.7894 24.2626 22.9797 24.1875 23.0952C24.1125 23.2106 23.9655 23.4009 23.8623 23.5164C23.7622 23.6318 23.5934 23.8034 23.487 23.8939C23.3838 23.9844 23.215 24.1154 23.1118 24.184C23.0086 24.2496 22.8335 24.3556 22.7209 24.4118C22.6083 24.4711 22.3894 24.5615 22.2362 24.6146C22.083 24.6645 21.8422 24.73 21.7046 24.7612C21.542 24.7955 21.2949 24.8143 20.9947 24.8174C20.7414 24.8174 20.5538 24.8299 20.5726 24.8423C20.5944 24.8517 20.6726 24.8829 20.7508 24.911C20.829 24.9359 20.9603 24.9734 21.0479 24.9921C21.1323 25.0139 21.2324 25.0358 21.2668 25.042C21.3012 25.0483 21.3794 25.0607 21.4388 25.0701C21.4982 25.0763 21.7452 25.0857 21.986 25.0857C22.2487 25.0857 22.5239 25.067 22.674 25.0389C22.8116 25.0108 23.0305 24.9547 23.1587 24.9079C23.2869 24.8642 23.4996 24.7768 23.6278 24.7144C23.756 24.652 23.9749 24.5272 24.1125 24.4367C24.2501 24.3432 24.4971 24.131 24.6628 23.9656C24.8255 23.8003 25.0381 23.5476 25.1319 23.4009C25.2257 23.2543 25.3508 23.039 25.4102 22.9173C25.4665 22.7956 25.5291 22.6896 25.5478 22.6771C25.5666 22.6646 25.6448 22.6459 25.7229 22.6365C25.8011 22.624 25.9262 22.5991 26.0044 22.5741C26.0826 22.5523 26.2014 22.5086 26.2702 22.4805C26.339 22.4524 26.4297 22.415 26.4735 22.3932C26.5172 22.3744 26.6548 22.2902 26.7768 22.2091C26.9019 22.1248 27.0707 21.9938 27.152 21.9096C27.2365 21.8284 27.3522 21.7005 27.4178 21.6225C27.4804 21.5445 27.5867 21.376 27.6586 21.2481C27.7274 21.1202 27.8056 20.9517 27.8338 20.8737C27.8619 20.7957 27.9057 20.6553 27.9307 20.5617C27.9557 20.4681 27.9839 20.2716 27.9964 20.1249C28.0057 19.9783 27.9964 19.7318 27.9776 19.5789C27.9557 19.4261 27.9119 19.2139 27.8775 19.1109C27.8431 19.008 27.7712 18.8333 27.7149 18.7209C27.6618 18.6086 27.5898 18.4776 27.5554 18.4277C27.5179 18.3746 27.4616 18.2997 27.4272 18.2561C27.3928 18.2124 27.2709 18.0813 27.1552 17.9659C27.0395 17.8473 26.855 17.6976 26.7455 17.6289C26.6392 17.5603 26.4797 17.4761 26.3953 17.4418C26.2858 17.3981 26.2295 17.3575 26.2014 17.2951C26.1826 17.2483 26.1576 17.1672 26.1451 17.1142C26.1357 17.0611 26.0669 16.9082 25.9981 16.771C25.9293 16.6337 25.798 16.4215 25.7073 16.303C25.6166 16.1844 25.4884 16.0346 25.4196 15.9754C25.3539 15.913 25.2226 15.8069 25.1288 15.7382C25.035 15.6665 24.8348 15.551 24.6816 15.4824C24.5315 15.4106 24.3126 15.3295 24.1906 15.3046Z"
          fill="url(#paint8_linear_139_6378)"
        />
        <path
          d="M15.294 23.922C15.1501 23.7722 15.025 23.6505 15.0156 23.6505C15.0063 23.6505 14.9312 23.716 14.853 23.7972C14.7717 23.8814 14.6592 24.0499 14.5966 24.1809C14.4872 24.4055 14.484 24.4274 14.484 24.7581C14.4872 25.0857 14.4934 25.1107 14.5935 25.3197C14.656 25.4414 14.7717 25.6036 14.8593 25.6941C14.9469 25.7783 15.1001 25.8938 15.2033 25.9499C15.3127 26.0061 15.4753 26.0591 15.5942 26.0779C15.7067 26.0935 15.86 26.1028 15.9382 26.0935C16.0163 26.0872 16.1477 26.0623 16.2352 26.0373C16.3197 26.0155 16.476 25.9375 16.5792 25.8719C16.6824 25.8033 16.8106 25.6941 16.8638 25.6255C16.9169 25.5599 16.9889 25.4507 17.0264 25.3821C17.0608 25.3135 17.1077 25.198 17.1327 25.1263L17.1734 24.9983C17.0045 24.964 16.8419 24.911 16.7043 24.8611C16.5667 24.808 16.3634 24.7144 16.2509 24.6551C16.1383 24.5959 15.9382 24.4679 15.8006 24.3712C15.6661 24.2745 15.4378 24.0748 15.294 23.922Z"
          fill="url(#paint9_linear_139_6378)"
        />
        <path
          d="M20.4537 14.228C20.3161 14.2093 20.0972 14.2 19.969 14.2C19.8408 14.2031 19.6375 14.2156 19.5156 14.2312C19.3936 14.2468 19.1904 14.2873 19.0622 14.3185C18.9339 14.3497 18.715 14.4215 18.5774 14.4745C18.4399 14.5275 18.2084 14.6399 18.0615 14.7272C17.9145 14.8146 17.6987 14.9612 17.5768 15.0579C17.4173 15.1827 17.3422 15.2264 17.2953 15.2108C17.2609 15.2015 17.1296 15.1734 17.0076 15.1484C16.8825 15.1235 16.6449 15.1016 16.4823 15.1016C16.3197 15.1016 16.082 15.1203 15.96 15.1453C15.835 15.1703 15.6473 15.2202 15.5441 15.2576C15.4409 15.2919 15.2658 15.3731 15.1532 15.4355C15.0407 15.4947 14.8718 15.6071 14.778 15.6788C14.6842 15.7506 14.5372 15.8847 14.4528 15.9783C14.3683 16.0719 14.2339 16.2467 14.1588 16.3652C14.0806 16.4838 13.9774 16.6741 13.9337 16.7864C13.8868 16.8987 13.8305 17.0735 13.8086 17.1764C13.7867 17.2794 13.746 17.3886 13.7179 17.4198C13.6897 17.451 13.6553 17.4728 13.6366 17.4728C13.6178 17.4728 13.4959 17.5352 13.3645 17.6132C13.2301 17.6912 13.0143 17.8566 12.8829 17.9782C12.7516 18.103 12.5827 18.2902 12.5108 18.3932C12.4389 18.4962 12.3388 18.6584 12.2919 18.752C12.245 18.8456 12.17 19.0234 12.1293 19.142C12.0887 19.2606 12.0417 19.479 12.023 19.6256C12.0011 19.7722 11.9948 20.0094 12.0042 20.156C12.0167 20.3026 12.0543 20.5335 12.0887 20.6708C12.1231 20.8081 12.195 21.0109 12.2481 21.1232C12.3013 21.2355 12.3951 21.404 12.4577 21.4976C12.5233 21.5912 12.6515 21.7503 12.7454 21.8501C12.8392 21.9531 13.0018 22.0997 13.105 22.1777C13.2082 22.2557 13.4208 22.3774 13.574 22.4492C13.7273 22.5241 13.9462 22.6052 14.0587 22.6301C14.1713 22.6582 14.3152 22.6894 14.3808 22.6988C14.4903 22.7144 14.5028 22.7269 14.6404 23.0014C14.7186 23.1605 14.8499 23.3821 14.9281 23.4944C15.0094 23.6067 15.1814 23.8095 15.3127 23.9468C15.4441 24.0841 15.663 24.2744 15.7974 24.3711C15.935 24.4678 16.1352 24.5957 16.2477 24.655C16.3603 24.7143 16.5636 24.8079 16.7012 24.8609C16.8388 24.914 17.0983 24.9857 17.2797 25.0232C17.5174 25.0731 17.7206 25.0918 18.0146 25.0918C18.2585 25.0918 18.5337 25.0731 18.7025 25.0419C18.8558 25.0138 19.0747 24.9608 19.1872 24.9264C19.2998 24.889 19.5281 24.7954 19.697 24.7174L20.0034 24.5708L20.5163 24.8266C21.2824 24.8141 21.5451 24.7923 21.7046 24.758C21.8422 24.7299 22.083 24.6645 22.2362 24.6146C22.3894 24.5615 22.6083 24.4711 22.7209 24.4118C22.8335 24.3556 23.0086 24.2496 23.1118 24.184C23.215 24.1154 23.3838 23.9844 23.487 23.8939C23.5934 23.8034 23.7622 23.6318 23.8623 23.5164C23.9655 23.4009 24.1125 23.2106 24.1875 23.0952C24.2626 22.9797 24.3689 22.7894 24.4252 22.6677C24.4815 22.546 24.5471 22.4337 24.569 22.415C24.594 22.3963 24.6847 22.3682 24.7692 22.3557C24.8567 22.3432 25.06 22.2871 25.2226 22.2278C25.3852 22.1685 25.626 22.0531 25.7542 21.9751C25.8824 21.894 26.0888 21.7286 26.2108 21.6069C26.3327 21.4884 26.5079 21.2762 26.5954 21.1389C26.6861 21.0016 26.7987 20.7833 26.8487 20.6553C26.8956 20.5274 26.9582 20.3028 26.9863 20.1561C27.0144 20.0095 27.0363 19.7786 27.0363 19.6413C27.0363 19.5041 27.0082 19.2638 26.9769 19.1109C26.9457 18.9581 26.88 18.7397 26.8362 18.6273C26.7893 18.515 26.6861 18.3185 26.6048 18.1905C26.5266 18.0626 26.3609 17.8567 26.2389 17.735C26.1201 17.6133 25.9356 17.4574 25.8324 17.3887C25.7292 17.3201 25.5572 17.2234 25.4478 17.1734C25.257 17.083 25.2539 17.0798 25.1913 16.8864C25.1569 16.7803 25.085 16.5994 25.0287 16.4808C24.9724 16.3654 24.8473 16.1657 24.7504 16.0378C24.6535 15.9098 24.4909 15.732 24.3908 15.6446C24.2876 15.5573 24.1312 15.4386 24.0437 15.3793C23.953 15.32 23.8873 15.2639 23.8998 15.2483C23.9092 15.2358 23.7622 15.2264 23.5715 15.2264C23.3776 15.2264 23.1118 15.2483 22.9804 15.2732C22.7647 15.3138 22.7303 15.3138 22.674 15.2732C22.6396 15.2451 22.5208 15.1484 22.4082 15.0548C22.2956 14.9612 22.0986 14.8239 21.9704 14.7459C21.8422 14.6679 21.617 14.5556 21.47 14.4932C21.3231 14.4339 21.0917 14.356 20.9541 14.3216C20.8165 14.2873 20.5913 14.2436 20.4537 14.228Z"
          fill="url(#paint10_linear_139_6378)"
        />
        <path
          d="M22.1111 25.1074C22.1799 25.1012 22.1299 25.0949 22.0017 25.0949C21.8734 25.0949 21.8172 25.1012 21.8766 25.1074C21.936 25.1136 22.0423 25.1136 22.1111 25.1074Z"
          fill="url(#paint11_linear_139_6378)"
        />
        <path
          d="M14.5278 26.5301C14.4277 26.4802 14.3371 26.4584 14.2151 26.4584C14.09 26.4584 14.0056 26.4802 13.9024 26.5395C13.8242 26.5832 13.7367 26.6487 13.7054 26.6861C13.6741 26.7236 13.6272 26.8047 13.5991 26.864C13.574 26.9232 13.5522 27.048 13.5553 27.1354C13.5584 27.229 13.5834 27.3538 13.6178 27.4162C13.6491 27.4817 13.7273 27.5816 13.7898 27.6346C13.8524 27.6908 13.9556 27.75 14.0212 27.7688C14.0838 27.7844 14.1713 27.8 14.2151 27.8C14.2589 27.8 14.3496 27.7844 14.4184 27.7656C14.4965 27.7438 14.5997 27.6752 14.6873 27.5847C14.7874 27.488 14.8468 27.3975 14.8718 27.3008C14.8906 27.2228 14.8999 27.1042 14.8906 27.0356C14.8812 26.9669 14.828 26.8421 14.7717 26.7579C14.7061 26.658 14.6185 26.5769 14.5278 26.5301Z"
          fill="url(#paint12_linear_139_6378)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_139_6378"
          x="6.32964"
          y="6.99627"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6378" />
        </filter>
        <filter
          id="filter1_i_139_6378"
          x="7.58386"
          y="8.22778"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.86069" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.297222 0 0 0 0 0.329917 0 0 0 0 0.445833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6378" />
        </filter>
        <filter
          id="filter2_d_139_6378"
          x="11.8886"
          y="14.0886"
          width="16.4454"
          height="14.0455"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6378" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6378" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6378"
          x1="13.28"
          y1="6.88771"
          x2="27.68"
          y2="35.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="1" stopColor="#B8BAC2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6378"
          x1="13.152"
          y1="9.25563"
          x2="25.568"
          y2="32.1676"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDCFD6" />
          <stop offset="1" stopColor="#EFEFF1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6378"
          x1="14.496"
          y1="8.42363"
          x2="27.872"
          y2="32.4876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DDDFE2" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6378"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.0639 20.9926) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#F5F7FF" />
          <stop offset="1" stopColor="#B3B5C5" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6378"
          x1="20.0639"
          y1="5.92993"
          x2="20.0639"
          y2="36.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6378"
          x1="4.65569"
          y1="8.65525"
          x2="19.7178"
          y2="34.7435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6378"
          x1="34.3497"
          y1="8.65529"
          x2="19.2876"
          y2="34.7436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6378"
          x1="20.0636"
          y1="26.2995"
          x2="19.9883"
          y2="34.4758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#D0DBFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6378"
          x1="15.1019"
          y1="18.0857"
          x2="17.9874"
          y2="25.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_139_6378"
          x1="15.1019"
          y1="18.0857"
          x2="17.9874"
          y2="25.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_139_6378"
          x1="15.1019"
          y1="18.0857"
          x2="17.9874"
          y2="25.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_139_6378"
          x1="15.1019"
          y1="18.0857"
          x2="17.9874"
          y2="25.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_139_6378"
          x1="15.1019"
          y1="18.0857"
          x2="17.9874"
          y2="25.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F2" />
          <stop offset="1" stopColor="#B7BAC5" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EmissionTypeGoldLevel = () => {
  return (
    <svg width="38" height="39" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="17"
        cy="17"
        r="18"
        transform="matrix(1 0 0 -1 2 36.4077)"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <g opacity="0.7">
        <path
          d="M3 19.3782L3 18.6219C3 12.7603 6.20522 7.36794 11.3542 4.56693C16.1215 1.97356 21.8785 1.97356 26.6458 4.56693C31.7948 7.36794 35 12.7603 35 18.6219V19.3782C35 25.2398 31.7948 30.6321 26.6458 33.4331C21.8785 36.0265 16.1215 36.0265 11.3542 33.4331C6.20521 30.6321 3 25.2397 3 19.3782Z"
          fill="url(#paint0_linear_139_6398)"
        />
        <path
          d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
          fill="url(#paint1_linear_139_6398)"
        />
        <g filter="url(#filter0_f_139_6398)">
          <path
            d="M5.43201 19.2881L5.43201 18.6477C5.43201 13.6841 8.14619 9.11781 12.5064 6.7459C16.5434 4.54984 21.4183 4.54984 25.4553 6.7459C29.8155 9.11781 32.5296 13.6841 32.5296 18.6477V19.2881C32.5296 24.2517 29.8155 28.8179 25.4553 31.1898C21.4183 33.3859 16.5433 33.3859 12.5064 31.1898C8.14618 28.8179 5.43201 24.2517 5.43201 19.2881Z"
            stroke="url(#paint2_linear_139_6398)"
            strokeWidth="0.128"
          />
        </g>
        <g opacity="0.5">
          <mask id="mask0_139_6398" maskUnits="userSpaceOnUse" x="6" y="6" width="26" height="26">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="#A6D3DE"
            />
          </mask>
          <g mask="url(#mask0_139_6398)">
            <path
              d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
              fill="url(#paint3_radial_139_6398)"
            />
            <path
              opacity="0.5"
              d="M16.9424 31.968L16.5234 6.51165C16.5001 5.09273 17.6439 3.92993 19.063 3.92993C20.4821 3.92993 21.626 5.09273 21.6026 6.51165L21.1837 31.968C21.1646 33.1256 20.2208 34.0541 19.063 34.0541C17.9053 34.0541 16.9614 33.1256 16.9424 31.968Z"
              fill="url(#paint4_linear_139_6398)"
            />
            <path
              opacity="0.5"
              d="M15.8379 31.9975L2.74684 10.1611C2.01716 8.94398 2.42634 7.36506 3.65533 6.6555C4.88431 5.94594 6.45629 6.38105 7.14553 7.62154L19.5109 29.8769C20.0732 30.8889 19.72 32.1649 18.7174 32.7438C17.7148 33.3226 16.4331 32.9905 15.8379 31.9975Z"
              fill="url(#paint5_linear_139_6398)"
            />
            <path
              opacity="0.5"
              d="M17.4933 29.8769L29.8587 7.62158C30.548 6.38108 32.1199 5.94598 33.3489 6.65554C34.5779 7.36509 34.9871 8.94402 34.2574 10.1612L21.1664 31.9976C20.5711 32.9905 19.2895 33.3227 18.2869 32.7438C17.2842 32.1649 16.931 30.889 17.4933 29.8769Z"
              fill="url(#paint6_linear_139_6398)"
            />
            <rect
              x="6.58313"
              y="17.2708"
              width="24.96"
              height="16.2097"
              rx="8.10483"
              fill="url(#paint7_linear_139_6398)"
            />
            <g filter="url(#filter1_i_139_6398)">
              <path
                d="M6.58398 19.2777V18.7081C6.58399 14.1343 9.08588 9.92701 13.1044 7.74293C16.8208 5.7231 21.3072 5.7231 25.0235 7.74293C29.0421 9.92701 31.544 14.1343 31.544 18.7081V19.2777C31.544 23.8514 29.0421 28.0587 25.0235 30.2428C21.3072 32.2627 16.8208 32.2627 13.1044 30.2428C9.08588 28.0587 6.58398 23.8514 6.58398 19.2777Z"
                fill="#6052B4"
                fillOpacity="0.01"
              />
            </g>
          </g>
        </g>
        <g filter="url(#filter2_d_139_6398)">
          <path
            d="M23.1906 13.3046C23.0687 13.2796 22.9467 13.2578 22.9186 13.2578H22.9155C22.8873 13.2578 22.9374 13.3077 23.0343 13.3732C23.1281 13.4356 23.2876 13.5573 23.3908 13.6446C23.4909 13.732 23.6535 13.9098 23.7504 14.0378C23.8473 14.1657 23.9724 14.3654 24.0287 14.4808C24.085 14.5994 24.1569 14.7803 24.1913 14.8864C24.2539 15.0798 24.257 15.083 24.4478 15.1734C24.5572 15.2234 24.7292 15.3201 24.8324 15.3887C24.9356 15.4574 25.1201 15.6133 25.2389 15.735C25.3609 15.8567 25.5266 16.0626 25.6048 16.1905C25.6861 16.3185 25.7893 16.515 25.8362 16.6273C25.88 16.7397 25.9457 16.9581 25.9769 17.1109C26.0082 17.2638 26.0363 17.5041 26.0363 17.6413C26.0363 17.7786 26.0144 18.0095 25.9863 18.1561C25.9582 18.3028 25.8956 18.5274 25.8487 18.6553C25.7987 18.7833 25.6861 19.0016 25.5954 19.1389C25.5079 19.2762 25.3327 19.4884 25.2108 19.6069C25.0888 19.7286 24.8824 19.894 24.7542 19.9751C24.626 20.0531 24.3852 20.1685 24.2226 20.2278C24.06 20.2871 23.8536 20.3432 23.7692 20.3557C23.6816 20.3682 23.594 20.3963 23.569 20.415C23.5471 20.4337 23.4815 20.546 23.4252 20.6677C23.3689 20.7894 23.2626 20.9797 23.1875 21.0952C23.1125 21.2106 22.9655 21.4009 22.8623 21.5164C22.7622 21.6318 22.5934 21.8034 22.487 21.8939C22.3838 21.9844 22.215 22.1154 22.1118 22.184C22.0086 22.2496 21.8335 22.3556 21.7209 22.4118C21.6083 22.4711 21.3894 22.5615 21.2362 22.6146C21.083 22.6645 20.8422 22.73 20.7046 22.7612C20.542 22.7955 20.2949 22.8143 19.9947 22.8174C19.7414 22.8174 19.5538 22.8299 19.5726 22.8423C19.5944 22.8517 19.6726 22.8829 19.7508 22.911C19.829 22.9359 19.9603 22.9734 20.0479 22.9921C20.1323 23.0139 20.2324 23.0358 20.2668 23.042C20.3012 23.0483 20.3794 23.0607 20.4388 23.0701C20.4982 23.0763 20.7452 23.0857 20.986 23.0857C21.2487 23.0857 21.5239 23.067 21.674 23.0389C21.8116 23.0108 22.0305 22.9547 22.1587 22.9079C22.2869 22.8642 22.4996 22.7768 22.6278 22.7144C22.756 22.652 22.9749 22.5272 23.1125 22.4367C23.2501 22.3432 23.4971 22.131 23.6628 21.9656C23.8255 21.8003 24.0381 21.5476 24.1319 21.4009C24.2257 21.2543 24.3508 21.039 24.4102 20.9173C24.4665 20.7956 24.5291 20.6896 24.5478 20.6771C24.5666 20.6646 24.6448 20.6459 24.7229 20.6365C24.8011 20.624 24.9262 20.5991 25.0044 20.5741C25.0826 20.5523 25.2014 20.5086 25.2702 20.4805C25.339 20.4524 25.4297 20.415 25.4735 20.3932C25.5172 20.3744 25.6548 20.2902 25.7768 20.2091C25.9019 20.1248 26.0707 19.9938 26.152 19.9096C26.2365 19.8284 26.3522 19.7005 26.4178 19.6225C26.4804 19.5445 26.5867 19.376 26.6586 19.2481C26.7274 19.1202 26.8056 18.9517 26.8338 18.8737C26.8619 18.7957 26.9057 18.6553 26.9307 18.5617C26.9557 18.4681 26.9839 18.2716 26.9964 18.1249C27.0057 17.9783 26.9964 17.7318 26.9776 17.5789C26.9557 17.4261 26.9119 17.2139 26.8775 17.1109C26.8431 17.008 26.7712 16.8333 26.7149 16.7209C26.6618 16.6086 26.5898 16.4776 26.5554 16.4277C26.5179 16.3746 26.4616 16.2997 26.4272 16.2561C26.3928 16.2124 26.2709 16.0813 26.1552 15.9659C26.0395 15.8473 25.855 15.6976 25.7455 15.6289C25.6392 15.5603 25.4797 15.4761 25.3953 15.4418C25.2858 15.3981 25.2295 15.3575 25.2014 15.2951C25.1826 15.2483 25.1576 15.1672 25.1451 15.1142C25.1357 15.0611 25.0669 14.9082 24.9981 14.771C24.9293 14.6337 24.798 14.4215 24.7073 14.303C24.6166 14.1844 24.4884 14.0346 24.4196 13.9754C24.3539 13.913 24.2226 13.8069 24.1288 13.7382C24.035 13.6665 23.8348 13.551 23.6816 13.4824C23.5315 13.4106 23.3126 13.3295 23.1906 13.3046Z"
            fill="url(#paint8_linear_139_6398)"
          />
          <path
            d="M14.294 21.922C14.1501 21.7722 14.025 21.6505 14.0156 21.6505C14.0063 21.6505 13.9312 21.716 13.853 21.7972C13.7717 21.8814 13.6592 22.0499 13.5966 22.1809C13.4872 22.4055 13.484 22.4274 13.484 22.7581C13.4872 23.0857 13.4934 23.1107 13.5935 23.3197C13.656 23.4414 13.7717 23.6036 13.8593 23.6941C13.9469 23.7783 14.1001 23.8938 14.2033 23.9499C14.3127 24.0061 14.4753 24.0591 14.5942 24.0779C14.7067 24.0935 14.86 24.1028 14.9382 24.0935C15.0163 24.0872 15.1477 24.0623 15.2352 24.0373C15.3197 24.0155 15.476 23.9375 15.5792 23.8719C15.6824 23.8033 15.8106 23.6941 15.8638 23.6255C15.9169 23.5599 15.9889 23.4507 16.0264 23.3821C16.0608 23.3135 16.1077 23.198 16.1327 23.1263L16.1734 22.9983C16.0045 22.964 15.8419 22.911 15.7043 22.8611C15.5667 22.808 15.3634 22.7144 15.2509 22.6551C15.1383 22.5959 14.9382 22.4679 14.8006 22.3712C14.6661 22.2745 14.4378 22.0748 14.294 21.922Z"
            fill="url(#paint9_linear_139_6398)"
          />
          <path
            d="M19.4537 12.228C19.3161 12.2093 19.0972 12.2 18.969 12.2C18.8408 12.2031 18.6375 12.2156 18.5156 12.2312C18.3936 12.2468 18.1904 12.2873 18.0622 12.3185C17.9339 12.3497 17.715 12.4215 17.5774 12.4745C17.4399 12.5275 17.2084 12.6399 17.0615 12.7272C16.9145 12.8146 16.6987 12.9612 16.5768 13.0579C16.4173 13.1827 16.3422 13.2264 16.2953 13.2108C16.2609 13.2015 16.1296 13.1734 16.0076 13.1484C15.8825 13.1235 15.6449 13.1016 15.4823 13.1016C15.3197 13.1016 15.082 13.1203 14.96 13.1453C14.835 13.1703 14.6473 13.2202 14.5441 13.2576C14.4409 13.2919 14.2658 13.3731 14.1532 13.4355C14.0407 13.4947 13.8718 13.6071 13.778 13.6788C13.6842 13.7506 13.5372 13.8847 13.4528 13.9783C13.3683 14.0719 13.2339 14.2467 13.1588 14.3652C13.0806 14.4838 12.9774 14.6741 12.9337 14.7864C12.8868 14.8987 12.8305 15.0735 12.8086 15.1764C12.7867 15.2794 12.746 15.3886 12.7179 15.4198C12.6897 15.451 12.6553 15.4728 12.6366 15.4728C12.6178 15.4728 12.4959 15.5352 12.3645 15.6132C12.2301 15.6912 12.0143 15.8566 11.8829 15.9782C11.7516 16.103 11.5827 16.2902 11.5108 16.3932C11.4389 16.4962 11.3388 16.6584 11.2919 16.752C11.245 16.8456 11.17 17.0234 11.1293 17.142C11.0887 17.2606 11.0417 17.479 11.023 17.6256C11.0011 17.7722 10.9948 18.0094 11.0042 18.156C11.0167 18.3026 11.0543 18.5335 11.0887 18.6708C11.1231 18.8081 11.195 19.0109 11.2481 19.1232C11.3013 19.2355 11.3951 19.404 11.4577 19.4976C11.5233 19.5912 11.6515 19.7503 11.7454 19.8501C11.8392 19.9531 12.0018 20.0997 12.105 20.1777C12.2082 20.2557 12.4208 20.3774 12.574 20.4492C12.7273 20.5241 12.9462 20.6052 13.0587 20.6301C13.1713 20.6582 13.3152 20.6894 13.3808 20.6988C13.4903 20.7144 13.5028 20.7269 13.6404 21.0014C13.7186 21.1605 13.8499 21.3821 13.9281 21.4944C14.0094 21.6067 14.1814 21.8095 14.3127 21.9468C14.4441 22.0841 14.663 22.2744 14.7974 22.3711C14.935 22.4678 15.1352 22.5957 15.2477 22.655C15.3603 22.7143 15.5636 22.8079 15.7012 22.8609C15.8388 22.914 16.0983 22.9857 16.2797 23.0232C16.5174 23.0731 16.7206 23.0918 17.0146 23.0918C17.2585 23.0918 17.5337 23.0731 17.7025 23.0419C17.8558 23.0138 18.0747 22.9608 18.1872 22.9264C18.2998 22.889 18.5281 22.7954 18.697 22.7174L19.0034 22.5708L19.5163 22.8266C20.2824 22.8141 20.5451 22.7923 20.7046 22.758C20.8422 22.7299 21.083 22.6645 21.2362 22.6146C21.3894 22.5615 21.6083 22.4711 21.7209 22.4118C21.8335 22.3556 22.0086 22.2496 22.1118 22.184C22.215 22.1154 22.3838 21.9844 22.487 21.8939C22.5934 21.8034 22.7622 21.6318 22.8623 21.5164C22.9655 21.4009 23.1125 21.2106 23.1875 21.0952C23.2626 20.9797 23.3689 20.7894 23.4252 20.6677C23.4815 20.546 23.5471 20.4337 23.569 20.415C23.594 20.3963 23.6847 20.3682 23.7692 20.3557C23.8567 20.3432 24.06 20.2871 24.2226 20.2278C24.3852 20.1685 24.626 20.0531 24.7542 19.9751C24.8824 19.894 25.0888 19.7286 25.2108 19.6069C25.3327 19.4884 25.5079 19.2762 25.5954 19.1389C25.6861 19.0016 25.7987 18.7833 25.8487 18.6553C25.8956 18.5274 25.9582 18.3028 25.9863 18.1561C26.0144 18.0095 26.0363 17.7786 26.0363 17.6413C26.0363 17.5041 26.0082 17.2638 25.9769 17.1109C25.9457 16.9581 25.88 16.7397 25.8362 16.6273C25.7893 16.515 25.6861 16.3185 25.6048 16.1905C25.5266 16.0626 25.3609 15.8567 25.2389 15.735C25.1201 15.6133 24.9356 15.4574 24.8324 15.3887C24.7292 15.3201 24.5572 15.2234 24.4478 15.1734C24.257 15.083 24.2539 15.0798 24.1913 14.8864C24.1569 14.7803 24.085 14.5994 24.0287 14.4808C23.9724 14.3654 23.8473 14.1657 23.7504 14.0378C23.6535 13.9098 23.4909 13.732 23.3908 13.6446C23.2876 13.5573 23.1312 13.4386 23.0437 13.3793C22.953 13.32 22.8873 13.2639 22.8998 13.2483C22.9092 13.2358 22.7622 13.2264 22.5715 13.2264C22.3776 13.2264 22.1118 13.2483 21.9804 13.2732C21.7647 13.3138 21.7303 13.3138 21.674 13.2732C21.6396 13.2451 21.5208 13.1484 21.4082 13.0548C21.2956 12.9612 21.0986 12.8239 20.9704 12.7459C20.8422 12.6679 20.617 12.5556 20.47 12.4932C20.3231 12.4339 20.0917 12.356 19.9541 12.3216C19.8165 12.2873 19.5913 12.2436 19.4537 12.228Z"
            fill="url(#paint10_linear_139_6398)"
          />
          <path
            d="M21.1111 23.1074C21.1799 23.1012 21.1299 23.0949 21.0017 23.0949C20.8734 23.0949 20.8172 23.1012 20.8766 23.1074C20.936 23.1136 21.0423 23.1136 21.1111 23.1074Z"
            fill="url(#paint11_linear_139_6398)"
          />
          <path
            d="M13.5278 24.5301C13.4277 24.4802 13.3371 24.4584 13.2151 24.4584C13.09 24.4584 13.0056 24.4802 12.9024 24.5395C12.8242 24.5832 12.7367 24.6487 12.7054 24.6861C12.6741 24.7236 12.6272 24.8047 12.5991 24.864C12.574 24.9232 12.5522 25.048 12.5553 25.1354C12.5584 25.229 12.5834 25.3538 12.6178 25.4162C12.6491 25.4817 12.7273 25.5816 12.7898 25.6346C12.8524 25.6908 12.9556 25.75 13.0212 25.7688C13.0838 25.7844 13.1713 25.8 13.2151 25.8C13.2589 25.8 13.3496 25.7844 13.4184 25.7656C13.4965 25.7438 13.5997 25.6752 13.6873 25.5847C13.7874 25.488 13.8468 25.3975 13.8718 25.3008C13.8906 25.2228 13.8999 25.1042 13.8906 25.0356C13.8812 24.9669 13.828 24.8421 13.7717 24.7579C13.7061 24.658 13.6185 24.5769 13.5278 24.5301Z"
            fill="url(#paint12_linear_139_6398)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_139_6398"
          x="5.32964"
          y="4.99651"
          width="27.3024"
          height="27.9428"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.0192" result="effect1_foregroundBlur_139_6398" />
        </filter>
        <filter
          id="filter1_i_139_6398"
          x="6.58398"
          y="6.22803"
          width="24.96"
          height="25.5298"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.860689" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.458333 0 0 0 0 0.256743 0 0 0 0 0.0706597 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_139_6398" />
        </filter>
        <filter
          id="filter2_d_139_6398"
          x="10.8886"
          y="12.0886"
          width="16.4454"
          height="14.0455"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.11136" dy="0.11136" />
          <feGaussianBlur stdDeviation="0.11136" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_139_6398" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_139_6398" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_139_6398"
          x1="12.28"
          y1="4.88771"
          x2="26.68"
          y2="33.4957"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DE" />
          <stop offset="1" stopColor="#CFA365" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_139_6398"
          x1="12.152"
          y1="7.25588"
          x2="24.568"
          y2="30.1679"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2A86C" />
          <stop offset="1" stopColor="#F8E6C0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_139_6398"
          x1="13.496"
          y1="6.42388"
          x2="26.872"
          y2="30.4879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E7" />
          <stop offset="1" stopColor="#FFF8EC" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_139_6398"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.064 18.9929) rotate(90) scale(14.489 12.48)"
        >
          <stop stopColor="#FFE4BA" />
          <stop offset="1" stopColor="#DEA44D" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_139_6398"
          x1="19.063"
          y1="3.92993"
          x2="19.063"
          y2="34.0541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_139_6398"
          x1="3.65533"
          y1="6.6555"
          x2="18.7174"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_139_6398"
          x1="33.3489"
          y1="6.65554"
          x2="18.2869"
          y2="32.7438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F2EDED" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_139_6398"
          x1="19.0631"
          y1="24.2997"
          x2="18.9878"
          y2="32.4761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#FFF1E3" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_139_6398"
          x1="14.1019"
          y1="16.0857"
          x2="16.9874"
          y2="23.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_139_6398"
          x1="14.1019"
          y1="16.0857"
          x2="16.9874"
          y2="23.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_139_6398"
          x1="14.1019"
          y1="16.0857"
          x2="16.9874"
          y2="23.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_139_6398"
          x1="14.1019"
          y1="16.0857"
          x2="16.9874"
          y2="23.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_139_6398"
          x1="14.1019"
          y1="16.0857"
          x2="16.9874"
          y2="23.3601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF5DF" />
          <stop offset="1" stopColor="#D2A76B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BronzeMedal = () => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M50.2646 99.7918C66.8913 99.7918 80.3676 86.3155 80.3676 69.6888C80.3676 61.4619 77.0656 54.0111 71.7174 48.5782L42.7045 98.8323C45.121 99.4567 47.654 99.7918 50.2646 99.7918Z"
        fill="#ED8422"
      />
      <path
        d="M42.7044 98.8323L71.7173 48.5783C66.2562 43.029 58.6643 39.5858 50.2646 39.5858C33.6379 39.5858 20.1616 53.0621 20.1616 69.6888C20.1616 83.7014 29.7361 95.4773 42.7009 98.8323H42.7044Z"
        fill="#EDA748"
      />
      <path d="M79.6726 0.21167L62.7108 29.5844L65.9317 35.1584L86.1074 0.21167H79.6726Z" fill="#EDA748" />
      <path d="M53.3444 13.3634L59.7827 24.5114L73.8129 0.21167H60.9398L53.3444 13.3634Z" fill="#ED8422" />
      <path d="M34.0719 35.1584H40.5066L20.3309 0.21167H13.8926L34.0719 35.1584Z" fill="#ED8422" />
      <path d="M46.3663 35.1584H59.2394L39.0637 0.21167H26.1871L46.3663 35.1584Z" fill="#EDA748" />
    </svg>
  );
};

export const SilverMedal = () => {
  return (
    <svg width="102" height="102" viewBox="0 0 102 102" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M51.2699 101.788C68.2291 101.788 81.975 88.0418 81.975 71.0826C81.975 62.6911 78.6069 55.0913 73.1517 49.5498L43.5585 100.809C46.0234 101.446 48.6071 101.788 51.2699 101.788Z"
        fill="#9EA2A2"
      />
      <path
        d="M43.5585 100.809L73.1517 49.5499C67.5814 43.8896 59.8377 40.3776 51.2699 40.3776C34.3107 40.3776 20.5648 54.1234 20.5648 71.0826C20.5648 85.3754 30.3309 97.3869 43.5549 100.809H43.5585Z"
        fill="#C7C9C7"
      />
      <path d="M81.2661 0.215942L63.965 30.1762L67.2504 35.8616L87.8296 0.215942H81.2661Z" fill="#C7C9C7" />
      <path d="M54.4113 13.6307L60.9783 25.0017L75.2891 0.215942H62.1586L54.4113 13.6307Z" fill="#9EA2A2" />
      <path d="M34.7533 35.8616H41.3167L20.7375 0.215942H14.1705L34.7533 35.8616Z" fill="#9EA2A2" />
      <path d="M47.2937 35.8616H60.4242L39.845 0.215942H26.7109L47.2937 35.8616Z" fill="#C7C9C7" />
    </svg>
  );
};

export const GoldMedal = () => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M50.2646 99.7918C66.8913 99.7918 80.3676 86.3155 80.3676 69.6888C80.3676 61.4619 77.0656 54.0111 71.7174 48.5782L42.7045 98.8323C45.121 99.4567 47.654 99.7918 50.2646 99.7918Z"
        fill="#FFB001"
      />
      <path
        d="M42.7045 98.8323L71.7174 48.5783C66.2563 43.029 58.6644 39.5858 50.2646 39.5858C33.6379 39.5858 20.1616 53.0621 20.1616 69.6888C20.1616 83.7014 29.7362 95.4773 42.701 98.8323H42.7045Z"
        fill="#FFD234"
      />
      <path d="M79.6726 0.21167L62.7108 29.5844L65.9317 35.1584L86.1074 0.21167H79.6726Z" fill="#FFD234" />
      <path d="M53.3444 13.3634L59.7827 24.5114L73.8129 0.21167H60.9398L53.3444 13.3634Z" fill="#FFB001" />
      <path d="M34.0718 35.1584H40.5066L20.3309 0.21167H13.8926L34.0718 35.1584Z" fill="#FFB001" />
      <path d="M46.3663 35.1584H59.2394L39.0637 0.21167H26.1871L46.3663 35.1584Z" fill="#FFD234" />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99999 14.167C10.2361 14.167 10.4342 14.087 10.5942 13.927C10.7536 13.7675 10.8333 13.5698 10.8333 13.3337V9.97949C10.8333 9.74338 10.7536 9.54894 10.5942 9.39616C10.4342 9.24338 10.2361 9.16699 9.99999 9.16699C9.76388 9.16699 9.5661 9.24671 9.40666 9.40616C9.24666 9.56616 9.16666 9.76421 9.16666 10.0003V13.3545C9.16666 13.5906 9.24666 13.785 9.40666 13.9378C9.5661 14.0906 9.76388 14.167 9.99999 14.167ZM9.99999 7.50033C10.2361 7.50033 10.4342 7.42033 10.5942 7.26033C10.7536 7.10088 10.8333 6.9031 10.8333 6.66699C10.8333 6.43088 10.7536 6.23283 10.5942 6.07283C10.4342 5.91338 10.2361 5.83366 9.99999 5.83366C9.76388 5.83366 9.5661 5.91338 9.40666 6.07283C9.24666 6.23283 9.16666 6.43088 9.16666 6.66699C9.16666 6.9031 9.24666 7.10088 9.40666 7.26033C9.5661 7.42033 9.76388 7.50033 9.99999 7.50033ZM9.99999 18.3337C8.84721 18.3337 7.76388 18.1148 6.74999 17.677C5.7361 17.2398 4.85416 16.6462 4.10416 15.8962C3.35416 15.1462 2.76055 14.2642 2.32332 13.2503C1.88555 12.2364 1.66666 11.1531 1.66666 10.0003C1.66666 8.84755 1.88555 7.76421 2.32332 6.75033C2.76055 5.73644 3.35416 4.85449 4.10416 4.10449C4.85416 3.35449 5.7361 2.7606 6.74999 2.32283C7.76388 1.8856 8.84721 1.66699 9.99999 1.66699C11.1528 1.66699 12.2361 1.8856 13.25 2.32283C14.2639 2.7606 15.1458 3.35449 15.8958 4.10449C16.6458 4.85449 17.2394 5.73644 17.6767 6.75033C18.1144 7.76421 18.3333 8.84755 18.3333 10.0003C18.3333 11.1531 18.1144 12.2364 17.6767 13.2503C17.2394 14.2642 16.6458 15.1462 15.8958 15.8962C15.1458 16.6462 14.2639 17.2398 13.25 17.677C12.2361 18.1148 11.1528 18.3337 9.99999 18.3337ZM9.99999 16.667C11.8472 16.667 13.4203 16.0178 14.7192 14.7195C16.0175 13.4206 16.6667 11.8475 16.6667 10.0003C16.6667 8.1531 16.0175 6.58005 14.7192 5.28116C13.4203 3.98283 11.8472 3.33366 9.99999 3.33366C8.15277 3.33366 6.57999 3.98283 5.28166 5.28116C3.98277 6.58005 3.33332 8.1531 3.33332 10.0003C3.33332 11.8475 3.98277 13.4206 5.28166 14.7195C6.57999 16.0178 8.15277 16.667 9.99999 16.667Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};

export const Search = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="10.6667"
        cy="10.6667"
        r="6.66667"
        stroke="#979797"
        strokeWidth="2.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20L15.3778 15.3778"
        stroke="#979797"
        strokeWidth="2.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowLeftIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.828 6.778H16V8.778H3.828L9.192 14.142L7.778 15.556L0 7.778L7.778 0L9.192 1.414L3.828 6.778Z"
        fill="#1D2028"
      />
    </svg>
  );
};

export const ArrowRightIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12L20 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 5L20 12L13 19" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const EmissionsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_650_5461)">
        <path
          d="M8.74611 9.61148H5.46632C5.14508 9.61148 4.88083 9.35241 4.88083 9.03117C4.88083 8.70993 5.1399 8.45086 5.46632 8.45086H8.74611C9.10881 8.45086 9.45078 8.31096 9.70984 8.05189C9.96891 7.79283 10.1088 7.45086 10.1088 7.08816C10.1088 6.72547 9.96891 6.3835 9.70984 6.12443C9.19689 5.61148 8.30052 5.61148 7.78756 6.12443C7.55959 6.35241 7.19171 6.35241 6.96373 6.12443C6.73575 5.89645 6.73575 5.52858 6.96373 5.3006C7.94819 4.31614 9.54922 4.31614 10.5337 5.3006C11.0104 5.77728 11.2746 6.40941 11.2746 7.08816C11.2746 7.76692 11.0104 8.39904 10.5337 8.87573C10.057 9.35241 9.41969 9.61666 8.74611 9.61148Z"
          fill="#43B02A"
        />
        <path
          d="M9.78237 15.4405C9.1917 15.4405 8.64248 15.2125 8.22279 14.7928C7.99481 14.5648 7.99481 14.1969 8.22279 13.969C8.45077 13.741 8.81864 13.741 9.04662 13.969C9.4404 14.3576 10.1192 14.3627 10.5129 13.969C10.7098 13.7721 10.8186 13.513 10.8186 13.2384C10.8186 12.9638 10.7098 12.6995 10.5129 12.5078C10.3161 12.3109 10.057 12.2021 9.78237 12.2021H4.17097C3.84973 12.2021 3.58548 11.9431 3.58548 11.6218C3.58548 11.3006 3.84455 11.0415 4.17097 11.0415H9.78237C10.373 11.0415 10.9223 11.2695 11.342 11.6892C11.7565 12.1037 11.9844 12.6581 11.9844 13.2436C11.9844 13.8291 11.7565 14.3835 11.3368 14.798C10.9223 15.2125 10.3679 15.4456 9.78237 15.4405Z"
          fill="#43B02A"
        />
        <path
          d="M14.3109 10.9068H11.943C11.6218 10.9068 11.3575 10.6477 11.3575 10.3265C11.3575 10.0052 11.6166 9.74618 11.943 9.74618H14.3109C14.5596 9.74618 14.7927 9.64774 14.9741 9.47157C15.3368 9.10888 15.3368 8.51302 14.9741 8.15033C14.6218 7.798 14.0052 7.798 13.6529 8.15033C13.4249 8.37831 13.057 8.37831 12.829 8.15033C12.601 7.92235 12.601 7.55447 12.829 7.32649C13.6218 6.53375 15.0052 6.53375 15.7979 7.32649C16.6166 8.14515 16.6166 9.47675 15.7979 10.2954C15.399 10.6944 14.8756 10.912 14.3109 10.9068Z"
          fill="#43B02A"
        />
        <path
          d="M2.6425 17.5856C2.32126 17.5856 2.05701 17.3265 2.05701 17.0052V15.0622C2.05701 14.741 2.31607 14.4819 2.6425 14.4819H4.5855C4.90675 14.4819 5.171 14.741 5.171 15.0622C5.171 15.3835 4.91193 15.6426 4.5855 15.6426H3.22281V17.0052C3.22281 17.3265 2.96374 17.5856 2.6425 17.5856Z"
          fill="#43B02A"
        />
        <path
          d="M1.39897 12.114C1.11918 12.114 0.875657 11.9171 0.823843 11.6321C0.720216 11.057 0.673584 10.5233 0.673584 10C0.673584 4.86011 4.85493 0.673584 10 0.673584C13.0052 0.673584 15.8497 2.13991 17.5959 4.60105C17.7824 4.86529 17.7202 5.22799 17.4611 5.41452C17.1969 5.60105 16.8342 5.53887 16.6477 5.27462C15.114 3.11918 12.6321 1.83421 10 1.83421C5.5026 1.83421 1.83939 5.49742 1.83939 9.99483C1.83939 10.4508 1.88084 10.9171 1.9741 11.4249C2.0311 11.7409 1.81866 12.0466 1.5026 12.0985C1.46633 12.1036 1.43524 12.1088 1.39897 12.1088V12.114Z"
          fill="#43B02A"
        />
        <path
          d="M10 19.3264C6.99483 19.3264 4.15027 17.8601 2.40415 15.3989C2.21763 15.1347 2.2798 14.772 2.53887 14.5855C2.80312 14.3989 3.16581 14.4611 3.35234 14.7254C4.88602 16.8808 7.36788 18.1658 10 18.1658C14.4974 18.1658 18.1606 14.5026 18.1606 10.0052C18.1606 9.54921 18.1192 9.08289 18.0259 8.57511C17.9689 8.25905 18.1814 7.95335 18.4974 7.89636C18.8135 7.84454 19.1192 8.0518 19.171 8.36786C19.2746 8.94299 19.3213 9.47667 19.3213 9.99998C19.3213 15.1399 15.1399 19.3264 10 19.3264Z"
          fill="#43B02A"
        />
        <path
          d="M17.3627 5.5233H15.4197C15.0984 5.5233 14.8342 5.26424 14.8342 4.94299C14.8342 4.62175 15.0933 4.36268 15.4197 4.36268H16.7824V2.99999C16.7824 2.67875 17.0415 2.41968 17.3679 2.41968C17.6943 2.41968 17.9534 2.67875 17.9534 2.99999V4.94299C17.9534 5.26424 17.6943 5.5233 17.3679 5.5233H17.3627Z"
          fill="#43B02A"
        />
      </g>
      <defs>
        <clipPath id="clip0_650_5461">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ElectricityIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.1247 38.6528C17.9796 38.6528 17.8241 38.6217 17.6791 38.5699C17.1817 38.373 16.8915 37.8652 16.964 37.3367L18.6635 25.057H5.91741C5.47181 25.057 5.07803 24.8082 4.87077 24.4145C4.67388 24.0207 4.71533 23.5544 4.98476 23.1917L20.9433 1.81343C21.2646 1.38855 21.8345 1.23311 22.3216 1.43001C22.819 1.6269 23.1091 2.13467 23.0366 2.66317L21.3371 14.943H34.0832C34.5288 14.943 34.9226 15.1917 35.1298 15.5854C35.3267 15.9792 35.2853 16.4455 35.0159 16.8082L19.0469 38.1865C18.819 38.487 18.477 38.6528 18.1143 38.6528H18.1247ZM8.23865 22.7253H20.0003C20.3423 22.7253 20.6532 22.8704 20.8811 23.1191C21.0988 23.3782 21.2024 23.7098 21.1609 24.0414L19.907 33.1606L31.7723 17.2746H20.0107C19.6687 17.2746 19.3578 17.1295 19.1298 16.8808C18.9122 16.6217 18.8086 16.2901 18.85 15.9585L20.1039 6.83933L8.23865 22.7253Z"
        fill="#F1B434"
      />
    </svg>
  );
};

export const WasteIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.829 4.75649C15.5751 4.75649 15.342 4.59068 15.2694 4.33162L14.8394 2.82902C14.6736 2.24871 14.1347 1.84457 13.5337 1.84457H6.47152C5.8653 1.84457 5.33162 2.24871 5.16582 2.82902L4.73576 4.33162C4.64768 4.6425 4.32644 4.81866 4.01556 4.73058C3.70468 4.6425 3.52851 4.32125 3.61659 4.01037L4.04665 2.50778C4.35753 1.43006 5.35234 0.673584 6.4767 0.673584H13.5389C14.658 0.673584 15.658 1.42488 15.9689 2.50778L16.399 4.01555C16.4871 4.32643 16.3057 4.64768 16 4.73576C15.9482 4.7513 15.8912 4.75649 15.8394 4.75649H15.829Z"
        fill="#DA291C"
      />
      <path
        d="M13.1295 19.3264H6.87047C5.59068 19.3264 4.51295 18.3678 4.3627 17.0984L3.18653 7.15537C3.15026 6.83413 3.37824 6.54398 3.69948 6.50771C4.01036 6.46625 4.31088 6.69942 4.34715 7.02066L5.52332 16.9637C5.60622 17.6476 6.18653 18.1657 6.87565 18.1657H13.1347C13.8238 18.1657 14.4041 17.6476 14.487 16.9637L15.6632 7.02066C15.6995 6.69942 16.0052 6.47144 16.3109 6.50771C16.6321 6.54398 16.8601 6.83413 16.8238 7.15537L15.6477 17.0984C15.4974 18.3678 14.4197 19.3264 13.1399 19.3264H13.1295Z"
        fill="#DA291C"
      />
      <path
        d="M10 15.4403C8.60622 15.4403 7.47668 14.3056 7.47668 12.9118C7.47668 11.518 8.6114 10.3833 10 10.3833C11.3886 10.3833 12.5233 11.518 12.5233 12.9118C12.5233 14.3056 11.3886 15.4403 10 15.4403ZM10 11.5543C9.2487 11.5543 8.63731 12.1657 8.63731 12.9118C8.63731 13.6579 9.2487 14.2693 10 14.2693C10.7513 14.2693 11.3627 13.6579 11.3627 12.9118C11.3627 12.1657 10.7513 11.5543 10 11.5543Z"
        fill="#DA291C"
      />
      <path
        d="M16.7979 7.66835H3.20208C2.70467 7.66835 2.23317 7.42483 1.93783 7.02068C1.6425 6.61136 1.56478 6.0984 1.7254 5.62172L2.05182 4.64763C2.26426 4.01032 2.85493 3.58545 3.52851 3.58545H16.4819C17.1503 3.58545 17.7461 4.01032 17.9586 4.64763L18.285 5.61654C18.4456 6.0984 18.3679 6.60617 18.0725 7.0155C17.7824 7.41965 17.3109 7.66317 16.8083 7.66317L16.7979 7.66835ZM3.52332 4.75643C3.35752 4.75643 3.20726 4.86524 3.15545 5.02068L2.82902 5.99478C2.78757 6.11395 2.8083 6.24348 2.88084 6.34711C2.95338 6.45073 3.07255 6.50773 3.1969 6.50773H16.7979C16.9223 6.50773 17.0415 6.45073 17.114 6.34711C17.1865 6.24348 17.2073 6.11913 17.1658 5.99478L16.8394 5.02586C16.7876 4.86524 16.6373 4.76161 16.4715 4.76161H3.52332V4.75643Z"
        fill="#DA291C"
      />
    </svg>
  );
};

export const WaterIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.7433 10.5803C24.7174 5.89638 21.65 1.97928 21.5153 1.81348C21.0179 1.19172 19.9816 1.18135 19.4842 1.81348C19.3599 1.97928 16.2925 5.88602 13.2562 10.5803C9.02827 17.1088 6.89355 21.9793 6.89355 25.0466C6.89355 25.2435 6.89355 25.4404 6.90392 25.6269C7.04899 29.1399 8.53086 32.4145 11.0697 34.8497C13.6189 37.2953 16.9661 38.6425 20.4998 38.6425C24.0335 38.6425 27.4531 37.2643 30.0127 34.7668C32.5619 32.2694 34.0127 28.9326 34.106 25.3679C34.106 25.2643 34.106 25.1503 34.106 25.0466C34.106 21.9689 31.9609 17.1088 27.7433 10.5803ZM31.5153 25.0466V25.3057C31.4428 28.1969 30.2718 30.9016 28.1993 32.9223C26.1267 34.943 23.391 36.0622 20.4998 36.0622C17.6086 36.0622 14.9246 34.9741 12.8625 32.9948C10.8107 31.0156 9.60858 28.3627 9.48423 25.5233C9.48423 25.3679 9.48423 25.2021 9.48423 25.0466C9.48423 23.285 10.5101 19.5855 15.4221 12C17.3702 8.98446 19.3288 6.30052 20.4998 4.74612C21.6708 6.30052 23.6293 8.98446 25.5775 11.9896C30.4894 19.5855 31.5153 23.2746 31.5153 25.0363V25.0466Z"
        fill="#00A9E0"
      />
      <path
        d="M21.1738 31.2539C19.3603 31.2539 17.6504 30.5596 16.3447 29.3057C15.039 28.0518 14.2826 26.3731 14.21 24.5803C14.21 24.4767 14.21 24.3834 14.21 24.2798C14.21 23.6166 13.6712 23.0674 12.9976 23.0674C12.324 23.0674 11.7852 23.6062 11.7852 24.2798C11.7852 24.4145 11.7852 24.5492 11.7852 24.684C11.8888 27.1088 12.9043 29.3679 14.666 31.057C16.4276 32.7461 18.7385 33.6788 21.1738 33.6788C21.837 33.6788 22.3862 33.1399 22.3862 32.4663C22.3862 31.7928 21.8473 31.2539 21.1738 31.2539Z"
        fill="#00A9E0"
      />
    </svg>
  );
};

export const InclusionIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 25 25" fill="#e783e9" xmlns="http://www.w3.org/2000/svg">
      <path d="m10.1 15.9 1.42-1.42C8.79 12.05 7 10.41 7 8.85 7 7.8 7.8 7 8.85 7c1.11 0 1.54.65 2.68 2h.93c1.12-1.31 1.53-2 2.68-2 .87 0 1.55.54 1.77 1.32.35-.04.68-.06 1-.06.36 0 .7.03 1.03.08C18.7 6.43 17.13 5 15.15 5c-.12 0-.23.03-.35.04.12-.33.2-.67.2-1.04 0-1.66-1.34-3-3-3S9 2.34 9 4c0 .37.08.71.2 1.04-.12-.01-.23-.04-.35-.04C6.69 5 5 6.69 5 8.85c0 2.42 2.04 4.31 5.1 7.05" />
      <path d="M22.5 16.24c-.32-.18-.66-.29-1-.35.07-.1.15-.18.21-.28 1.08-1.87.46-4.18-1.41-5.26-2.09-1.21-4.76-.39-8.65.9l.52 1.94c3.47-1.14 5.79-1.88 7.14-1.1.91.53 1.2 1.61.68 2.53-.56.96-1.33 1-3.07 1.32l-.47.81c.58 1.62.97 2.33.39 3.32-.53.91-1.61 1.2-2.53.68-.06-.03-.11-.09-.17-.13-.3.67-.64 1.24-1.03 1.73.07.04.13.09.2.14 1.87 1.08 4.18.46 5.26-1.41.06-.1.09-.21.14-.32.22.27.48.51.8.69 1.43.83 3.27.34 4.1-1.1s.32-3.29-1.11-4.11" />
      <path d="M12.32 14.01c-.74 3.58-1.27 5.95-2.62 6.73-.91.53-2 .24-2.53-.68-.56-.96-.2-1.66.39-3.32l-.46-.81c-1.7-.31-2.5-.33-3.07-1.32-.53-.91-.24-2 .68-2.53.09-.05.19-.08.29-.11-.35-.56-.64-1.17-.82-1.85-.16.07-.32.14-.48.23-1.87 1.08-2.49 3.39-1.41 5.26.06.1.14.18.21.28-.34.06-.68.17-1 .35-1.43.83-1.93 2.66-1.1 4.1s2.66 1.93 4.1 1.1c.32-.18.58-.42.8-.69.05.11.08.22.14.32 1.08 1.87 3.39 2.49 5.26 1.41 2.09-1.21 2.71-3.93 3.55-7.94z" />
    </svg>
  );
};

export const CommunityIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 25 25" fill="#cee9e6" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.27 12h3.46c.93 0 1.63-.83 1.48-1.75l-.3-1.79C14.67 7.04 13.44 6 12 6S9.33 7.04 9.09 8.47l-.3 1.79c-.15.91.55 1.74 1.48 1.74m-8.61-.89c-.13.26-.18.57-.1.88.16.69.76 1.03 1.53 1h1.95c.83 0 1.51-.58 1.51-1.29 0-.14-.03-.27-.07-.4-.01-.03-.01-.05.01-.08.09-.16.14-.34.14-.53 0-.31-.14-.6-.36-.82-.03-.03-.03-.06-.02-.1.07-.2.07-.43.01-.65-.16-.43-.55-.72-.99-.74-.03 0-.05-.01-.07-.03-.17-.21-.48-.35-.83-.35-.3 0-.57.1-.75.26-.03.03-.06.03-.09.02-.14-.06-.3-.09-.46-.09-.65 0-1.18.49-1.24 1.12 0 .02-.01.04-.03.06-.29.26-.46.65-.41 1.05.03.22.12.43.25.6.03.02.03.06.02.09m14.58 2.54c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9C6.68 14.13 6 15.21 6 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74m-15.02.93C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58m21.56 0c-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85M22 11v-.5c0-1.1-.9-2-2-2h-2c-.42 0-.65.48-.39.81l.7.63c-.19.31-.31.67-.31 1.06 0 1.1.9 2 2 2s2-.9 2-2" />
    </svg>
  );
};

export const Bee = () => {
  return (
    <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" clipPath="url(#clip0_650_14626)">
        <path
          d="M21.0897 26.7597C20.9081 26.9412 20.6488 27.0449 20.355 27.0103L11.6685 25.9472C11.1844 25.8953 10.8387 25.4459 10.8992 24.9705C10.9597 24.4951 11.3919 24.1494 11.8759 24.2013L20.5624 25.2644C21.0464 25.3162 21.3922 25.7657 21.3317 26.2411C21.3057 26.4399 21.2107 26.6214 21.081 26.751L21.0897 26.7597Z"
          fill="#F1B434"
        />
        <path
          d="M26.7597 21.0897C26.6214 21.228 26.4485 21.3144 26.2497 21.3403C25.7657 21.3922 25.3249 21.0551 25.273 20.5711L24.2099 11.8846C24.1494 11.4092 24.4951 10.9597 24.9792 10.9079C25.4632 10.856 25.904 11.1931 25.9559 11.6771L27.019 20.3636C27.0536 20.6402 26.9585 20.9082 26.7683 21.0983L26.7597 21.0897Z"
          fill="#F1B434"
        />
        <path
          d="M30.7356 21.7637C30.4676 22.0317 30.0614 22.1094 29.7156 21.9193C28.6612 21.3834 27.4425 21.1673 26.2583 21.3315C25.031 21.5044 23.8641 22.0835 22.9652 22.9651C22.0836 23.8467 21.4959 25.0222 21.3316 26.2582C21.1761 27.4337 21.3835 28.6611 21.9194 29.7155C22.1441 30.1477 21.9799 30.675 21.5391 30.9083C21.1069 31.133 20.571 30.9602 20.355 30.5194C19.6548 29.1624 19.3869 27.5634 19.5857 26.0335C19.8018 24.4172 20.5624 22.896 21.7206 21.7378C22.8788 20.5796 24.4087 19.8276 26.0163 19.6029C27.5548 19.3954 29.1452 19.672 30.5195 20.3721C30.9516 20.5969 31.1159 21.1241 30.9084 21.5563C30.8652 21.6341 30.8047 21.7119 30.7442 21.7724L30.7356 21.7637Z"
          fill="#ED8B00"
        />
        <path
          d="M41.8595 32.3862L32.3778 41.8679C32.0321 42.2137 31.4789 42.2137 31.1332 41.8679C30.7875 41.5222 30.7875 40.969 31.1332 40.6233L40.6149 31.1416C40.9606 30.7959 41.5138 30.7959 41.8595 31.1416C42.2052 31.4873 42.2052 32.0405 41.8595 32.3862Z"
          fill="#ED8B00"
        />
        <path
          d="M44.7982 35.3249L35.3165 44.8066C34.9708 45.1524 34.4176 45.1524 34.0719 44.8066C33.7262 44.4609 33.7262 43.9077 34.0719 43.562L43.5536 34.0803C43.8993 33.7346 44.4525 33.7346 44.7982 34.0803C45.144 34.426 45.144 34.9792 44.7982 35.3249Z"
          fill="#ED8B00"
        />
        <path
          d="M47.2096 38.8084L38.8084 47.2097C38.4626 47.5555 37.9095 47.5555 37.5637 47.2097C37.218 46.864 37.218 46.3108 37.5637 45.9651L45.965 37.5638C46.3107 37.2181 46.8639 37.2181 47.2096 37.5638C47.5554 37.9095 47.5554 38.4627 47.2096 38.8084Z"
          fill="#ED8B00"
        />
        <path
          d="M45.5416 45.5414C42.5855 48.4801 37.7885 48.4715 34.8498 45.5328L31.1332 41.8162C30.7874 41.4704 30.7875 40.9173 31.1332 40.5715C31.4789 40.2258 32.0321 40.2258 32.3778 40.5715L36.0944 44.2881C38.3503 46.544 42.0237 46.5527 44.2969 44.2968C46.5528 42.0409 46.5355 38.3588 44.2796 36.1029L40.563 32.3863C40.2173 32.0406 40.2173 31.4874 40.563 31.1417C40.9088 30.796 41.4619 30.796 41.8077 31.1417L45.5243 34.8583C48.463 37.797 48.4716 42.5941 45.5416 45.5414Z"
          fill="#F1B434"
        />
        <path
          d="M48.921 48.921C48.5753 49.2668 48.0221 49.2668 47.6764 48.921L44.2969 45.5415C43.9511 45.1958 43.9511 44.6426 44.2969 44.2969C44.6426 43.9511 45.1958 43.9511 45.5415 44.2969L48.921 47.6764C49.2668 48.0221 49.2668 48.5753 48.921 48.921Z"
          fill="#F1B434"
        />
        <path
          d="M46.5442 27.7017L41.8595 32.3863C41.678 32.5678 41.436 32.6543 41.1767 32.637L32.0148 32.0147L32.6371 41.1766C32.6544 41.4359 32.5679 41.6779 32.3864 41.8594L27.7018 46.5441C24.3568 49.889 18.9202 49.8804 15.5839 46.5441C12.2475 43.2077 12.2475 37.7625 15.5839 34.4262L20.5192 29.4908C20.7093 29.3007 20.9686 29.2142 21.2279 29.2315L30.0787 30.0786L29.2403 21.2192C29.2143 20.9513 29.3094 20.7006 29.4996 20.5104L34.4349 15.5751C37.7798 12.2302 43.2078 12.2302 46.5528 15.5751C49.8978 18.9201 49.8891 24.3567 46.5528 27.693L46.5442 27.7017ZM40.9001 30.8565L45.2995 26.457C47.953 23.8035 47.953 19.4819 45.2995 16.8284C42.646 14.1749 38.3244 14.1749 35.6709 16.8284L31.0294 21.4698L31.8592 30.2514L40.9001 30.8565ZM16.8198 35.6621C14.1664 38.3156 14.1664 42.6373 16.8198 45.2908C19.4733 47.9443 23.795 47.9443 26.4485 45.2908L30.8479 40.8913L30.2429 31.8505L21.4613 31.0207L16.8198 35.6621Z"
          fill="#F1B434"
        />
      </g>
      <defs>
        <clipPath id="clip0_650_14626">
          <rect width="47.1826" height="47.1826" fill="white" transform="translate(0 33.363) rotate(-45)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Bird = () => {
  return (
    <svg width="143" height="157" viewBox="0 0 143 157" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M89.4041 127.544C91.1658 127.544 92.5751 126.135 92.5751 124.373C92.5751 121.026 95.3057 118.295 98.6528 118.295H135.736C155.114 118.295 162.821 102.837 164.231 94.6892C164.407 93.7643 164.142 92.8395 163.526 92.0908C162.909 91.3861 162.161 90.9016 161.104 90.9897C153.749 91.1218 133.225 90.6814 126.311 87.9509C120.277 85.5726 97.1995 65.8421 82.4016 52.4975C82.5777 49.5908 82.3135 46.684 81.6528 43.7773C79.1425 33.0752 70.6425 24.5752 59.8964 22.1089C50.8679 20.039 41.6632 22.1089 34.5725 27.7462C28.3186 32.7229 24.443 39.8576 23.6062 47.6529H8.94041C8.05958 47.6529 7.26684 48.0053 6.65026 48.6219C6.03367 49.2384 5.72538 50.0752 5.76942 50.956C5.94558 55.6685 8.8083 64.5649 18.4093 64.5649C20.171 64.5649 21.5803 63.1555 21.5803 61.3939C21.5803 59.6322 20.171 58.2229 18.4093 58.2229C15.1062 58.2229 13.5648 56.0208 12.8161 53.9949H26.6451C28.4067 53.9949 29.8161 52.5856 29.8161 50.8239C29.8161 43.7333 32.987 37.127 38.5803 32.6789C44.1295 28.2307 51.3964 26.6452 58.5311 28.2747C66.7668 30.1685 73.5933 36.9509 75.5311 45.1866C76.1917 47.9612 76.3238 50.7358 76.0596 53.4224C75.9275 54.4353 76.3238 55.4483 77.0725 56.1089C80.9041 59.5882 114.816 90.1529 124.109 93.8084C131.42 96.6711 148.904 97.1996 157.052 97.2877C155.026 102.661 149.521 111.953 135.912 111.953H98.829C91.9585 111.953 86.4093 117.547 86.4093 124.373C86.4093 126.135 87.8186 127.544 89.5803 127.544H89.4041Z"
          fill="#00A9E0"
        />
        <path
          d="M86.9819 148.728C87.4223 148.728 87.8187 148.64 88.2591 148.464C89.8446 147.759 90.5933 145.909 89.8886 144.28L80.9482 123.844C80.5959 123.052 79.9352 122.435 79.1425 122.127C78.3497 121.819 77.4249 121.863 76.6762 122.259C66.1503 127.368 50.5596 123.756 38.8005 113.451C31.4896 107.021 26.4689 98.917 24.6632 90.6372C22.9456 82.6657 24.443 75.531 28.8471 70.5103C29.9482 69.2331 31.2254 68.132 32.6347 67.2072C34.0881 66.2382 34.4845 64.2564 33.5596 62.803C32.5907 61.3496 30.6088 60.9533 29.1554 61.8781C27.2617 63.1113 25.544 64.6087 24.0907 66.2823C18.3212 72.8445 16.3394 81.961 18.4974 91.9144C20.5673 101.515 26.2927 110.852 34.6606 118.163C47.4326 129.394 63.772 133.578 76.4119 129.173L84.1192 146.746C84.6477 147.935 85.7927 148.64 87.0259 148.64L86.9819 148.728Z"
          fill="#00A9E0"
        />
        <path
          d="M106.272 104.687C107.769 104.687 108.738 104.643 108.959 104.643C110.72 104.554 112.041 103.057 111.953 101.295C111.865 99.5337 110.456 98.0803 108.606 98.3005C108.21 98.3005 71.4352 100.062 61.3057 75.8834C60.6451 74.2539 58.7953 73.5052 57.1658 74.1658C55.5363 74.8264 54.7876 76.7202 55.4482 78.3057C65.7098 102.749 96.8031 104.643 106.272 104.643V104.687Z"
          fill="#004C97"
        />
        <path
          d="M63.3757 145.777C63.772 145.777 64.1684 145.689 64.5648 145.557C66.1943 144.896 66.987 143.047 66.3264 141.417L59.9404 125.474C59.2798 123.845 57.4301 123.052 55.8005 123.713C54.171 124.373 53.3782 126.223 54.0389 127.852L60.4249 143.795C60.9093 145.029 62.0985 145.777 63.3757 145.777Z"
          fill="#00A9E0"
        />
        <path
          d="M40.7824 49.6787C41.2228 49.6787 41.6632 49.3704 41.7953 48.93C42.2357 47.5647 43.1166 46.3315 44.2617 45.4507C45.4508 44.5258 46.9482 44.0414 48.4896 44.0414C49.987 44.0414 51.5285 44.5699 52.7176 45.4507C53.8627 46.3315 54.7435 47.5647 55.1839 48.93C55.3601 49.5025 55.9767 49.8108 56.5052 49.6347C57.0777 49.4585 57.386 48.8419 57.2098 48.3134C56.6373 46.5517 55.4922 44.9222 54.0389 43.8212C52.4534 42.6321 50.5155 41.9714 48.5337 41.9714C46.5518 41.9714 44.5699 42.6321 43.0285 43.8212C41.5311 44.9663 40.386 46.5517 39.8135 48.3574C39.6373 48.93 39.9456 49.5025 40.5181 49.6787C40.6062 49.6787 40.7383 49.7227 40.8264 49.7227L40.7824 49.6787Z"
          fill="#004C97"
        />
        <path
          d="M40.7824 50.9119C41.7953 50.9119 42.6762 50.2512 42.9844 49.3264C43.3368 48.1813 44.0855 47.1683 45.0104 46.4637C45.9793 45.715 47.2565 45.3186 48.4896 45.3186C49.7228 45.3186 50.956 45.759 51.9689 46.5077C52.8938 47.2124 53.6425 48.2694 53.9948 49.3704C54.3912 50.5595 55.6684 51.2201 56.8575 50.8678C57.43 50.6917 57.9145 50.2953 58.2228 49.7227C58.5311 49.1502 58.5311 48.5777 58.3549 47.9611C57.6943 45.9792 56.4171 44.1295 54.7435 42.8523C52.9378 41.487 50.7357 40.7383 48.4896 40.7383C46.2435 40.7383 43.9974 41.487 42.2357 42.8523C40.5181 44.1295 39.2409 45.9792 38.6243 47.9611C38.4482 48.5336 38.4922 49.1502 38.7565 49.7227C39.0207 50.2953 39.5052 50.6917 40.0777 50.8678C40.2979 50.9559 40.5181 50.9559 40.7824 50.9559V50.9119Z"
          fill="#004C97"
        />
      </g>
    </svg>
  );
};
